const sv = {
  language: 'sv',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Stäng',
    resize: 'Ändra panelens bredd',
    move: 'Dra eller använd piltangenterna för att flytta',
    send: 'Skicka',
    stop: 'Stoppa',
    placeholder: 'Fråga om hur Glow fungerar…',
    empty: 'Fråga vad som helst om hur Glow fungerar.',
    disclaimer: 'Svaren genereras av AI och kan vara felaktiga. Assistenten har inte tillgång till dina sändningsdata.',
    error: 'Något gick fel när svaret skulle genereras.',
    retry: 'Försök igen',
    helpful: 'Hjälpsam',
    notHelpful: 'Inte hjälpsam',
    commentLabel: 'Lägg till en kommentar',
    commentOptional: 'valfritt',
    commentPlaceholder: 'Vad var bra eller dåligt med svaret?',
    feedbackThanks: 'Tack för din feedback.',
    beta: 'Beta',
    thinking: 'Tänker…',
    tools: {
      glossary: {
        running: 'Slår upp {{detail}} i ordlistan…',
        used: 'Slog upp {{detail}} i ordlistan'
      },
      fallback: {
        running: 'Hämtar information…',
        used: 'Hämtade information'
      }
    },
    newChat: 'Ny konversation',
    language: 'Svarsspråk',
    copyAnswer: 'Kopiera svaret',
    sources: 'Källor',
    sourceUpdated: 'Uppdaterad {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Kundportalen', tracking: 'Spårning' },
    copied: 'Kopierat',
    history: {
      open: 'Konversationshistorik',
      back: 'Tillbaka till konversationen',
      empty: 'Inga tidigare konversationer.',
      error: 'Det gick inte att läsa in dina konversationer.',
      loadError: 'Det gick inte att läsa in konversationen.',
      delete: 'Radera konversationen ”{{title}}”',
      deleteConfirm: 'Radera konversationen ”{{title}}”?',
      deleteYes: 'Radera',
      deleteCancel: 'Avbryt',
      deleteError: 'Det gick inte att radera konversationen.'
    },
    suggestions: {
      dispatch: 'Hur tilldelar jag försändelser till en rutt?',
      statuses: 'Vad betyder de olika försändelsestatusarna?',
      recurring: 'Hur skapar jag en återkommande rutt?',
      deviation: 'Vad innebär det att en försändelse har en avvikelse?'
    }
  },
  emptyStates: { notFoundTitle: 'Inget resultat' },
  welcomeToGlowWithName: 'Välkommen till Glow, {{name}}!',
  welcomeToGlowDescription: 'Använd navigeringen till vänster för att börja ditt arbete!',
  glowGlobeImage: 'Glow globusbild',
  latestUpdatesHere: 'Här är de senaste uppdateringarna',
  userRoles: {
    admin: 'Admin',
    planner: 'Normal',
    read_only_planner: 'Läsbehörighet',
    plus_planner: 'Plus',
    partner: 'Partner',
    customer: 'Kund',
    customs_agent: 'Tullagent',
    support: 'Support',
    handler: 'Terminalarbetare'
  },
  application: {
    requiredLocation: 'Platstjänster är obligatoriskt',
    filter: 'Filter',
    reset: 'Återställ',
    cluster: 'Kluster',
    assigned: 'Tilldelad',
    created: 'Skapad',
    selected: 'Vald',
    all: 'Alla',
    save: 'Spara',
    lastUpdated: 'Senast uppdaterad',
    update: 'Uppdatera',
    required: '*Obligatoriskt fält',
    requiredShort: '*Obligatoriskt',
    endsNextDay: 'slutar nästa dag',
    search: 'Sök',
    logOut: 'Logga ut',
    courier: 'Chaufför',
    drivers: 'Chaufförer',
    consignments: 'Sändningar',
    status: 'Status',
    move: 'Flytta',
    address: 'Adress',
    estimatedDepartureTime: 'ETD',
    adjusted: 'Justerad',
    actual: 'Faktisk',
    tracking: 'Spårning',
    trackingPage: 'Spårningssida för mottagare',
    phoneNumberShort: 'Telefon',
    allSelected: 'Alla valda',
    someSelected: '{{count}} valda',
    noneSelected: 'Inga valda',
    appBuild: 'App-version',
    lastLogin: 'Senaste inloggning',
    device: 'Enhet',
    model: 'Modell',
    os: 'OS',
    units: 'Enheter',
    yes: 'Ja',
    no: 'Nej',
    notSelected: 'Inte vald',
    sms: 'SMS',
    httpErrorToString: 'HTTP-fel: kod {{status}} {{statusText}}',
    anErrorOccurred: 'Ett fel inträffade!',
    noAccessTitle: 'Ingen åtkomst',
    noAccessMessage: 'Du har inte rätt att använda denna funktion',
    autoComplete: 'Sök plats ...',
    autoCompleteWithoutDots: 'Sök plats',
    totalWeight: 'Total vikt',
    totalVolume: 'Total volym',
    validDeviationCode: 'Vänligen ange ett giltigt värde',
    columns: 'Kolumner',
    title: {
      siteName: 'GLOW',
      root: 'Välkommen',
      planner: 'Trafikplanering',
      admin: 'Administration',
      settings: 'Inställningar',
      plannerLive: 'Trafikplanering - Live',
      plannerLiveSlot: 'Trafikplanering - Live - Rutt',
      plannerCouriers: 'Trafikplanering - Chaufförer',
      templateRouteRules: 'Trafikplanering - Hantera ruttregler',
      plannerUnits: 'Trafikplanering - Enheter',
      plannerImport: 'Trafikplanering - Importer',
      plannerUnresolved: 'Trafikplanering - Obekräftade',
      plannerCoordinates: 'Trafikplanering - Ange koordinater',
      plannerConsignments: 'Trafikplanering - Sändningar',
      plannerSearch: 'Trafikplanering - Sök',
      plannerPlanning: 'Trafikplanering - Planering',
      waybills: 'Trafikplanering - Fraktsedlar',
      deliveryNotes: 'Trafikplanering - Följesedlar',
      plannerInvoicing: 'Trafikplanering - Fakturering',
      plannerCreateBillingOrder: 'Trafikplanering - Skapa faktureringsorder',
      plannerEditBillingOrder: 'Trafikplanering - Redigera faktureringsorder',
      plannerCreateCreditNote: 'Trafikplanering - Skapa kreditnota',
      plannerCopyToBillingOrder: 'Trafikplanering - Skapa kopia till faktureringsorder',
      plannerVehicle: 'Trafikplanering - Vehicles',
      report: 'Rapporter',
      customerDepartmentLive: 'Live-vy',
      recipient: 'Spårning - Bring',
      instant: 'Instant',
      instantBooking: 'Bokning',
      h2Booking: 'H2 Bokning',
      orderConfirmation: 'Orderbekräftelse',
      customerPortal: 'Kundportal',
      financial: 'Finansiella rättigheter',
      readAny: 'Läsrättigheter',
      instantMap: 'Karta',
      instantMap2: '$t(application.title.instantMap)',
      recurringOrder: 'Återkommande uppdrag',
      corrections: 'Korrigeringar',
      jobs: 'Jobbövervakning',
      holidays: 'Högtider',
      shipmentLabels: 'Fraktsedlar',
      addresses: 'Adresser',
      shd: 'SHD',
      preadvice: 'Avisering',
      apollo: 'Apollo',
      routeReceiptList: 'Kvittenslista',
      routesOverview: 'Ruttöversikt',
      loadList: 'Lastlista',
      pickupOrders: 'Upphämtningsordrar',
      customerBooking: 'Kundbokning',
      manageReturns: 'Hantera returer',
      preAdviceFollowup: 'Hantera föravisering',
      integrations: '$t(apolloAdmin.title)',
      parcelHub: '$t(parcelHubAdmin.title)',
      recurring: 'Trafikplanering - Återkommande'
    },
    language: { en: 'Engelska', nb: 'Norska', sv: 'Svenska', dk: 'Danska', fi: 'Finska', fr: 'Franska' },
    country: {
      AllCountry: 'Alla länder',
      Country: 'Land',
      AD: 'Andorra',
      AT: 'Österrike',
      BE: 'Belgien',
      BA: 'Bosnien och Hercegovina',
      BG: 'Bulgarien',
      HR: 'Kroatien',
      CZ: 'Tjeckien',
      DK: 'Danmark',
      GB: 'Storbritannien',
      EE: 'Estland',
      FO: 'Färöarna',
      FI: 'Finland',
      FR: 'Frankrike',
      DE: 'Tyskland',
      GI: 'Gibraltar',
      GR: 'Grekland',
      HU: 'Ungern',
      IS: 'Island',
      IE: 'Irland',
      IT: 'Italien',
      LV: 'Lettland',
      LT: 'Litauen',
      LU: 'Luxemburg',
      MK: 'Nordmakedonien',
      MT: 'Malta',
      MC: 'Monaco',
      ME: 'Montenegro',
      NL: 'Nederländerna',
      NO: 'Norge',
      PL: 'Polen',
      PT: 'Portugal',
      RO: 'Rumänien',
      RU: 'Ryssland',
      SM: 'San Marino',
      RS: 'Serbien',
      SK: 'Slovakien',
      SI: 'Slovenien',
      ES: 'Spanien',
      SE: 'Sverige',
      CH: 'Schweiz',
      UA: 'Ukraina'
    },
    timeDistance: 'Planerad tid och distans',
    driverReturnToAddress: 'Ange ingen returadress',
    distance: 'Distans',
    helpLink: '(Vad är detta?)',
    none: 'Ingen',
    noOptions: 'Inga alternativ',
    groups: 'Grupper',
    departments: 'Avdelningar',
    selectAll: 'Välj alla',
    totalCustomerPrice: 'Totalt kundpris',
    totalUnitPrice: 'Totalt enhetspris',
    notFound: 'Hittades inte'
  },
  serviceLevel: {
    label: 'Nedgradera servicenivå',
    ingress:
      'Ange en standard-e-postadress som kan ta emot en avisering vid orderregistrering, upphämtning och/eller leverans.',
    notSet: 'Inte valt',
    none: 'Av',
    standard: 'Standard',
    premium: 'Premium'
  },
  dropdown: {
    nrSelected: '{{count}} vald',
    nrSelected_other: '{{count}} valda',
    selectedCustomers: '{{count}} kund',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alla kunder',
    filterCustomers: 'Filtrera kunder',
    selectedDepartments: '{{count}} avdelning',
    selectedDepartments_other: '{{count}} avdelningar',
    allDepartments: 'Alla avdelningar',
    filterDepartments: 'Filtrera avdelningar',
    selectedServiceCodes: '{{count}} tjänst',
    selectedServiceCodes_other: '{{count}} tjänster',
    allServiceCodes: 'Alla tjänster',
    filterServiceCodes: 'Filtrera tjänster',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: 'Alla VAS:er',
    filterVasCodes: 'Filtrera VAS:er',
    selectedDestinations: '{{count}} destination',
    selectedDestinations_other: '{{count}} destinationer',
    filterSelfBillingUnitIds: 'Filtrera självfaktureringsenhets-id',
    allSelfBillingUnitIds: 'Alla självfaktureringsenhets-id',
    selectedSelfBillingUnitIds: '{{count}} självfaktureringsenhets-id',
    selectedSelfBillingUnitIds_other: '{{count}} självfaktureringsenhets-id'
  },
  button: {
    actions: 'Åtgärder',
    edit: 'Ändra',
    back: 'Tillbaka',
    cancel: 'Ångra',
    confirm: 'Bekräfta',
    done: 'Klar',
    clear: 'Rensa',
    clearAll: 'Rensa alla',
    selectAll: 'Välj alla',
    close: 'Stäng',
    save: 'Spara',
    saveAndPublish: 'Spara och publicera',
    delete: 'Ta bort',
    export: 'Exportera',
    new: 'Skapa ny',
    search: 'Sök',
    add: 'Lägg till',
    remove: 'Ta bort',
    assign: 'Tilldela',
    fullEdit: 'Full redigering',
    continue: 'Fortsätt',
    copy: 'Kopiera',
    continueAndSave: 'Fortsätt och spara',
    triggerRollout: 'Utlös utrullning',
    triggerRolloutAgain: 'Rulla ut igen'
  },
  consignment: {
    packageType: 'Kollityp',
    palletFootprints: 'Pallplats',
    loadingMeters: 'Flakmeter',
    includePreAdvice: 'Preavisering',
    onlyFailedPreAdvice: 'Avisering misslyckats',
    onlyReturnPreAdvice: 'Retur till avsänder',
    search: 'Sök efter sändningar',
    noShipmentsFound: 'Hittade inga sändningar',
    clickButtonToSearch: 'Klicka på sök-knappen för att utföra ett sök',
    consignmentsForDate: 'Sändningar {{date}}',
    showOnlyEditable: 'Bara ändringsbara',
    showOnlyNotAssigned: 'Ej tilldelad',
    withoutDate: 'Utan datum',
    extendedSearch: 'Utökad sökning',
    showDeleted: 'Visa borttagna',
    showDeviated: 'Visa avvik',
    deletedBy: 'Raderad av',
    deletionReason: 'Orsak',
    numberOfConsignments: 'Hittade {{number}} sändningar',
    showAll: 'Alla',
    delivery: 'Leverans',
    pickup: 'Upphämtning',
    pickups: '{{count}} upphämtning',
    pickups_other: '{{count}} upphämtningar',
    edit: 'Ändra',
    deleteOrders: 'Radera',
    duplicateOrder: 'Duplicera',
    duplicateConfirmation: 'Är du säker på att du vill duplicera denna order?',
    orderDuplicated: 'Ordern har duplicerats',
    orderDuplicatedFailed: 'Det gick inte att duplicera ordern',
    copyOrder: 'Kopiera',
    editOrder: 'Ändra',
    cantDeleteOfferedOrders: 'Du kan bara radera kommande ordrar som ännu inte har lagts till på en rutt',
    cantEditOfferedOrders: 'Du kan bara redigera kommande ordrar som ännu inte har lagts till på en rutt',
    onlyCopyOne: 'Du kan bara kopiera en order åt gången',
    onlyEditOne: 'Du kan bara redigera en order åt gången',
    preplan: 'Förplanera',
    deletedOrderNotCopyable: 'Den borttagna ordern kan inte kopieras eftersom det saknas orderdetaljer i Glow',
    restoreOrder: 'Återställ',
    deletedOrderNotRestorable: 'Raderad order kan inte återställas eftersom det saknas orderdetaljer i Glow',
    deleteConfirmation: 'Är du säker på att du vill radera den här sändningen?',
    deleteMultipleConfirmation: 'Är du säker på att du radera de valda sändningarna?',
    copyConfirmation: 'Är du säker på att du vill kopiera den här sändninge?',
    editConsignment: 'Ändra sändningsinformation',
    changeDateAndTime: 'Ändra datum och tid',
    searchShipments: 'Sök bland sändningar:',
    searchCustomers: 'Sök bland kunder:',
    excelExportRemoved:
      'Det kommer inte längre att vara möjligt att Exportera till Excel från denna sida. Använd istället <0>Import / Export</0> eller <0>SAGA</0>. Detta är en del av en större uppdatering där fler funktioner kommer att tas bort innan sidan slutligen stängs ner. Allt arbete ska göras på <1>den här sidan</1>.',
    filterBy: 'Filtrera på:',
    limitedShipmentsShownMessage: 'Visar ett maximalt antal av {{count}} sändningar, överväg att begränsa din sökning',
    limitedUnresolvedAddressesShownMessage: 'Ett maximum av {{count}} olösta adresser visas',
    bulkActions: 'Ändra sändningar',
    bulkActionsMultiple: 'Ändra sändningar ({{count}})',
    addToRecurringGroup: 'Lägg till återkommande uppdrag',
    moveShipmentsToDifferentDepartment: 'Flytta till en annan avdelning',
    addEvents: 'Lägg till händelser',
    disabledEditDeleteHelperText:
      'Den här ordern kan inte ändras eller tas bort. Kontakta ditt lokala Bring-kontor för att göra ändringar i ordern.',
    editPickupConsignment: 'Ändra upphämtningsinformation',
    editDeliveryConsignment: 'Ändra leveransinformation',
    editPickupAndDeliveryTime: 'Uppdatera upphämtning och leveranstider',
    editConsignmentLocation: ' Plats',
    editConsignmentTime: ' Tid',
    editConsignmentName: ' Namn',
    editConsignmentPhone: ' Telefon',
    editConsignmentInstructions: ' Instruktioner',
    earliestPickupTime: 'Tidigaste upphämtningstid *',
    latestPickupTime: 'Senaste upphämtningstid *',
    earliestDeliveryTime: 'Tidigaste leveranstid',
    latestDeliveryTime: 'Senaste leveranstid',
    enterPickupInstructions: 'Fyll i upphämtningsinstruktioner',
    enterDeliveryInstructions: 'Fyll i leveransinstruktioner',
    enterDeliveryName: 'Fyll i namn till mottagare',
    enterPickupName: 'Fyll i namn till avsändare',
    enterPickupPhone: 'Fyll i telefonnummer till avsändare',
    enterDeliveryPhone: 'Fyll i telefonnummer till mottagare',
    specificationSize: 'Antal',
    enterSpecificationSize: 'Fyll i antal',
    editSpecificationSize: 'Ändra antal',
    enterSpecificationDescription: 'Fyll i beskrivning',
    editSpecificationDescription: 'Ändra beskrivning',
    editPickupInfoDescription: 'För att ändra information så måste du välja någon av alternativen ovan.',
    updateLocationFor: 'Uppdatera information för {{count}} sändning',
    updateLocationFor_other: 'Uppdatera information för {{count}} sändningar',
    comment: 'Kommentar',
    show: 'Visa',
    filter: 'Filtrera sändningar',
    state: 'Status',
    estimatedDelivery: 'Beräknad leveranstid',
    requestedTimePickup: 'Upphämtningstid',
    requestedTimeDelivery: 'Leveranstid',
    timeNotSet: 'Inte bestämt',
    customerReference: 'Kundreferens',
    shipmentId: 'Sändningsnummer',
    packageId: 'Kollinummer',
    noCourier: 'Ingen chaufför',
    noSlot: 'Ingen rutt',
    showEvents: 'Visa händelser →',
    hideEvents: 'Dölj händelser ←',
    events: 'Händelser',
    send: 'Visa',
    sendMessage: 'Skicka meddelande',
    sendCommentFailed: 'Misslyckades med att spara kommentar',
    recipient: 'Mottagare',
    unresolved: 'Obekräftade sändningar',
    description: 'Beskrivning',
    pickupAddress: 'Upphämtningsadress',
    numberOfPackages: 'Antal paket',
    registeredPickupAddress: 'Registrerad upphämtningsadress',
    pickupZipCode: 'Postnummer',
    pickupZipArea: 'Stad',
    deliveryAddress: 'Leveransadress',
    deliveryZipCode: 'Postnummer',
    deliveryZipArea: 'Stad',
    deliveryLocation: 'Plats',
    registeredDeliveryAddress: 'Registrerad leveransadress',
    updated: 'Sändningen har uppdaterats',
    moved: 'Sändningen har flyttats',
    unresolvedMessage: 'Det finns {{count}} sändning där vi inte kan hitta adressen, lägg till den.',
    unresolvedMessage_other: 'Det finns {{count}} sändningar där vi inte kan hitta en adress.',
    foundUnresolvedMessage:
      'Vi har hittat de här giltiga adresserna för den här sändningen. Om de är korrekta, tryck på Uppdatera. Om de inte är korrekta, hitta den giltiga adressen med kartan nedan.',
    remove: 'Ta bort',
    optimizingNewSlot: 'Optimera sändningar i ny rutt',
    slotSelect: 'Välj rutt',
    pickupInstructions: 'Upphämtningsinstruktioner',
    deliveryInstructions: 'Leveransinstruktioner',
    specificationDescription: 'Beskrivning',
    tracking: 'Spårning',
    recipientPhone: 'Mottagarens telefonnummer',
    customerRef: 'Kundreferens',
    service: 'Tjänst',
    message: {
      CREATED: 'Skapad',
      ASSIGNED: 'Tilldelad rutt',
      UNASSIGNED: 'Ej tilldelad rutt',
      COLLECTED: 'Upphämtad',
      DELIVERED: 'Levererad',
      DEVIATED: 'Avvik',
      COMMENT: 'Kommentar',
      RESOLVED: 'Bekräftad',
      UNRESOLVED: 'Obekräftad',
      OFFERED: 'Erbjuden',
      REJECTED: 'Nekad',
      ACCEPTED: 'Accepterad',
      RETURNED: 'Returnerad',
      DELETED: 'Borttagen',
      UNCONFIRMED: 'Obekräftad',
      REFUSED: 'Avvisad'
    },
    adjustTabTitle: 'Editera',
    bookingPanelTitle: 'Bokning',
    mapPanelTitle: 'Karta',
    recipientName: 'Mottagarens namn',
    receivedBy: 'Mottaget av:',
    manuallyChangeLocations: 'Ändra plats manuellt',
    manualOverrideDeviationTimeConfirm: 'Bekräfta manuell avvikelse för vald sändning',
    manualOverrideDeliveryTimeConfirm: 'Bekräfta manuell leverans för vald sändning',
    onManuallyChangeLocationsConfirm: 'Är du säker på att du vill göra sändningen obekräftad?',
    unresolveDeliveryAddress: 'Gör leveransadressen obekräftad',
    unresolvePickupAddress: 'Gör upphämtningsadressen obekräftad',
    unresolveAddress: 'Ta bort adressbekräftelse',
    reference: 'Referens',
    shipmentIdNumber: 'Nummer',
    shipmentDetails: 'Sändningsdetaljer',
    customer: 'Kund',
    subcustomer: 'Kundnummer',
    dateAndTime: 'Datum och tid',
    filterCustomer: 'Filtrera kund',
    searchShipmentDateError: 'Fyll i ett datumintervall under 120 dagar.',
    searchPhraseLength: 'Sökfraser bör vara minst {{minLength}} tecken för utökad sökning.',
    moveOrder: 'Flytta sändning',
    moveOrderTitle: 'Flytta sändning till en annan avdelning',
    moveOrderDefault: 'Välj avdelning',
    label: 'Fraktsedel',
    createLabel: 'Skapa fraktsedel',
    createDeliveryLabel: 'Skapa fraktetikett',
    createLabelShipment: 'Skapa fraktsedel (Sändning)',
    createMultipleLabel: 'Skapa fraktsedel ({{count}})',
    viewLabel: 'Visa fraktsedel',
    viewLabels: 'Visa fraktsedlar',
    generateLabelError: 'Fel: {{error}}',
    generateLabelErrorTitle: 'Något gick fel',
    generateLabelErrorDescription: 'Beklagar, vi kan inte generera fraktsedlar för tillfället',
    generateLabelErrorButton: 'Se felkod',
    generatingLabels: 'Url:er till PDFer dyker upp nedan alldeles strax',
    labelsGeneratedSuccessfully: 'Fraktsedlarna har genererats',
    vas: 'Tilläggstjänster (VAS)',
    price: 'Pris',
    orderSources: {
      expressit: 'ExpressIT',
      glow: 'GLOW',
      glow_customerBooking: 'GLOW Kundbokning',
      glow_excelImportV2: 'GLOW Excel',
      excel: 'GLOW Excel',
      HappyFlow: 'Happy Flow',
      '98466118503': 'Mybring',
      '98466118504': 'Mybring',
      glow_recurring: 'Återkommande',
      ShipmentAPI: 'Shipment API',
      others: 'EDI'
    },
    pickupDeviation: 'Upphämtningsavvikelse',
    deliveryDeviation: 'Leveransavvikelse',
    shipmentSyncStatus: { no: 'Nej', yes: 'Ja', partial: 'Delvis' },
    selectOtherActions: 'Välj fler alternativ'
  },
  eventsList: { timeWindow: 'Tidsfönster', from: 'Från', to: 'Till' },
  status: {
    started: 'Startad',
    notStarted: 'Inte startad'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Automatisk tilldelning av uppdrag startad',
      'auto-dispatch-failed': 'Automatisk tilldelning av uppdrag misslyckades',
      'optimizing-failed': 'Ruttoptimering misslyckades',
      'order-excluded-from-invoicing': 'Exkluderad från fakturering',
      'reoptimized-with-fallback-window': 'Rutt automatiskt omoptimerad',
      routeName: 'Rutenamn',
      resolved: 'Adresskoordinater satta',
      unresolved: 'Adresskoordinater är inte angivna',
      comment: 'Kommentar',
      created: 'Skapad',
      completed: 'Avslutad',
      assigned: 'Tilldelad',
      plannedOnRoute: 'Planerad på rutt',
      plannedOnRouteMoreInfo: 'Planerad på rutt {{routeName}} ({{unitName}})',
      nameOfUnit: 'Enhetens namn',
      optimizeProviderId: 'Optimerings-ID',
      noOptimizationEngine: 'Ingen optimeringsmotor',
      failedOptimizeProviderId: 'Misslyckat optimerings-ID',
      retryOptimizeProviderId: 'Optimerings-ID för nytt försök',
      optimizationTimeWindow: 'Tidsfönster för optimering',
      extendedBy: 'Förlängt med {{minutes}} min',
      optimizingFailedOtherNotPlanned: 'En annan sändning på rutten kunde inte planeras',
      optimizingFailedError: 'Optimeringen avbröts med ett fel',
      delivered: 'Levererad',
      collected: 'Upphämtad',
      returned: 'Returnerad',
      deviated: 'Avvik',
      damaged: 'Skadad',
      notification: 'Meddelande',
      slotChanged: 'Rutten manuellt ändrad',
      unassigned: 'Borttagen från chafför',
      rejected: 'Nekad',
      image: 'Bild',
      error: 'Fel',
      started: 'Startad',
      stopped: 'Avslutad',
      accepted: 'Accepterad',
      offered: 'Erbjuden',
      unitName: 'Enhet',
      driverName: 'Chaufför',
      'delivery-id-check': 'ID-kontroll',
      'deviation-sms-sent': 'Avvikelse-SMS skickat',
      'delivered-manually-overridden': 'Leverans manuellt ändrad',
      'order-released-for-invoicing': 'Öppen för fakturering',
      'order-paused-from-invoicing': 'Fakturering pausad',
      'manually-set-invoicing-ok-for-order-invoicing': 'Fakturerad OK',
      'manually-set-not-invoiced-for-order-invoicing': 'Inte fakturerad',
      'manually-set-excluded-from-invoicing': 'Undantagen från fakturering',
      'unit-manually-added-for-invoicing': 'Enhet manuellt tillagd',
      'deviated-manually-overridden': 'Avvik manuellt ändrad',
      'collected-manually-overridden': 'Upphämtning manuellt ändrad',
      'pickup-location-changed': 'Upphämtningsadress ändrad',
      'delivery-time-estimated': 'Uppdaterad leveranstid',
      'slot-manually-changed': 'Rutt manuellt ändrad',
      'pickup-time-changed': 'Upphämtningstid ändrad',
      'manually-change-location': 'Platser manuellt ändrade',
      'pickup-consignment-data-changed': 'Upphämtningsdetaljer ändrade',
      'delivery-consignment-data-changed': 'Leveransdetaljer ändrade',
      'specification-size-data-changed': 'Antal ändrade',
      'specification-description-data-changed': 'Beskrivning ändrad',
      'delivery-time-purchased': 'Merförsäljning: Kortare tidsfönster beställt av mottagaren',
      'digital-identity-verified': 'Mottagarens identitet verifierad digitalt',
      'digital-identity-verification-failed': 'Kunde inte verifiera mottagarens identitet digitalt',
      'flex-delivery-ordered': 'Förenklad leverans beställd av mottagare',
      'flex-delivery-ordered-by-sender': 'Förenklad leverans beställd av avsändare',
      'flex-delivery-changed': 'Förenklad leverans ändrad',
      'flex-delivery-confirmation-sms-sent': 'Flex leverans bekräftelse SMS skickat',
      'flex-delivery-confirmation-app-notification': 'Pushnotis för flex leveransbekräftelse skickad',
      'return-to-pickup-point-delivery-deviated': 'Kommer att överlämnas till utlämningsställe',
      recipientName: 'Mottagarnamn',
      receivedBy: 'Mottaget av',
      'reject-order-correction': 'Orderkorrigering avvisad',
      'accept-order-correction': 'Orderkorrigering accepterad',
      'handed-over-to-other-unit': 'Överlämnat till annan enhet',
      'handed-over': 'Överlämnat till annan enhet',
      deliveredWithoutSignature: 'Levererat utan signatur',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Placerat enligt anvisning',
        did_not_get_signature: 'Personligen',
        DELIVER_IN_PERSON: 'Personligen'
      },
      'returned-manually-overridden': 'Retur manuellt ändrad',
      'eta-sms-sent': 'SMS om beräknad tid skickat',
      calculatedEta: 'Beräknad ankomsttid: {{eta}}',
      etaSmsLabel: 'Beräknad ankomsttid',
      scanned: 'Ankommit terminal',
      'arrived-at-terminal': 'Ankommit till distributionsterminal',
      'order-sorted': 'Sorterad',
      'not-arrived-at-distributing-terminal': 'Ej ankommit till distributionsterminal',
      'pickup-eta-sms-sent': 'Pickup ETA SMS skickat',
      'handed-in-at-posten-terminal': 'Ankommit till sorteringsterminal',
      'pickup-sms-sent': 'Spårnings-SMS skickat',
      'pre-pickup-sms-sent': 'Spårnings-SMS förhandsskickat',
      'pickup-address-unresolved': 'Upphämtningsadressen har gjorts ofullständing',
      'delivery-address-unresolved': 'Leveransadressen har gjorts ofullständing',
      'in-transit': 'Under transport',
      'upcoming-pickup-sms-sent': 'Kommande leverans SMS skickat',
      'order-sorted-same-day': 'Datum satt till idag av terminal appen',
      'signature-sms-sent': 'Signatur-SMS skickat',
      'flex-delivery-cancelled': 'Förenklad leverans avbeställd',
      'delivery-time-ordered': 'Leveransdatum ändrat av mottagare',
      'delivery-time-ordered-internal': 'Leveransdatum ändrat',
      'delivery-time-updated-from-hf-sync': 'Leveranstid synkroniserad från HF',
      'planned-delivery-date-ordered': 'Planerat leveransdatum bokat',
      'delay-sms-sent': 'SMS om försening har skickats',
      'production-deviation': 'Produktionsavvikelse',
      'manual-delay-sms-sent': 'Manuellt försenat-SMS skickat',
      'route-planning-complete': 'Rutt färdig',
      'signature-delivered': 'Signature från mottagare',
      showPicture: 'Visa bild',
      'external-address-wash': 'Leveransdetaljer ändrade',
      'order-note-changed': 'Anteckning ändrad',
      'customer-details-changed': 'Kunduppgifter ändrade',
      'order-data-changed': 'Order ändrad',
      'order-moved-to-department': 'Flyttad till en annan avdelning',
      'order-moved-to-department-with-data': 'Sändningen flyttad från',
      'package-measurements-changed': 'Paketstorlek ändrad',
      'package-data-changed': 'Kollidata ändrad',
      'driver-deviated-from-route': 'Chaufför avvek från rutten',
      'driver-deviated-from-route-at-pickup': 'Chaufför avvek från rutten vid upphämtning',
      'delivered-outside-service-time-window': 'Leverans eller avvik utanför tjänstens tidsfönster',
      'delivered-outside-estimated-time-window': 'Leverans eller avvik utanför beräknat tidsfönster',
      'delivered-in-estimated-time-window': 'Leverans eller avvik inom beräknat tidsfönster',
      'picked-up-outside-service-time-window': 'Hämtning eller avvik utanför tjänstens tidsfönster',
      'picked-up-outside-estimated-time-window': 'Hämtning eller avvik utanför beräknat tidsfönster',
      'picked-up-in-estimated-time-window': 'Hämtning eller avvik inom beräknat tidsfönster',
      'ordered-delivery-time-set-by-production-time-window': 'Produktionstidsfönster inställt',
      'seen-by-recipient': 'Mottagaren har sett spårningssidan',
      'first-estimated-times-seen': 'Första estimerade tid sedd av mottagare',
      'pre-advice-push-sms-sent': 'Preadvice PUSH-SMS skickat',
      'pre-advice-push-return-sms-sent': 'Preadvice PUSH-RETURN-SMS skickat',
      'pre-advice-pull-sms-sent': 'Preadvice PULL-SMS skickat',
      'pre-advice-pull-email-sent': 'Preadvice PULL-e-post skickat',
      'pre-advice-pull-reminder-sms-sent': 'Preadvice PULL påminnelse-SMS till mottagare skickat',
      'pre-advice-pull-reminder-email-sent': 'Preadvice PULL påminnelse-e-post till mottagare skickat',
      'pre-advice-pup-sms-sent': 'Preadvice PUP-SMS skickat',
      'pre-advice-return-sms-sent': 'Retur aviserings SMS skickat',
      'pre-advice-return-email-sent': 'Retur aviserings email skickat',
      'delivery-location-deviation': 'Leverans eller avvik inte på förväntad plats',
      'pre-advice-pull-reminder-to-sender-email-sent': 'Preadvice PULL påminnelse till avsändare email skickat',
      'pre-advice-pup-reminder-to-sender-email-sent': 'Preadvice PUP påminnelse till avsändare email skickat',
      'pre-advice-return-return-to-sender-email-sent': 'Preadvice RETURN retur till avsändare email skickat',
      'pre-advice-pull-return-to-sender-email-sent': 'Preadvice PULL retur till avsändare email skickat',
      'pre-advice-push-return-email-sent': 'Preadvice PUSH retur till avsändare email skickat',
      'pre-advice-manual-attempt': 'Manuellt preadvice-forsök',
      'pre-advice-manual-request': 'Manuellt preadvice påbörjat',
      'pre-advice-status-changed': 'Aviseringstatus endret',
      'reported-damaged': 'Skada rapporterad',
      'reported-missing-article': 'Saknade artiklar rapporterade',
      'pre-advice-active-return-to-customer-email-sent': 'Preadvice aktiv retur till kund, epost skickad',
      'pre-advice-active-return-not-picked-up-email-sent': 'Preadvice aktiv return ble inte hämtat, epost skickad',
      'pre-advice-active-return-info-to-customer-email-sent':
        'Preadvice e-post med information om aktiv retur till kund skickat',
      'pre-advice-passive-return-to-customer-email-sent': 'Preadvice passiv retur til kunde, epost skickad',
      'notification-to-sender-failed': 'Epostavisering till kunden misslyckades',
      'delivery-sms-sent': 'Leverans SMS skickat',
      'parcelbox-allocated': 'Plats reserverad i paketbox',
      unconfirmed: 'Obekräftad',
      refused: 'Avvisad',
      'accepted-by-planner': 'Accepterad',
      'apartment-information-updated': 'Lägenhetsinformation uppdaterad',
      'lock-code-entered': 'Portkod angiven',
      'claim-registered-email-sent': 'E-post om skadade- eller saknade artiklar sänt',
      'invoicing-failed': 'Fakturering misslyckades',
      'invoiced-ok': 'Fakturering OK',
      'invoice-awaiting-acknowledgement': 'Inväntar orderbekräftelse',
      'parcel-locker-delivery-selected': 'Paketbox vald',
      'cancelled-parcel-locker-delivery': 'Paketbox avbokad',
      'pre-advice-result': 'Avisering',
      'order-credited': 'Order krediterad',
      'parcel-locker-tracking-sms-sent': 'Spårnings-SMS för paketbox skickat',
      'time-window-cancelled-by-recipient': 'Tidsfönster avbokat av mottagaren',
      'hd-multileg-return-created': 'Returleverans skapad',
      'hd-multileg-return-failed': 'Returleverans misslyckades',
      'invoice-acknowledged-by-external-system': 'Order bekräftad av externt system',
      'invoice-created-in-external-system': 'Faktura skapad i externt system',
      'invoice-sent-to-customer': 'Faktura skickad till kund',
      'invoice-paid-by-customer': 'Faktura betald av kund',
      'invoice-due-date-updated': 'Fakturaförfallodatum uppdaterat',
      'invoice-paid-to-vendor': 'Faktura betald till leverantör',
      'customer-invoiced': 'Kund fakturerad',
      'service-upgrade-purchased': 'Merförsäljning: Inburen leverans beställd av mottagaren',
      serviceUpgradePurchasedDescription: 'Inburen leverans beställd av mottagaren',
      'preliminary-loaded': 'Preliminärt lastad',
      selfBillingUnitId: 'Self-billing unit ID',
      selfBillingUser: 'Användare',
      'manual-price-override': 'Pris överstyrt',
      'incomplete-price-approved': 'Ofullständigt pris godkänt',
      'incomplete-price-unapproved': 'Ofullständigt prisgodkännande återkallat',
      'b2r-return-order-created': 'B2R returorder skapad',
      unloaded: 'Avlastat',
      'manually-changed-measurements': 'Manuellt ändrad vikt och volym',
      'internal-trade-order-created': 'Intern handelsorder skapad',
      'load-carrier-ready-for-distribution': 'Lastbärare redo för distribution',
      'bom-articles-muted': 'BOM PU/DEL är undantagna från fakturering',
      'bom-articles-unmuted': 'BOM PU/DEL är inte undantagna från fakturering',
      'pickup-app-notification': 'Pushnotis för spårning skickad',
      'duplicate-order-created': 'Duplikat skapat',
      'ready-for-pickup': 'Redo för hämtning (PUP på terminal)',
      'return-address-updated': 'Returadress uppdaterad',
      restored: 'Återställd',
      'manually-marked-as-handled': 'Retur markerad som hanterad',
      'recipient-phone-number-updated': 'Mottagarens telefonnummer har blivit uppdaterat',
      'recipient-email-address-updated': 'Mottagarens e-postadress har blivit uppdaterad'
    },
    cause: {
      plannedStop: 'Upphämtningsinformationen har uppdaterats eftersom leveransen lastades vid en schemalagd hållplats',
      planToScan: 'Leveransinformationen har blivit uppdaterad eftersom sändningen scannades på rutt',
      adhocHenteordre: 'Leveransinformationen har uppdaterats eftersom rutten har en annan slutadress än terminalen',
      sorted: 'Leveransinformationen har uppdaterats på grund av att sändningen blev sorterad',
      shipmentDelayed: 'Leveransinformationen har uppdaterats eftersom sändningen är försenad',
      movedToNextWorkingDay: 'Flyttad till nästa arbetsdag',
      optimizedInLoadCarrier:
        'Leveransinformationen har uppdaterats eftersom sändningen ruttplanerades som en del av en lastbärare'
    },
    source: 'Källa',
    unassignedReason: 'Orsak',
    returnAddressSource: {
      OrderSource: 'Returadressen som kunden har angett i bokningsfilen används',
      CustomerAdmin: 'Returadressen som är konfigurerad i Customer Admin används',
      SenderAddress: 'Ingen returadress har angetts i kundens bokningsfil, avsändarens adress används'
    },
    rejectedReason: {
      reason: 'Anledning',
      private: 'Privata orsaker',
      notEnoughTime: 'Hinner inte med stoppet i tid',
      notEnoughSpaceOnVehicle: 'Sändningen får inte plats',
      other: 'Annat',
      CJ: '$t(consignmentEvent.rejectedReason.notEnoughSpaceOnVehicle)',
      CK: '$t(consignmentEvent.rejectedReason.other)',
      CL: '$t(consignmentEvent.rejectedReason.notEnoughTime)',
      OL1: 'Inte på rutten',
      OL2: 'Inte tillräckligt med plats i fordonet',
      OL3: 'Inte tillräckligt med tid',
      OL4: 'Godset hittades inte',
      OL5: 'Planerad till senare, men inga terminalstopp återstår',
      comment: 'Kommentar'
    },
    idCheck: {
      idCheckFailed: 'ID-kontroll misslyckades, men levererades med {{idCheckFailedResult}}',
      idCheckSummaryOther: 'Annat ({{otherType}}), födelsedatum {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, födelsedatum {{birthDate}}',
      idCheckSummaryOtherLabel: 'Annat ({{otherType}})',
      idCheckValue: 'Födelsedatum {{birthDate}}'
    },
    damaged: {
      damageType: 'Skadetyp',
      courierInput: 'Meddelande från chaufför',
      showPictureLink: 'Visa bild {{idx}}',
      type: { A: 'Paket/emballageskada', D: 'Tryck/klämskada', E: 'Totalskada' }
    },
    invoiceInitiationType: {
      automatic: 'Schemalagd fakturering',
      'manual-department-level': 'Manuell avdelningsfakturering',
      'manual-order-level': 'Manuell orderfakturering',
      'multiple-order-level': 'Manuell fakturering av flera order'
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'Ingen matchande rutt hittades',
      DISPATCH_REJECTED: 'Kunde inte schemalägga optimering',
      RETRIES_EXHAUSTED: 'Alla försök misslyckades'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        'Exkluderad automatiskt eftersom enheten inte har både avräkning och interna handelstransaktioner aktiverade'
    },
    autoDispatchSucceeded: {
      matchedRange: 'Matchat postnummerintervall: {{from}}-{{to}}.',
      matchedPostalCode: 'Matchat postnummer: {{code}}.',
      viewRuleDetails: 'Visa regeldetaljer <a>här</a>',
      sentForOptimization:
        'Ordern matchade en regel för automatisk tilldelning av uppdrag och har skickats för ruttoptimering.'
    },
    invoiceCallback: {
      timeOfTransaction: 'Tidpunkt',
      transactionNumber: 'Transaktionsnummer hos {{systemId}}',
      invoiceLink: 'Klicka för att se faktura'
    },
    changedFrom: 'Ändrat från -',
    blankText: '(tom)',
    name: 'Namn',
    deliveryOrderedByReceiver: 'Leverans till paketbox vald av mottagaren',
    invoiceEventReason: {
      manuallySetByUser: 'Faktureringsstatusen är manuellt ändrad av användare',
      manualInvoiceInfo: 'Pausad automatiskt eftersom manuell fakturainformation angavs på ordern'
    },
    unresolved: {
      missingPickupCoordinates: 'Saknade upphämtningskoordinater',
      missingDeliveryCoordinates: 'Saknade leveranskoordinater'
    },
    resolved: {
      source: {
        DepartmentLocation: 'koordinater på avdelning',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'lagrade koordinater',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'okänt',
        CustomerSite: 'kundens plats',
        ParcelHub: 'ParcelHub',
        ParcelInMailbox: 'postlådans koordinater',
        Driver: 'chaufför',
        OriginalOrder: 'Ursprunglig sändning',
        Google: 'Google',
        GoodsReturnAddress: 'returadress för varor'
      },
      pickup: {
        coordinatesSetBy: 'Upphämtningskoordinater satt av {{source}}',
        coordinatesManuallySet: 'Upphämtningskoordinater har satts manuellt',
        coordinatesRestored: 'Upphämtningskoordinater återställda',
        coordinatesSwapped: 'Upphämtningskoordinater satta till tidigare leveranskoordinater'
      },
      delivery: {
        coordinatesSetBy: 'Leveranskoordinater satt av {{source}}',
        coordinatesManuallySet: 'Leveranskoordinater har satts manuellt',
        coordinatesRestored: 'Leveranskoordinater återställda',
        coordinatesSwapped: 'Leveranskoordinater satta till tidigare upphämtningskoordinater'
      }
    },
    created: {
      recurringOrder: 'Skapad från återkommande uppdrag.',
      showOriginalOrder: 'Visa originalet',
      recurringRoute: 'Skapad från återkommande rutt',
      recurringRouteLink: 'till ruttinställningar',
      showDuplicate: 'Visa duplicerad order',
      showOrder: 'Visa order',
      fromThisOrder: 'Skapad från denna order',
      fromOrder: 'Skapad från order'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Uppskattat tidsfönster',
      'delivered-in-estimated-time-window': 'Uppskattat tidsfönster',
      'delivered-outside-service-time-window': 'Servicetidsfönster',
      'picked-up-outside-estimated-time-window': 'Uppskattat tidsfönster',
      'picked-up-in-estimated-time-window': 'Uppskattat tidsfönster',
      'picked-up-outside-service-time-window': 'Servicetidsfönster',
      actual: 'Faktisk leverans eller avvikelse',
      actualPickup: 'Faktisk hämtning eller avvikelse'
    },
    deliveryInstructions: 'Leveransinstruktioner'
  },
  jobs: {
    job: 'Jobb',
    lastStarted: 'Senast startad',
    lastFinished: 'Senast avslutad',
    maxDuration: 'Maxvaraktighet',
    timeBetweenRuns: 'Tid mellan körningar',
    disable: 'Inaktivera',
    enable: 'Aktivera',
    disabled: 'Inaktiverad',
    disabledInConfig: 'Inaktiverad i konfiguration',
    mustBeASuperAdmin: 'Du måste vara superadministratör för att inaktivera och aktivera jobb',
    showOnlyStruggling: 'Visa bara jobb med problem',
    runningLongerThanExpected: 'Kör längre än förväntat',
    notStartedForLongerThanExpected: 'Har inte startat som förväntat'
  },
  numberSeries: {
    numberSeries: 'Nummerserie',
    comparisonError: 'Maximum måste vara större än minimum',
    successfullyAdded: 'Nummerserien har lagts till i listan',
    successfullyDeleted: 'Nummerserien har tagits bort',
    addNewNumberSeries: 'Lägg till ny nummerserie',
    addedNumberSeries: 'Tillagda nummerserier',
    addedNumberSeriesSubHeading: 'Lägg till nummerserie (inkludera inte kontrollsiffror)',
    selectType: 'Välj typ',
    shipmentNumber: 'GSIN (sändningsnummer)',
    packageNumber: 'SSCC (kollinummer)',
    minimum: 'Minimum',
    maximum: 'Maximum',
    addNumberSeriesButton: 'Lägg till nummerserie i listan',
    type: 'Typ',
    currentNumber: 'Aktuellt nummer',
    maxNumber: 'Maxnummer',
    numbersLeft: 'Nummer kvar',
    validMinimumValue: 'Du måste ange ett giltigt minimivärde',
    validMaximumValue: 'Du måste ange ett giltigt maximivärde',
    deleteModalTitle: 'Ta bort nummerserie',
    deleteModalDescription: 'Den här åtgärden kan inte ångras'
  },
  preadvice: {
    searchPlaceholder: 'Skriv minst 3 tecken för att filtrera',
    selectedCustomers: 'Valda kunder ({{count}})',
    customerSearch: 'Sökfält - Skriv minst 3 tecken för att söka efter kunder',
    settingTargetDepartment:
      'Denna aviseringsinställning gäller för specifika avdelningar. Ta bort alla valda avdelningar för att kunna byta till avdelningsgrupper',
    settingTargetDepartmentGroups:
      'Denna aviseringsinställning gäller för specifika avdelningsgrupper. Ta bort alla valda avdelningsgrupper för att kunna byta till avdelningar',
    settingTargetCustomers:
      'Den här preaviseringen riktar sig mot en specifik kund. Ta bort alla valda kunder för att kunna byta inställning till kundgrupper',
    settingTargetCustomerGroups:
      'Denna aviseringsinställning gäller för specifika kundgrupper. Ta bort alla valda kundgrupper för att kunna byta till kunder',
    conflictHeading: 'Det finns konflikter i dina aviseringsregler',
    conflictingRules: 'Regler i konflikt',
    deletePreadviceDescription:
      'Om du raderar tas alla aviseringsinställningar bort och mottagaren eller avsändaren får inte längre någon kommunikation. Åtgärden kan inte ångras.',
    rule: 'Regel',
    ruleTrigger: 'Avisering på',
    type: 'Typ',
    trigger: 'Orsak',
    action: 'Variant',
    nameDescription: 'Namn och beskrivning',
    createNewPreadvice: 'Skapa ny preaviseringsregel',
    bizArea: 'Välj affärsområde',
    courierAndExpress: 'Bud och Express',
    homeDelivery: 'Hemleverans (HD)',
    filterDepartmentAndGroups: 'Filtrera på avdelningar eller avdelningsgrupper',
    filterCustomersAndGroups: 'Filtrera på kunder eller kundgrupper',
    tabsWithErrors: 'Åtgärda problemen på följande flikar: {{tabs}}',
    preadvice: 'Avisering',
    hdDepartments: 'HD-avdelningar',
    ceDepartments: 'Budavdelningar',
    departmentGroups: 'Avdelningsgrupper',
    customers: 'Kunder',
    customerGroups: 'Kundgrupper',
    customersCount: 'Antal kunder',
    customerGroupsCount: 'Antal kundgrupper',
    showGroupMembers: 'Visa gruppmedlemmar',
    departmentsCount: 'Antal avdelningar',
    departmentGroupsCount: 'Antal avdelingsgrupper',
    lockNotification: 'Lås avisering',
    preadviceRule: 'Aviseringsregel',
    locked: 'Avisering låst',
    nameOfRule: 'Regelns namn',
    updated: 'Avisering uppdaterad',
    noSelectedCustomers: 'Inga valda kunder',
    result: {
      NO_RULE: 'Ingen aviseringsregel matchar',
      NO_DELIVERY_TIME_WINDOW: 'Tidsfönster för leverans hittades ej',
      SMS_SENT: 'Aviseringsregel kontrollerad. SMS tillagt i kön',
      EMAIL_SENT: 'Aviseringsregel kontrollerad. Email tillagt i kön',
      SMS_AND_EMAIL_SENT: 'Aviseringsregel kontrollerad. SMS och Email tillagt i kön',
      NO_VALID_PHONE_OR_EMAIL: 'Inget giltigt telefonnummer eller e-postadress',
      FEATURE_OFF: 'Avisering avstängd',
      ALREADY_PRE_ADVICED: 'Leveransdag och tid redan satt. Ingen åtgärd vidtagits',
      CANCELLED: 'Avisering avstängd',
      WAITING_FOR_PACKAGES: 'Alla kollin har ej ankommit terminal',
      ALREADY_IN_PROGRESS: 'Väntar på att avsändare/mottagare bokar tid',
      ERROR: 'Ett fel har uppstått',
      WRONG_TRIGGER: 'Triggern matchar inte regeln. Ignorerar.',
      MANUAL_ATTEMPT: 'Manuellt aviseringsförsök tillagt',
      PRE_ADVICE_LIMIT_REACHED: 'Antal aviseringsförsök nådd',
      PRE_ADVICE_LOCKED: 'Avisering låst',
      ORDER_DELIVERED: 'Sändningen är redan levererad',
      RETURN_LAST_LEG_CREATION_SKIPPED: 'Returben ej skapat'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Regelkonflikt!',
        detail:
          'Regel för {{service}} vill åsidosätta regelsett {{policySetNames}} genom anknytning där till {{relations}}.',
        department: 'avdelning',
        department_group: 'avdelningsgrupp',
        customer: 'kund',
        customer_group: 'kundgrupp'
      }
    },
    noPoliciesFound: 'Inga regelsett',
    policies: 'Regelsett för automatisk avisering',
    copyText: 'Kopiera text',
    customerInGroupTitle: 'Kunder i {{groupName}}',
    policy: {
      servicePoliciesDescription: 'Beroende på vilken typ av avisering du väljer visas olika inmatningsfält',
      exception: 'Undantag',
      deleteConfirm: 'Är du säker på att du vil avlägsna detta regelsettet?',
      name: 'Namn',
      new: 'Ny aviseringsinställning',
      edit: 'Redigera aviseringsinställning',
      description: 'Beskrivning',
      save: 'Spara',
      saveAnyway: 'Spara endå',
      servicePolicies: 'Aviseringsregler',
      targets: 'Kund-/avdelningsinställningar',
      servicePolicy: {
        edit: 'Redigera inställningar',
        new: 'Lägg till aviseringsinställningar för tjänst',
        cutOff: 'Cutoff',
        remove: 'Avlägsna vald',
        serviceCode: 'Tjänst',
        serviceCodeLegend: 'Lägg till tjänst t.ex 3123',
        vasCode: 'VAS',
        vasCodeLegend: 'Lägg till tilläggstjänst t.ex SWAP',
        sameDay: 'Samma dag',
        returnToCustomer: 'Retur till kund',
        reminderToCustomer: 'Påminnelse till kund',
        redirectToPuP: 'Omdirigera till utlämningsställe',
        sameDayTitle: 'Tillåt bokningar samma dag före cutoff',
        yesRecipientShouldChange: 'Ja, mottagaren ska kunna ändra',
        noRecipientShouldNotChange: 'Nej, mottagaren ska inte kunna ändra',
        recipientCanCancelBookedTimeSlot: 'Mottagaren kan avboka det bokade tidsfönstret.',
        sameDayLegend: 'Ange om du sändingar ska levereras med Same Day Service',
        triggerEvent: 'Avisering på',
        triggerEventTitle: 'Trigga avisering',
        triggerEventLegend:
          'Hva ska trigga at preavisering skickas? När Glow mottagar EDI, när sändingen ankommit HUB eller vid DIP? Om det inte ska triggas, väljer du MANUAL.',
        cutoff: 'Cutoff',
        cutoffLegend:
          'Vad er cutoff-tiden när inte längre erbjuder att leverera första tilgjengliga fönster, utan nesta dag.',
        relativeCutoffMinutes: 'Cutoffminuter',
        relativeCutoffMinutesLegend:
          'Minsta antal minuter från aviseringstiden till nästa tillgängliga tidsfönster. Åsidosätter cutoff.',
        calendarDays: 'Kalenderdagar',
        goodsRedirectToPickupPoint: 'Godset omdirigeras till utlämningsställe efter 1 leveransförsök',
        dateAndTimeChangeBookingPageTitle: 'Ändringar av datum och tid på bokningssidan.',
        calenderDaysTitle: 'Ange hur många dagar som ska visas för mottagaren på bokningssidan',
        calendarDaysLegend: 'Hur många dagar ski visas i mottagarens kalender',
        noServicePoliciesFound: 'Inga inställningar tillagda än',
        returnToSenderAfterDays: 'Retur till avsändare',
        returnToSenderAfterDaysLegend:
          'Efter hur många dagar sk sändingar skickas tilbaka til sendaren, om vi inte lykkas komma i kontakt med mottagar.',
        scheme: 'Typ',
        schemeLegend: 'Vilken typ preavisering ska skickas. Pull, Push, Return eller Pick up parcel.',
        searchCustomer: 'Sök kund',
        remindAfterHours: 'Påminnelse till mottagare',
        remindAfterHoursLegend:
          'Används för Pull och PUP preavisering. Efter hur många timmar ska vi skicka påminnelse til mottagaren för at dom ska booka levering',
        preAdviceAttempts: 'Aviseringsforsök',
        preAdviceAttemptsLegend: 'Hur många påminnelser som ska skickas innan sändningen returneras till avsändaren.',
        reminderToSenderAfterHours: 'Påminnelse till avsänder',
        reminderToSenderAfterHoursLegend:
          'Påminnelse till avsänder om at ci inte har lyckas komme i kontakt med mottagaren. Sändingen vill bli returnerad.',
        deliveryAttempts: 'Leveransforsök',
        deliveryAttemptsTitle: 'När det maximala antalet leveransförsök har nåtts returneras kollit till kunden',
        deliveryAttemptsChoiceTitle: 'Vad ska hända när det maximala antalet leveransförsök har nåtts',
        deliveryAttemptsLegend: 'Antal leveransfök innan sändingar returneras tilbaka till avsändar.',
        pickupAttempts: 'Upphämtningsförsök',
        pickupAttemptsTitle: 'Maximalt antal upphämtningsförsök',
        pickupAttemptsDescription:
          'När antalet upphämtningsförsök har nåtts informerar vi kunden om att det inte finns något att returnera på grund av upphämtningsavvikelse',
        label: { days: 'Dagar', hours: 'Timmar', smss: 'st.' },
        legend: { days: 'Dagar', hours: 'Timmar', smss: 'Maks antal SMS' },
        returnToPup: 'Retur till pickup point',
        addNewRule: 'Lägg till ny regel',
        enableCancelBookingTimes: 'Tillåt avbokning på bokningssidan',
        typeOfOrders: 'Typ av ordrar',
        ordersWithDate: 'Ordrar med datum',
        ordersWithoutDate: 'Ordrar utan datum',
        ordersWithAndWithoutDate: 'Ordrar med och utan datum',
        emailToCustomer: 'E-post till kund',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'HUB',
          DIP: 'DIP',
          MANUAL: 'MANUAL'
        }
      }
    },
    tooltip: 'Låst order = ingen avisering skickas till mottagaren',
    customerCode: 'Kundkod'
  },
  holidays: {
    holidays: 'Helgdagar',
    holiday: 'Helgdag',
    dayBeforeHoliday: 'Dag före helgdag',
    addHoliday: 'Lägg till ny helgdag',
    country: 'Land',
    type: 'Typ',
    date: 'Datum',
    successfullyAdded: 'Helgdagen har lagts till i listan',
    successfullyDeleted: 'Helgdagen har tagits bort',
    filterOnCountry: 'Filtrera på land',
    selectHolidayType: 'Välj typ av helgdag',
    addHolidayToList: 'Lägg till helgdag i listan',
    selectCountry: 'Välj land',
    addedHolidays: 'Tillagda helgdagar',
    deleteModalTitle: 'Ta bort helgdag',
    deleteModalDescription: 'Den här åtgärden kan inte ångras'
  },
  distributionMapping: {
    title: 'Distributionskoppling',
    addDips: 'Lägg till DIP',
    addedDips: 'Tillagd DIP ({{count}})',
    addedDips_other: 'Tillagda DIP:er ({{count}})',
    connectedToPickupPoints: 'Kopplad till {{count}} utlämningsställe',
    connectedToPickupPoints_other: 'Kopplad till {{count}} utlämningsställen',
    emptyTitle: 'Inga kopplade distributionspunkter (DIP)',
    emptyDescription:
      'Du måste först välja en DIP för att kunna lägga till utlämningsställen.\nKlicka på knappen längst upp till höger för att komma igång.',
    addDipModalTitle: 'Lägg till distributionskoppling',
    addDipModalDescription: 'Välj den DIP du vill lägga till utlämningsställen på',
    selectDipLabel: 'Sök efter distributionspunkt (DIP)',
    searchPlaceholder: 'PUP ID, namn eller adress',
    selectButton: 'Välj',
    editDip: 'Ändra {{name}}',
    selectPickupPointHeading: 'Välj det utlämningsställe du vill lägga till DIP:en',
    selectPickupPointLabel: 'Sök efter utlämningsställe (PUP)',
    addedPickupPoints: 'Utlämningsställen tillagda på DIP:en',
    removePickupPoint: 'Ta bort {{name}}',
    editPickupPoint: 'Ändra {{name}}',
    editPickupPointDescription: 'Välj de dagar PUP:en kan få leveranser',
    deliveryDays: 'Leveransdagar',
    deliveryDaysHint: 'Välj de dagar utlämningsställena kan få leveranser',
    addPickupPoint: 'Lägg till utlämningsställe',
    saveToast: 'Distributionskoppling för {{name}} har sparats',
    addLocations: 'Lägg till platser',
    removeDip: 'Ta bort {{name}}',
    removeDipQuestion: 'Ta bort {{name}} från distributionskopplingen?',
    removeDipDescription: 'Kopplade utlämningsställen blir utan DIP.',
    removeConnectionQuestion: 'Ta bort kopplingen till {{name}}?',
    removeConnectionDescription: 'Utlämningsstället blir utan DIP tills det kopplas igen.',
    alreadyAdded: 'Detta utlämningsställe finns redan på denna DIP. Att lägga till det igen ersätter leveransdagarna.',
    alreadyMappedToOtherDip:
      'Detta utlämningsställe är redan kopplat till {{dip}}. Ta bort det från den DIP:en innan du lägger till det här.',
    loadFailed: 'Kunde inte hämta DIP-kopplingarna. Försök igen eller ladda om sidan.',
    errorSelectPickupPoint: 'Du måste välja ett utlämningsställe',
    errorSelectDeliveryDay: 'Du måste välja minst en leveransdag',
    errorSelectDip: 'Du måste välja en DIP',
    deleteToast: '{{name}} har tagits bort'
  },
  department: {
    region: 'Region',
    general: 'Allmänt',
    plannedStopLocations: 'Planerade stopp',
    plannedStopLocationsDescription: 'Här kan du lägga till alla planerade stopp för optimering av ruttplaneringen.',
    plannedStopLocationName: 'Namn på planerat stopp',
    plannedStopLocationIsTerminal: 'Räknas som terminaladress för denna avdelning',
    plannedStopLocationIsTerminalTooltip:
      'Endast relevant för avdelningar med mer än en terminaladress. Adressen används då utöver avdelningens standardadress.',
    addPlannedStopLocation: 'Lägg till planerat stopp',
    searchDepartmentByNameOrId: 'Filtrera på avdelningsnamn eller avdelnings-ID',
    searchDepartmentGroups: 'Sök efter gruppnamn eller beskrivning',
    createNewDepartment: 'Skapa ny avdelning',
    addressAndContact: 'Adress och kontaktinformation',
    searchAddressError: 'Saknas värden för adressen. Du måste använda sökfältet för att få rätt adress.',
    addressContactIngress: 'För att få rätt adress, använd sökfältet. Adress, postnummer och stad fylls i automatiskt.',
    settingsInGlow: 'Inställningar på mottagarens spårningssida',
    settingsBodyText: 'Beroende på ditt val kommer olika innehåll och kommunikation att visas/skickas till mottagarna.',
    tooltipNPSID: 'NPS ID = Ange avdelningens unika ID för utskick av NPS-mätningar.',
    tooltipTerminal: 'Om upphämtnings- och avdelningsnamn skiljer sig åt, fyll i denna information',
    removeRow: 'Ta bort rad',
    cutoff: 'Cutoff',
    regular: 'Ordinarie',
    sameDay: 'Samma dag',
    weekdays: 'Vardagar',
    saturdays: 'Lördagar',
    sundays: 'Söndagar',
    setTimeWindow: 'Ange tidsfönster',
    setTimeWindowToDepartment: 'Ange tidsfönster för avdelningen',
    updateTimeWindow: 'Uppdatera tidsfönster',
    timeWindowTitle: 'Logik för leveransdagar',
    timeWindowIngress:
      'Vilka dagar ska denna avdelning leverera? Fyll för varje dag i antingen alla värden eller inga värden.',
    emailAddress: 'E-postadress',
    npsId: 'NPS ID',
    defaultAlystraUnitId: 'Selfbilling unit ID',
    timeWindow: 'Tidsfönster',
    pickupEarliest: 'Tidigaste upphämtning',
    pickupLatest: 'Senaste upphämtning',
    deliveryEarliest: 'Tidigaste leverans',
    deliveryLatest: 'Senaste leverans',
    routePlanning: 'Ruttplanering',
    autoRouteCreationTime: 'Automatisk ruttgenerering',
    autoRouteOptimizationTime: 'Automatisk ruttoptimering',
    clearTime: 'Ta bort tiden',
    delegatedDepartment: 'Delegerad avdelning',
    manageDepartment: 'Hantera avdelning',
    listAllDepartments: 'Lista alla avdelningar',
    listAllGroups: 'Lista alla avdelningsgrupper',
    successUpdate: '{{name}} har uppdaterats',
    editDepartment: 'Redigera {{name}}',
    departmentTitle: 'Avdelning',
    departmentsLabel: 'avdelningar',
    labels: 'Etiketter',
    labelsDescription:
      'Skapa etiketter för att bygga filtreringsregler för den här avdelningen. Etiketter inom samma kategori matchas med <bold>OR</bold>-logik, medan olika kategorier kombineras med <bold>AND</bold>-logik. Kom ihåg att tilldela etiketterna till dina rutter för att filtreringen ska börja gälla.\n' +
      '\n' +
      'Om etiketter har skapats för en avdelning ombeds användarna att välja vilka etiketter de vill visa första gången de öppnar sidan <bold>Ruttöversikt</bold>. De kan när som helst ändra sitt val med hjälp av det vanliga filterpanelen på sidan <bold>Ruttöversikt</bold>. Valet sparas i webbläsaren. Läs mer här (eller i “Vad är detta”-modalen): <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>',
    labelsCategory: 'Kategori',
    labelsCategoryHint: 'Använd ett befintligt kategorinamn för att lägga till fler etiketter i samma grupp.',
    labelName: 'Etikettnamn',
    existingLabels: 'Befintliga etiketter',
    labelsEmpty: 'Inga etiketter har skapats ännu.',
    labelsPreview: 'Förhandsvisning',
    labelsPreviewEmpty: 'Välj etiketter för att se hur filterlogiken byggs upp.',
    labelsDuplicate: 'Den här etiketten finns redan i den valda kategorin.',
    labelsNotAdded: 'Klicka på Lägg till för att lägga till etiketten innan du sparar.',
    nameRequired: 'Namn krävs',
    addressRequired: 'Adress krävs',
    zipCodeRequired: 'Postnummer krävs',
    zipAreaRequired: 'Stad krävs',
    labelsCategoryRequired: 'Kategori krävs',
    labelNameRequired: 'Etikettnamn krävs',
    departmentTypeRequired: 'Avdelningstyp krävs',
    departmentIdRequired: 'Avdelnings-ID krävs',
    descriptionRequired: 'Beskrivning krävs',
    regionRequired: 'Region krävs',
    minutesAfterOrderArrivalRequired: 'Minuter efter att ordern mottagits krävs',
    createLabels: 'Skapa etiketter',
    departmentWithCount: '{{count}} avdelning',
    departmentWithCount_other: '{{count}} avdelningar',
    departmentGroups: 'Avdelningsgrupper',
    numberOfDepartmentGroups: 'Antal avdelningsgrupper',
    numberOfDepartments: 'Antal avdelningar',
    search: 'Sök efter avdelningar',
    searchGroups: 'Sök efter avdelningsgrupper',
    noDepartmentsFound: 'Inga avdelningar hittades',
    noDepartmentGroupsFound: 'Inga avdelningsgrupper hittades',
    noDepartmentName: 'Namn saknas',
    noDepartmentId: 'Id saknas',
    noCouriers: 'Inga chaufförer',
    courierCount_other: '{{count}} chaufförer',
    courierCount: '{{count}} chaufför',
    noCourier: 'Inga chaufförer',
    couriers: 'Antal chaufförer',
    plannerCount_other: '{{count}} trafikplanerare',
    plannerCount: '{{count}} trafikplanerare',
    noPlanner: 'Inga trafikplanerare',
    planners: 'Antal trafikplanerare',
    choose: 'Välj avdelning',
    new: 'Ny avdelning',
    description: 'Beskrivning',
    name: 'Namn',
    created: 'Avdelning skapad',
    updated: 'Avdelning uppdaterad',
    departmentType: 'Avdelningstyp',
    notSet: 'Inte valt',
    courier: 'Bud',
    express: 'Express',
    hd: 'Hemleveranser',
    h2: 'H2',
    parcel: 'Parcel',
    posten: 'Posten',
    other: 'Övrig',
    all: 'Alla',
    deliveryDisplayType: 'Leveranstidsval',
    terminalName: 'Terminalnamn',
    terminalNameTooltip: 'Fyll i detta fält om hämtnings- och avdelningsnamnet är olika',
    selectArea: 'Välj area...',
    address: 'Adress',
    zipCode: 'Postnr',
    zipArea: 'Stad',
    orderBillingType: {
      title: 'Beställningsfaktureringstyp',
      selectBillingType: 'Välj Faktureringstyp',
      apollo: 'Apollo',
      h2: 'H2',
      pickup: 'Upphämtning',
      customerBillingNumber: 'Kundens faktureringsnummer',
      addMoreOrderBillingInfo: 'Lägg till faktureringstyp för ny beställning',
      internalTrade: 'Intern handel'
    },
    departmentId: 'Avdelnings-ID',
    disableSms: 'Inaktivera spårnings- och ETA-SMS på rutt',
    smsShouldNotBeSent:
      'Spårnings- och ETA-SMS ska inte skickas till mottagare i rutter producerade på denna avdelning.',
    autoRecurrentTime: 'Automatiskt återkommande tid',
    autoInvoiceTitle: 'Automatisk fakturering',
    autoInvoiceEnable: 'Ställ in automatisk fakturering',
    autoInvoiceTime: 'Tidpunkt',
    autoInvoiceOffset: {
      legend: 'Vilka ordrar ska faktureras',
      oneDayEarlier: 'Levererade för 1 dag sedan',
      twoDaysEarlier: 'Levererade för 2 dagar sedan',
      threeDaysEarlier: 'Levererade för 3 dagar sedan',
      fourDaysEarlier: 'Levererade för 4 dagar sedan',
      fiveDaysEarlier: 'Levererade för 5 dagar sedan'
    },
    autoDispatchSettings: {
      title: 'Automatisk tilldelning av upphämtningsordrar',
      enable: 'Ställ in automatisk tilldelning av upphämtningsordrar',
      minutesAfterOrderArrival: 'Minuter efter att ordern mottagits',
      startTime: 'Starttid'
    },
    unitNumber: 'Enhetsnummer'
  },
  departmentGroup: {
    departmentGroupDeleted: '{{name}} har raderats',
    selectedCountries: '{{count}} valt land',
    selectedCountries_other: '{{count}} valda länder',
    countries: 'Länder',
    allDepartmentTypes: 'Alla avdelningstyper',
    selectedDepartmentTypes: '{{count}} vald avdelningstyp',
    selectedDepartmentTypes_other: '{{count}} valda avdelningstyper',
    departmentTypes: 'Avdelningstyper',
    youMustSelectDepartment: 'Du måste välja avdelning',
    manageDepartments: 'Hantera avdelningar i grupp',
    createDepartmentGroup: 'Skapa ny avdelningsgrupp',
    noSelectedDepartments: 'Inga valda avdelningar',
    selectedDepartments: 'Valda avdelningar ({{count}})',
    selectAllFor: 'Välj alla för {{name}}',
    departmentGroup: 'Avdelningsgrupp',
    name: 'Namn',
    deleteConfirm: 'Är du säker på att du vill radera den här avdelningsgrupp?',
    edit: 'Ändra avdelningsgrupp',
    type: 'Typ',
    types: {
      DEFAULT: 'Standard',
      FOLLOW_UP: 'Uppföljning',
      INVOICING: 'Fakturering',
      PLANNING: 'Planering',
      PREADVICE: 'Avisering',
      REGION: 'Region',
      SEARCH: 'Sök'
    }
  },
  deliveryDisplayType: {
    instant: 'Instant',
    customized: 'Anpassad'
  },
  templateRouteRules: {
    title: 'Hantera ruttregler',
    ruleName: 'Regelnamn',
    type: 'Typ',
    POSTAL_CODE: 'Postnummer',
    searchPlaceholder: 'Sök efter namn eller typ',
    createNew: 'Skapa ny regel',
    createNewRule: 'Skapa ny ruttregel',
    edit: 'Redigera',
    settings: 'Inställningar',
    assignToTemplateRoutes: 'Mallrutter',
    connectedToRule: 'kopplad till "{{name}}"',
    noTemplateRoutesInDepartment: 'Inga mallrutter tillgängliga i denna avdelning',
    templateHasNoRoutes: 'Den valda mallen har inga rutter',
    noRecurringRoutesInDepartment: 'Inga återkommande rutter tillgängliga i denna avdelning',
    template: 'Mall',
    selectTemplate: 'Välj mall',
    templateRoute: 'Mallrutt',
    selectTemplateRoutes: 'Välj mallrutter',
    assignedTemplateRoutes: 'Tilldelade mallrutter ({{count}})',
    noAssignedTemplateRoutes: 'Inga mallrutter tilldelade ännu',
    assignToRecurringRoutes: 'Återkommande rutter',
    recurringRoute: 'Återkommande rutt',
    selectRecurringRoutes: 'Välj återkommande rutter',
    assignedRecurringRoutes: 'Tilldelade återkommande rutter ({{count}})',
    noAssignedRecurringRoutes: 'Inga återkommande rutter tilldelade ännu',
    atLeastOneRule: 'Lägg till minst en postnummerregel',
    successfullyAdded: '{{name}} lades till',
    successfullyUpdated: '{{name}} uppdaterades',
    successfullyDeleted: 'Ruttregeln raderades',
    deleteRule: 'Radera ruttregel',
    deleteRuleDescription: 'Är du säker på att du vill radera den här ruttregeln?',
    serviceExclusion: 'Tjänsteuteslutning',
    serviceExclusionDescription: 'Ordrar med någon av dessa tjänstekoder tilldelas aldrig rutter av denna regel.',
    serviceCode: 'Tjänstekod',
    addServiceCode: 'Lägg till tjänstekod',
    excludedServices: 'Uteslutna tjänster',
    noExcludedServices: 'Inga tjänster uteslutna',
    serviceCodeRequired: 'Ange en tjänstekod',
    serviceCodeAlreadyExcluded: '{{code}} är redan utesluten',
    removeServiceCode: 'Ta bort {{code}}'
  },
  menu: {
    distributionMapping: 'DIP-koppling',
    manageRouteRules: 'Hantera ruttregler',
    defaultDisabled: 'Välj ett kundnummer för att visa det här menyalternativet',
    home: 'Hem',
    planner: 'Trafikplanerare',
    volumeReport: 'Volymrapporter',
    openSearch: 'Öppna sök',
    report: 'Rapporter',
    customer: 'Kund',
    apiOrder: 'Sök (GLOW Order)',
    support: 'Support',
    priceMotor: 'Prismotor',
    departments: 'Avdelningar',
    users: 'Användare',
    customers: 'Kunder',
    customerGroups: 'Kundgrupper',
    numberSeries: 'Nummerserie',
    jobsMonitoring: 'Jobbövervakning',
    holidays: 'Högtider',
    shd: 'SHD',
    settings: 'Inställningar',
    preadvice: 'Avisering',
    cms: 'CMS',
    userRoles: 'Användarroller',
    integrations: 'Integrationer',
    live: 'Live',
    routePlanning: 'Ruttplanering',
    dispatching: 'Trafikledning',
    booking: 'Bokning',
    h2Booking: 'H2 Bokning',
    setCoordinates: 'Sätt koordinater',
    pickupOrders: 'Upphämtningsordrar',
    billingOrder: 'Faktureringsorder',
    shipments: 'Sändningar',
    corrections: 'Korrigeringar',
    units: 'Enheter',
    couriers: 'Chaufförer',
    vehicles: 'Fordon',
    recurring: 'Återkommande',
    importExport: 'Import / Export',
    addresses: 'Adresser',
    invoicing: 'Fakturering',
    manageReturns: 'Hantera returer',
    preAdviceFollowup: 'Hantera föravisering',
    optimizing: 'Optimering',
    services: 'Tjänster',
    matrix: 'Matris',
    vendors: 'Leverantörer',
    backToOldShipmentsPage: 'Tillbaka till den gamla sidan.',
    mainNavigation: 'Huvudmenyn',
    closePanel: 'Stäng panelen',
    expandPanel: 'Expandera panel',
    goToHomepage: 'Gå till startsidan',
    admin: 'Administration',
    productionTimeWindow: 'Produktionstidsfönster',
    routesOverview: 'Ruttöversikt'
  },
  planner: {
    colorPicker: 'Färgväljare',
    canLogIn: 'Kan logga in',
    chooseYourDepartment: 'Välj din avdelning',
    unassignedShipments: 'Oanvisade försändelser',
    filterCustomers: 'Filtrera kunder',
    filterServices: 'Filtrera tjänster',
    autoRoute: 'Automatisk rutt',
    saved: 'Sparad',
    allUserRoles: 'Alla användarroller',
    userRolesCount_other: '{{count}} användarroller',
    createNewUser: 'Skapa ny användare',
    userRolesCount: '{{count}} användarroll',
    role: 'Roll',
    searchForNameOrNumber: 'Sök efter namn eller telefonnummer',
    noPlannersFound: 'Inga planerare hittades',
    typeOfRole: 'Typ av användarroll',
    selectUserRole: 'Välj användarroll',
    secondTab: 'Andra fliken',
    users: 'Användare',
    connectDepartment: 'Koppla avdelning till användare',
    autoRouteModal: {
      selectRoutes: 'Välj rutter',
      selectRoutesText:
        'Välj rutter att inkludera i automatisk ruttplanering. Endast rutter med status Skapad eller Tilldelad är tillgängliga. För rutter som redan pågår, använd Lägg till rutt för att dispatcha sändningar.',
      routesStartedRemoved: '{{routes}} har startat och togs bort från urvalet',
      routesStartedRemoved_other: '{{routes}} har startat och togs bort från urvalet',
      lockAllToSlot: 'Lås alla tilldelade sändningar till rutten',
      useMapAreaRestrictions: 'Använd kartområdesbegränsningar',
      usePostalCodeRestrictions: 'Använd postnummerbegränsningar',
      useGraphHopper: 'Använd GraphHopper',
      usePtv: 'Använd PTV',
      usePtvPilot: 'Premiumoptimering',
      useKardinal: 'Använd Kardinal',
      useHere: 'Använd HERE',
      useHexaly: 'Använd Hexaly',
      useHexalyCloud: 'Använd Hexaly Cloud',
      timeLimitInSeconds: 'Tidsgräns i sekunder',
      timeLimitByStops: 'Tomt: baserat på planens storlek',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Ange hela sekunder mellan 10 och 2700 (45 minuter)',
      timeLimitExample: 't.ex. 60',
      useNoEngine: 'Använd ingen optimeringsmotor för den här rutten',
      optimizeOn: 'Optimera efter',
      noRelevantRoutes: 'Inga relevanta rutter hittades',
      startAutomaticRouting: 'Starta automatisk ruttplanering',
      selectOptimizingEngine: 'Välj optimeringsmotor',
      useFlexAndForceFromPrevious: 'Använd flex och tvingad ordning från tidigare optimeringar'
    },
    wait: 'Vänta',
    trips: 'Resor',
    searchSlotCourierName: 'Sök rutt-/chaufförsnamn',
    banner: {
      tryNewRoutePlanner:
        'Från och med 1 maj blir <0>ruttplanerare 2.0</0> den enda tillgängliga ruttplaneraren. Om du inte har använt ruttplaneraren tidigare rekommenderar vi att du börjar använda den redan nu. <1>Läs mer på Zendesk</1> och i andra relaterade artiklar för att få en överblick över hur den fungerar.'
    },
    createdBy: 'Skapad av',
    totalTitle: 'Kollin',
    pickList: 'Plocklista',
    export: 'Exportera för fakturering',
    deleteSlot: 'Radera',
    editSlot: 'Ändra',
    deleteSlotConfirmDialogText: 'Är du säker på att du vill radera rutten?',
    deleteFilteredSlots: 'Radera alla rutter',
    deleteAllSlotsConfirmDialogText: 'Är du säker på att du vill ta bort alla rutter?',
    created: 'Trafikplanerare skapad',
    updated: 'Trafikplanerare uppdaterad',
    deleted: 'Trafikplaneraren har raderats',
    confirmDelete: 'Är du säker på att du vill radera denna användare?',
    live: 'Live',
    removeDepartment: 'Ta bort avdelning {{name}}',
    youMustProvideName: 'Du måste ange användarens namn',
    youMustProvidePhonenumber: 'Du måste ange telefonnummer',
    showInGoogleMaps: 'Visa rutt i Google Maps',
    detailedAccessRights: 'Detaljerade behörigheter för {{name}}',
    routePlanning: 'Ruttplanering',
    vehicles: 'Fordon',
    routePlanningConsignmentsAssigned: 'tilldelad',
    routePlanningRangeDescription: 'Filtrera sändningar på leveranstid',
    unresolvedConsignments: 'Obekräftad',
    consignments: 'Sändningar',
    couriers: 'Chaufförer',
    units: 'Enheter',
    invoicing: 'Fakturering',
    planner: 'Trafikplanerare',
    planners: 'Trafikplanerare',
    noPlanners: 'Inga trafikplanerare',
    missingId: 'Id saknas',
    missingName: 'Namn saknas',
    search: 'Sök',
    searchForPlanner: 'Sök efter trafikplanerare',
    name: 'Namn',
    phoneNumber: 'Telefonnummer',
    selectDepartments: 'Välj avdelning',
    createSlot: 'Skapa rutt',
    editSlotForm: 'Ändra rutt',
    routeUpdated: 'Ruttdetaljer uppdaterade',
    createSlotFormName: 'Ruttnamn',
    createSlotFormUnit: 'Enhet',
    createSlotFormCourier: 'Chaufför',
    createSlotFormSlotMode: 'Ruttalternativ',
    createSlotFormSlotModePickup: 'Rita upphämtningsområde på karta',
    createSlotFormSlotModeDelivery: 'Ruta leveransområde på karta',
    createSlotFormSlotModeManual: 'Välj sändningar manuellt',
    createSlotFormSlotModeSelected: 'Välj sändningar',
    createSlotFormTimeRange: 'Tidsintervall',
    createSlotFormStartLocation: 'Startplats',
    createSlotFormEndTime: 'Sluttid',
    createSlotFormEndLocation: 'Slutplats',
    createSlotFormSlotColor: 'Ruttfärg',
    createSlotFormTimeRangeTooBig: 'Tidsintervallet är för stort. Maximalt tidsintervall är {{hours}} timmar.',
    createSlotFormFilterCustomers: 'Filtrera kunder',
    createSlotFormFilterServices: 'Filtrera tjänster (ingen markerad = alla)',
    slotFilterInfo:
      'Den här rutten har filtrerats, vilket betyder att bara sändningar som tillhör de valda kunderna och tjänsterna kan kopplas till rutten.',
    slotFilteredCustomer: 'Rutten innehåller BARA sändningar från följande kunder',
    slotFilteredService: 'Rutten innehåller BARA sändningar från följande tjänster',
    onlyShowApplicable: 'Visa bara sändningar som kan kopplas till den här rutten baserat på kund- och tjänstefilter',
    optimizeButtonLabel: 'Optimera och skapa rutter',
    optimizeSlotButtonLabel: 'Omoptimera rutt',
    reversedOptimizeSlotButtonLabel: 'Omvänd leveransordning',
    optimizingSince: 'Optimering pågår, startad {{startTime}}',
    addToRoute: 'Lägg till rutt...',
    pickup: 'Upphämtning',
    delivery: 'Leverans',
    depot_call: 'Planerat stopp',
    slot: 'Rutt',
    notAssigned: 'Inte tilldelad',
    readOnly: 'Normal (enbart lästillgång)',
    normal: 'Normal',
    plus: 'Utökade rättigheter',
    partner: 'Partner',
    readOnlyAccessPlannersWithCount: '{{count}} trafikplanerare med endast läsrättigheter',
    plusPlannersWithCount: '{{count}} trafikplanerare med utökade rättigheter',
    normalPlannersWithCount: '{{count}} trafikplanerare med normala rättigheter',
    saveTemplate: 'Spara som mall',
    loadTemplate: 'Ladda från mall',
    routeListForFilteredSlots: 'Kvittenslista (skriv ut alla)',
    loadListForFilteredSlots: 'Lastlista (skriv ut alla)',
    sendPrePickupSmsesToAll: 'Förhandsskicka spårningssms',
    alertBeforeSendingPrePickupSms: 'Är du säker på att du vill förhandsskicka spårnings-SMS för alla rutter för idag?',
    newTemplate: 'Skapa ett ny mall',
    selectTemplate: 'Välj mall',
    deleteTemplate: 'Radera',
    templateDeleteConfirm: 'Är du säker på att du vill radera mallen?',
    missingDeliveryMarker: 'Inte en giltig leveransplats',
    missingPickupMarker: 'Inte en giltig upphämtningsplats',
    assignConsignmentFromSlot: 'Tilldela sändning till {{routeName}}?',
    unassignConsignmentFromSlot: 'Ta bort {{count}} sändning från rutt?',
    unassignConsignmentFromSlot_other: 'Ta bort {{count}} sändningar från rutt?',
    unassignBulkConsignmentsFromSlotsAlert: 'Ta bort försändelser från respektive rutt?',
    unassignedFromSlot: 'Sändningen har tagits bort från rutten',
    unassignBulkConsignmentsFromSlots: 'Sändningarna är nu borttagna från respektive rutt',
    unassignButton: 'Ta bort från rutt',
    forceUnassignButton: 'Tvingad borttagng från rutt',
    driverName: 'Chaufför',
    deliveries: 'Leveranser',
    returns: 'Returer',
    installations: 'Installationer',
    curbside: 'Leverans till trottoarkant',
    label: 'Etikett',
    filters: {
      assigned: 'Tilldelade',
      unassigned: 'Inte tilldelade',
      pickups: 'Upphämtningar',
      deliveries: 'Leveranser'
    },
    saveSelected: 'Spara utvalda ({{count}})',
    showSaved: 'Visa sparade ({{count}})',
    showAll: 'Visa alla',
    clearSaved: 'Rensa sparade',
    sendPrePickupSms: 'Förhandsskicka Spårnings-SMS till mottagare',
    sendSms: 'Skicka SMS',
    sendingSmsText: 'Skickar {{count}} spårnings-SMS',
    prePickupSmsSent: '{{sentCount}} av {{totalCount}} SMS förhandsskickade',
    manualDelaySms: {
      smsSent: '{{count}} manuella försenat-SMS skickade',
      heading: 'Manuella försenat-SMS',
      sendingSmsText: 'Skickar {{count}} manuella försenat-SMS',
      selectSmsDescription:
        'SMS kommer börja med "Hej, din leverans från Avsändare är tyvärr försenad". Välj avslut på SMS:et nedan.',
      selectSmsEnding: 'Välj hur SMS:et ska avslutas',
      selectSmsBeginning: 'Välj hur SMS:et ska börja',
      previewLabel: 'Förhandsgranskning av SMS',
      buttonTitle: 'Skicka',
      beginningType: {
        hi: '"Hej!"',
        none: 'Ingen',
        fromSender: '"Din leverans från avsändaren är tyvärr försenad."',
        highDemand: '"På grund av hög belastning kan ditt gods inte levereras som planerat."'
      },
      endingType: {
        none: 'Ingen',
        soon: '"Vi försöker leverera så snabbt som möjligt."',
        tomorrow: '"Vi försöker leverera nästa dag."',
        whenShipmentHasArrived: '"Ett nytt leveransdatum och tidsfönster skickas när sändningen har nått terminalen."',
        newDeliveryTime: '"Vi levererar detta till dig nästa tillgängliga leveransdag."',
        newDeliveryTimeFullEnding:
          '"Ny leverans är bokad [DATE] [TIMESLOT]. Du kan ändra leveranstid via [TRACKINGLINK]. Hälsningar Bring"'
      },
      disabledTooltip: 'Sändning kan ej vara i status levererad'
    },
    delayedShipmentNotification: {
      description:
        'Mottagaren får ett SMS om att sändningen är försenad och att ett nytt leveransdatum och tidsfönster skickas när sändningen har nått terminalen.',
      resetDescription:
        'När du bekräftar återställs de valda sändningarna och tas bort från rutten om de är tilldelade.',
      gScanDescription:
        'Efter att terminalankomst har registrerats meddelas mottagaren igen enligt preadvice-reglerna.',
      successMessage: 'Flödet för försenad sändning startades'
    },
    rescheduledShipmentNotification: {
      description: 'Leveransen kommer att flyttas till ett nytt datum och ny tid.',
      autoUpdateDescription:
        'Mottagaren får ett SMS om att leveransen inte kommer att anlända idag som planerat. Meddelandet innehåller också det nya datumet och tidpunkten, samt en länk där de kan ändra leveransen om det behövs.'
    },
    h2: { booking: 'H2 Bokning', vasHelperText: 'Använd VAS 1158 för MBH' },
    loadList: {
      address: 'Adress',
      customerRef: 'Kundreferens',
      date: 'Datum',
      deliveries: 'Leveranser',
      distance: 'Distans',
      estimatedLoadTime: 'ELT',
      estimatedTotalTime: 'Ber. tid',
      header: 'Ruttöversigt',
      instructions: 'Leveransinstruktioner,\ntelefon,\nmottagarref.',
      instructionsPhone: 'Tel:',
      instructionsRef: 'Mottagarref.:',
      listName: 'Lastlista',
      name: 'Namn',
      qty: 'Ant',
      routeName: 'Rutt',
      service: 'Tjänst\n(VAS)',
      stopOrder: 'Stoppordn.',
      summary: 'Summering',
      time: 'Tid',
      timeWindow: 'Tidsfönster (ETA-ETD)',
      tripNumber: 'Resa',
      totalDistance: 'Total distans',
      totalTime: 'Total tid',
      unit: 'Enhet',
      volume: 'Vol\nm³',
      weight: 'Vikt\nkg',
      zipArea: 'Område',
      zipCode: 'Postnummer',
      unknownRouteName: 'Okänt Ruttnamn',
      unknownUnitName: 'Okänt enhetsnamn',
      noDataText: 'Inget att se här',
      utilization: 'Beläggning'
    },
    locationList: { listName: 'Lokationslista' },
    assignedUnits: 'Tilldelade enheter',
    unassignedUnits: 'Ej tilldelade enheter',
    noUnitSelected: 'Ingen enhet har valts',
    unitAssignmentCount: 'Enhet tilldelad till {{count}} rutter',
    breakDeletedFromRoute: 'Pausen har tagits bort från rutten',
    favouriteDepartments: 'Favoriter',
    addFavouriteDepartment: 'Lägg till favorit: {{department}}',
    removeFavouriteDepartment: 'Ta bort favorit: {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'Den valda avdelningsgruppen {{departmentGroup}} har för många rutter och kan inte användas på {{page}}. Välj en annan avdelningsgrupp eller avdelning.'
    }
  },

  updateServiceLevel: {
    menuItem: 'Ändra servicenivå',
    selectOption: 'Välj servicenivå',
    heading: 'Ändra servicenivå',
    confirmation: 'Servivenivå uppdaterad',
    subtext: 'Ändra servicenivå för {{count}} sändning',
    subtext_other: 'Ändra servicenivå för {{count}} sändningar',
    failed: {
      title: 'Misslyckades med att ändra servicenivån',
      message: 'Misslyckades med att ändra servicenivå för {{count}} sändning',
      message_other: 'Misslyckades med att ändra servicenivå för {{count}} sändningar'
    }
  },
  manualPreAdvice: {
    menuItem: 'Manuel preadvisering',
    selectOption: 'Välj preadviseringstyp',
    heading: 'Manuel preadvisering',
    confirmation: 'Manuel(la) preadvisering(ar) lagrat',
    subtext: 'Manuel preadvisering för {{count}} sändning',
    subtext_other: 'Manuel preadvisering för {{count}} sändningar',
    failed: {
      title: 'Lagrande av preadvisering(ar) Misslyckades',
      message: 'Lagrande av preadvisering misslyckades för {{count}} sändning',
      message_other: 'Lagrande av preadvisering misslyckades för {{count}} sändningar'
    }
  },
  setPickupDeliveryDuration: {
    menuItem: 'Ändra tider vid upphämtning och leverans',
    heading: 'Ändra tider vid upphämtning och leverans',
    subtext: 'Ändrar tider vid upphämtning och leverans för {{count}} sändning',
    subtext_other: 'Ändrar tider vid upphämtning och leverans för {{count}} sändningar',
    pickupPreparation: 'Förberedelse upphämtning',
    pickupDuration: 'Stopptid vid upphämtning',
    deliveryPreparation: 'Förberedelse leverans',
    deliveryDuration: 'Stopptid vid leverans',
    confirmation: 'Tider vid upphämtning och leverans uppdaterade',
    validationError: 'Ogiltig tid. Maximalt antal minuter och sekunder är 59',
    description:
      'Ange förberedelse och stopptid för upphämtning och leverans för valda beställningar. Det maximala antalet minuter och sekunder är 59.'
  },
  importExportOrders: {
    importOrdersHeading: 'Importera ordrar',
    importStatus: 'Det finns för närvarande {{imports}} importer i kö med totalt {{orders}} ordrar',
    exportForInvoice: 'Exportera för fakturering',
    fileTemplateLink: 'Ladda hem Excel-mall',
    uploadFile: 'Importera ordrar',
    uploadingMessage: 'Ladda upp filen och importera sändningarna...',
    testDataWarning: 'Använd inte persondata i testmiljön',
    testDataInfo: 'Det här är en testmiljö, och du får inte använda persondata från kunder utan deras tillåtelse.',
    fromDate: 'Från datum',
    toDate: 'Till datum',
    fromDateNotAfterToDate: "Kan inte vara senare än 'Till datum'",
    toDateNotBeforeFromDate: "Kan inte vara tidigare än 'Från datum'",
    removeControlColumns: 'Ta bort kontrollkolumner',
    importResults: 'Importresultat',
    fileName: 'Filnamn',
    processedAt: 'Behandlad tidpunkt',
    createdShipmentId: 'Skapad sändningsnummer',
    date: 'Datum',
    exportShipments: 'Exportera sändningar',
    createLabels: 'Skapa fraktsedlar',
    selectSlot: 'Välj rutt',
    all: 'Alla',
    types: {
      SHIPMENT_EXPORT: 'Exportera sändningar',
      COURIER_WORK_REPORT: 'Arbetsrapport för chaufförer',
      COURIER_WORK_REPORT_EXTENDED: 'Utökad arbetsrapport för chaufförer',
      END_OF_DAY_REPORT: 'Dagsslutsrapport',
      SOCIAL_CONTROL: 'Social kontrolldata',
      LOCATION_LIST: 'Platslista',
      ORDER_EXPORT: 'Ordrar',
      ORDER_DEVIATION_EXPORT: 'Ordrar (Avvikta)',
      ORDER_EXPORT_ANONYMOUS: 'Ordrar (Anonymiserad data)',
      ORDER_PARTNER_EXPORT: 'Orders (För partners)',
      DEVIATION_EVENTS: 'Avvikelsehändelser',
      OPTIMIZATION_RESULTS: 'Optimeringsresultat',
      FINANCIAL_REPORT: 'Ekonomisk rapport'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Exportera sändningar',
      COURIER_WORK_REPORT: 'Arbetsrapport för chaufförer',
      COURIER_WORK_REPORT_EXTENDED: 'Utökad arbetsrapport för chaufförer',
      END_OF_DAY_REPORT: 'Dagsslutsrapport',
      SOCIAL_CONTROL: 'Exportera sociala kontrolldata',
      LOCATION_LIST: 'Exportera platslista',
      ORDER_EXPORT: 'Exportera Ordrar',
      ORDER_DEVIATION_EXPORT: 'Exportera ordrar',
      ORDER_EXPORT_ANONYMOUS: 'Exportera ordrar',
      ORDER_PARTNER_EXPORT: 'Exportera ordrar',
      DEVIATION_EVENTS: 'Exportera avvikelsehändelser',
      OPTIMIZATION_RESULTS: 'Exportera optimeringsresultat',
      FINANCIAL_REPORT: 'Exportera ekonomisk rapport'
    },
    exportFailed: 'Misslyckades med att exportera data',
    selectExportLabel: 'Välj vad du vill exportera',
    allOrders: 'Alla Ordrar',
    deviatedOrders: 'Avvikta Ordrar',
    selectFile: 'Välj fil',
    jobList: {
      title: 'Tidigare exporter',
      content: 'Innehåll',
      created: 'Skapad',
      user: 'Användare',
      dates: 'Datum',
      download: 'Ladda ner',
      exporting: 'Exporterar...',
      downloading: 'Laddar ner...',
      inQueue: 'I exportkö',
      exportFailed: 'Exporten misslyckades',
      updated: 'Uppdaterad',
      previousImports: 'Tidigare importer',
      fileName: 'Filnamn',
      numberOfOrders: 'Antal order',
      imported: 'Importerad',
      viewOrders: 'Visa order',
      lastImports: 'Visar de senaste {{count}} importerna'
    },
    exportStartedNotification: 'Export startad',
    exportStartedNotificationMessage: 'Din rapport kommer att vara tillgänglig så snart den har behandlats.',
    exportFailedNotification: 'Exporten misslyckades, försök igen senare',
    refreshData: 'Uppdatera data i befintlig rapport',
    refreshDataDescription:
      'Välj det här alternativet om du redan har skapat en befintlig rapport för de specifika datumen',
    exportDescriptions: {
      SHIPMENT_EXPORT: '',
      COURIER_WORK_REPORT: '',
      COURIER_WORK_REPORT_EXTENDED: '',
      END_OF_DAY_REPORT:
        'Använd den här rapporten för att se daglig ruttstatistik, inklusive driftskostnader och intäkter.',
      SOCIAL_CONTROL: '',
      LOCATION_LIST: '',
      ORDER_EXPORT:
        'Om du vill använda datan i en test-miljö rekommenderar vi att använda valet "Ordrar (Anonymiserad data)',
      ORDER_DEVIATION_EXPORT:
        'Om du vill använda datan i en test-miljö rekommenderar vi att använda valet "Ordrar (Anonymiserad data)',
      ORDER_EXPORT_ANONYMOUS: 'Kan användas om datan ska importeras i en test-miljö.',
      ORDER_PARTNER_EXPORT: 'Anpassad excel-fil som kan användas för att importeras i Opter.',
      DEVIATION_EVENTS: '',
      OPTIMIZATION_RESULTS: 'Anpassad Excel-fil med optimeringsresultat',
      FINANCIAL_REPORT: 'Innehåller ytterligare blad med order uppdelade efter debetrader där tillämpligt'
    }
  },
  unit: {
    unitWithCount: '{{count}} enhet',
    unitWithCount_other: '{{count}} enheter',
    new: 'Ny enhet',
    edit: 'Redigera enhet',
    addCourier: 'Lägg till chaufför',
    hideAddCourier: 'Dölj lägg till chaufför',
    requiresCourierUsers: 'Må ha minst én sjåfør',
    created: 'Enheten har skapats',
    updated: 'Enheten har uppdaterats',
    search: 'Sök efter enheter från andra avdelningar...',
    unitsInCurrentDepartment: 'Enheter i nuvarande avdelning',
    unitsInOtherDepartments: 'Enheter i andra avdelningar',
    saveUnit: 'Spara enhet',
    addCourierToUnit: 'Lägg till chaufför til enheten',
    clearSearch: 'Rensa sökning',
    noCouriersFound: 'Inga chaufförer hittades',
    addCourierToUnitSearch: 'Du kan bara söka efter chaufförer i avdelningar du har åtkomst till',
    addedCouriers: 'Tillagda chaufförer ({{count}})',
    newCourier: 'Skapa ny chaufför',
    name: 'Namn',
    unitId: 'Enhets-ID',
    couriers: 'Chaufförer',
    active: 'Aktiv',
    vehicle: 'Fordon',
    deleteQuestion: 'Ta bort enheten från den nuvarande avdelningen',
    deleteDescription: 'Enheten kan återanslutas senare om den fortfarande är kopplad till andra avdelningar',
    unassigned: 'Enheten har tagits bort från avdelningen',
    setDefaultVehicle: {
      add: 'Lägg till fordon',
      change: 'Byt fordon',
      title: 'Lägg till fordon till {{unit}}',
      selectVehicle: 'Välj fordon',
      addSuccess: 'Fordonet lades till i {{unit}}',
      changeSuccess: 'Fordonet ändrades på {{unit}}'
    }
  },
  courier: {
    isActive: 'Är aktiv',
    canLogIn: 'Kan logga in',
    secureLoginEnabled: 'BankID-inloggning',
    recipientName: 'Mottagarens namn',
    created: 'Chauffören har skapats',
    updated: 'Chauffören har uppdaterats',
    courier: 'Chaufför',
    couriers: 'Chaufförer',
    noCouriers: 'Inga chaufförer',
    courierWithCount: '{{count}} chaufför',
    courierWithCount_other: '{{count}} chaufförer',
    numberOfCouriers: 'Hittade {{number}} chaufförer',
    multipleDrivers: 'Flera chaufförer',
    missingId: 'Saknar id',
    missingName: 'Saknar namn',
    search: 'Sök efter chaufförer',
    new: 'Ny chaufför',
    edit: 'Redigera chaufför {{name}}',
    name: 'Namn',
    phoneNumber: 'Telefon',
    driverId: 'Chaufför-ID',
    capacity: 'Kapacitet',
    capacityLabel: 'Kapacitet (antal)',
    weightCapacity: 'Viktkapacitet (kg)',
    volumeCapacity: 'Volymkapacitet (m³)',
    maxRangeKm: 'Räckvidd (km)',
    color: 'Färg',
    resetColor: 'återställ färg',
    speedFactor: 'Hastighetsfaktor',
    speedFactorExplanation: 'lägre = långsammare',
    serviceTimeFactor: 'Stopptidsfaktor',
    serviceTimeFactorExplanation: 'lägre = snabbare',
    defaultStopLocation: 'Standardslutplats',
    defaultStartLocation: 'Standardstartplats',
    slotNumDeliveries: '{{count}} leverans',
    slotNumDeliveries_other: '{{count}} leveranser',
    slotNumPickups: '{{count}} upphämtning',
    slotNumPickups_other: '{{count}} upphämtningar',
    deliverPerformButtonLabel: 'Leverera',
    handoverPerformButtonLabel: 'Överlämna',
    deviationPerformButtonLabel: 'Avvik',
    deliverWithoutSignatureButtonLabel: 'Utan signatur',
    deliverWithSignatureButtonLabel: 'Signatur',
    deviateTimeWindow: 'Hann inte leverera innanför tidsfönstret',
    addressNotFound: 'Adress hittades inte',
    deliverySpotUnavailable: 'Överenskommen leveransplats är inte tillgänglig',
    deliveryAttemptNotPickedUp: 'Leveransförsök - Ej upphämtad',
    deviateNotAtHomeButtonLabel: 'Inte hemma',
    deviateLocNotFoundButtonLabel: 'Kunde inte hitta platsen',
    deviateRecipientDeclinedButtonLabel: 'Mottagaren ville inte ha det',
    deviation: {
      '7-10': 'Godset kunde inte hämtas upp på grund av ofullständig adress',
      '7-12': 'Avsändaren var inte tillgänglig. Godset har inte hämtats upp',
      '7-82': 'Godset var inte redo för upphämtning',
      'OFU-10': 'Ofullständig adress',
      'OFU-12': 'Mottagaren är inte tillgänglig',
      'OFU-82': 'Godset är inte klart för upphämtning',
      'OFU-DI': 'Inga varor för upphämtning',
      'OFU-87': 'Force majeure',
      'OFU-OCB': 'Haveri på bilen',
      'OFU-OL2': 'Inte tillräckligt med plats i bilen',
      'OFU-OS1': 'Godset skadat före upphämtning',
      'H-10': 'Ett försök har gjorts att leverera paketet, men adressen finns inte',
      'H-11': 'Ett försök har gjorts att leverera paketet, men mottagaren fanns inte på adressen',
      'H-12': 'Ett försök har gjorts att leverera sändningen, men mottagaren var inte på plats',
      'H-13': 'Ett försök har gjorts att leverera paketet, men paketet nekades av mottagaren',
      'H-07-R': 'Misslyckad social kontroll',
      'H-07-Z': 'Misslyckad social kontroll',
      'H-08-Z': 'Misslyckad ålderskontroll',
      'H-09-Z': 'Misslyckad ID kontroll',
      'VI-16-X': 'Hann inte leverera innanför tidsfönstret',
      'V-41-K': 'Sändningen är försenad och kommer att skickas så snart som möjligt',
      'V-OL2': 'Inte tillräckligt med plats i fordonet',
      'V-OL4': 'Godset hittades inte',
      'V-OL5': 'Planerad senare på samma rutt',
      '9-91': 'Avbeställd av kunden',
      'H-11-Z': 'Adress hittades inte',
      'H-BL-A': 'Överenskommen leveransplats är inte tillgänglig',
      'A-10': '$t(courier.deviation.7-10)',
      'A-12': '$t(courier.deviation.7-12)',
      'A-82': '$t(courier.deviation.7-82)',
      'V-100-CA': 'Ingen paketbox tillgänglig. Paketet levereras som hemleverans',
      'V-100-CI': 'Ingen tillgänglig lucka',
      'V-80-CI': 'Paketet överskrider tillåtna mått/vikt',
      'V-99-CI': 'Annat okänt',
      'V-AO-CI': 'Maskinen är ur funktion',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Ordern är lastad av en annan förare'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} klara',
    lockCode: 'Portkod',
    flexDelivery: 'Förenklad leverans',
    fuelType: 'Bränsletyp',
    fuelTypes: {
      gasoline: 'Bensin',
      natural_gas: 'Naturgas',
      ethanol: 'Etanol',
      electric: 'El',
      bicycle: 'Cykel',
      diesel: 'Diesel',
      rme: 'RME',
      hvo: 'HVO',
      bio_gas: 'Biogas',
      hydrogen: 'Väte'
    },
    fuelCategory: 'Bränslekategori',
    fuelCategories: {
      fossil: 'Fossilt',
      fossil_free: 'Fossilfri',
      zero_emissions: 'Utsläppsfritt'
    },
    latestLogin: 'Senaste inloggning',
    latestVersion: 'Senaste version',
    failedSocialControl: 'Misslyckad social kontroll',
    failedIdControl: 'Misslyckad ID kontroll',
    failedAgeControl: 'Misslyckad ålderskontroll',
    incompletePickupAddress: 'Ofullständig upphämtningsadress',
    custNotAvailableAtPickupAddress: 'Kunden var inte tillgänglig vid upphämtningsadressen',
    goodsNotReadyAtPickupForCust: 'Godset var inte redo för upphämtning hos kunden',
    shipmentNotAvailableAtTerminal: 'Sändningen var inte tillgänglig på terminalen',
    registrationNumber: 'Registreringsnummer',
    commercialTrafficEligibility: 'Kommersiell trafikk berettigelse',
    vehicleBrand: 'Fordonsmärke',
    vehicleModel: 'Fordonsmodell',
    vehicleControl: 'Fordonskontroll',
    vehicleControlComment: 'Kommentar gällande fordonskontroll',
    euroClass: 'Euroklass',
    alcoholDeliveryEducation: 'Alkoholleveransutbildning',
    alcoholDeliveryEducationDate: 'Genomförd utbildning',
    alcoholDeliveryEducationDateMissing: 'Datum saknas',
    alcoholDeliveryEducationDateRequired: 'Ange datumet då alkoholleveransutbildningen slutfördes',
    alcoholDeliveryEducationValidToDate: 'Giltig till {{date}}',
    alcoholDeliveryEducationExpiresDate: 'Går ut {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Utgången {{date}}',
    alcoholDeliveryEducationValidTo: 'Giltig till',
    alcoholDeliveryEducationValidToRequired: 'Ange datumet utbildningen är giltig till',
    alcoholDeliveryEducationValidToAfterEducationDate: 'Giltig till måste vara efter datumet för genomförd utbildning',
    approved: 'Godkänd',
    notApproved: 'Ej godkänd',
    couriersInCurrentDepartment: 'Chaufförer I nuvarande avdelning',
    editCourier: 'Ändra chaufför:',
    courierUserUpdated: 'Chauffören har uppdaterats.',
    courierScanEnabled: 'Skanna',
    breakDuration: 'Rastens längd (min)',
    timeWindow: 'Rastens start (tidigaste och senaste)',
    breakTimeDescription:
      'I fältet Pausens start (tidigast och senast) så väljer du vilken tid som pausen tidigast och senast kan starta. T.ex. 11.00-17.00 innebär att den senaste tiden som chauffören kan ta en paus är vid kl. 17.00',
    breakOptimizingSupportDescription:
      'Observera att endast GraphHopper har stöd för ruttoptimering med pauser. Denna funktion är inte tillgänglig vid användning av PTV.',
    noCouriersExplain: 'Vi kunde inte hitta några resultat. Försök att söka med en annan term',
    unitId: 'Enhets-ID',
    minShipmentWeightKg: 'Minsta sändningsvikt på detta fordon (kg)',
    maxShipmentWeightKg: 'Maximal sändningsvikt på detta fordon (kg)',
    canCarryPallets: 'Kan transportera pallar',
    noAvailableHatchInParcelBoxMachine: 'Ingen tillgänglig lucka',
    packageDoesNotFitInParcelBox: 'Paketet överskrider tillåtna mått/vikt',
    unknownErrorForParcelBoxDelivery: 'Annat okänt',
    errorInParcelBoxMachine: 'Maskinen är ur funktion',
    euroClassTypes: { euroEL: 'Euro EL', euro5: 'Euro 5', euro6: 'Euro 6' },
    co2: 'CO2',
    inCurrentDepartment: 'Nuvarande avdelning',
    couriersInOtherDepartments: 'Chaufförer i andra avdelningar',
    inOtherDepartments: 'Olika avdelningar',
    confirmConnect: 'Anslut chaufför till nuvarande avdelning',
    confirmModalDescription: '',
    searchForCouriers: 'Sök efter chaufförer',
    dateOfBirth: 'Födelsedatum',
    dateNotValid: 'Ogiltigt datum',
    dateOfBirthWithFormat: 'Födelsedatum (åååå-mm-dd)',
    occupationalInjuryInsurance: 'Arbetsskadeförsäkring',
    breakTime: 'Rasttid',
    between: 'Mellan',
    editBreakTime: 'Redigera rasttid',
    updateBreakTime: 'Uppdatera rasttid',
    latestBreakStart: 'Senaste raststart',
    radioButtons: { noBreakTime: 'Ingen rast', timeWindow: 'Tidsfönster', workingTime: 'Arbetstid' },
    workingTimeDescription:
      'Du ställer in den maximala arbetstiden innan föraren måste ta en rast. Till exempel";" efter 8 timmar måste föraren ta en 30 minuters ras',
    maxWorkingTime: 'Maximal tillåten arbetstid',
    selectMaxWorkingTime: 'Välj maximal tillåten arbetstid',
    hours: '{{hours}} timmar',
    breakTooltip: 'Du kan bara ha en rasttyp per enhet'
  },
  slot: {
    minutesDelay: 'minuter försenad',
    minutesAhead: 'minuter för tidig',
    minutes: 'minuter',
    time: 'Tid',
    created: 'Skapad',
    assigned: 'Tilldelad',
    lock: 'Lås',
    lockDescription:
      'När rutten är låst så kommer den inte bli en del av ny ruttoptimering och den kan inte bli ändrad.',
    toggleVisibleSlotDescription: 'Dölj rutten.',
    inProgress: 'Pågår',
    onHold: 'Pausad',
    complete: 'Avslutad',
    unknownState: 'Okänd status',
    courierSelect: 'Välj chaufför',
    unitSelect: 'Välj enhet',
    printableSlotList: 'Utskrivsvänlig ruttlista',
    followsRoute: 'Följer',
    doesNotFollowRoute: 'Avviker',
    hasLocation: 'Synlig',
    hasNoLocation: 'Osynlig',
    showActiveSlots: 'Pågående',
    showSlotNotStarted: 'Ej startade',
    showLoggedInRoutes: 'Inloggad - inte startad',
    showCompletedSlot: 'Avslutade',
    showPerfectSlot: 'Perfekta',
    filterSlots: 'Filtrera rutter',
    planningCompleted: 'Färdiga',
    completeWithLastSent: '{{label}} (senast skickad: {{time}})',
    addMapArea: 'Välj område på karta',
    editMapArea: 'Ändra område på karta'
  },
  login: {
    phone: 'Skriv in det telefonnummer du är registrerad med i GLOW med landskod (+46 ...), så skickar vi en SMS-kod',
    code: 'SMS-kod skickad, om du har en användare med det angivna telefonnumret. Koden är giltig i 5 minuter. Ange koden.',
    requestNewCode: 'Begär en ny kod',
    verifyFailed:
      'Koden eller telefonnumret är felaktigt, eller så har för många försök gjorts för att logga in, försök igen eller begär en ny kod.',
    requestFailed: 'Kunde inte skicka kod, försök igen..',
    verifyTokenButton: 'Verifiera kod',
    requestTokenButton: 'Skicka kod',
    passwordWrong: 'Felaktigt lösenord',
    customer: 'Jag är en kund',
    forgotPassword: 'Glömt ditt lösenord?',
    tryApp: 'Prova den nya appen!',
    appDownload: 'Ladda hem den nya chaufförsappen här och få tillgång till ännnu fler funktioner!',
    appInfo:
      'Är du en chaufför med Android-telefon? Ladda hem chaufförsappen <1>här</1> och få tillgång till ännu fler funktioner!',
    webApp: 'Webapp',
    note: 'Notera! Använd bara webbversionen om du av någon anledning inte kan använda apparna för iOS och Android',
    resendToken: 'Skicka kod igen',
    heading: 'Logga in',
    privacyLink: 'Integritetspolicy',
    submitPassword: 'Skicka lösenord',
    loginAsCustomer: 'Logga in som kund',
    loginAsPlanner: 'Logga in som planerare ',
    loginAsPartnerOrPhoneNumber: 'Logga in som partner',
    loginWithPhoneNumber: 'Logga in med telefonnummer',
    loginUsingSSO: 'Logga in med Posten-konto',
    partnerLoginTitle: 'Inloggning med telefonnummer är för partner',
    partnerLoginBody:
      'Endast partneranvändare kan logga in med telefonnummer. Som Glow- och Bring-anställd, använd <pageLink>den här sidan</pageLink>.',
    ssoLoginFailed: 'Inloggningen misslyckades. Kontakta Posten och Brings servicedesk om problemet kvarstår.',
    token: 'Kod',
    password: 'Lösenord',
    tokenRequired: 'Kod är obligatorisk',
    forgotPasswordDescription:
      'För att fortstätta så behöver du ange ett lösenord. Vi kommer att skicka ett mail till dig med en länk för att ställa in detta. Om du har en annan mail än den registrerade i Glow så behöver du kontakta en administratör för att ändra den.',
    sendEmailDescription:
      'För att fortsätta behöver vi din mail. Vi skickar en bekräftelselänk till den angivna adressen. Med den här länken kan du ställa in ditt tvåfaktorslösenord.',
    emailFormatValidation: 'Mailaddressen behöver vara i ett korrekt format',
    sendEmailSuccess: 'Mailet kommer till din inkorg inom kort',
    sendEmailFailed: 'Skicka e-post misslyckades, försök igen',
    setYourPassword: 'Ställ in ditt lösenord',
    sendEmail: 'Skicka mail',
    passwordsDontMatch: 'Lösenorden matchar inte',
    passwordNotMeetRequirements: 'Lösenordet uppfyller inte kraven',
    passwordRequired: 'Lösenord är obligatoriskt',
    newPassword: 'Nytt lösenord',
    repeatPassword: 'Upprepa ditt lösenord',
    lowercaseLetter: 'En liten bokstav (gemen)',
    uppercaseLetter: 'En stor bokstav (versal) ',
    numberCharacter: 'En siffra',
    minimumCharacters: 'Minst 15 tecken ',
    passwordDescription: 'Du kan nu ange ditt lösenord. Lösenordet behöver innehålla följande'
  },
  error: {
    '404Title': 'Sidan hittades inte',
    '404Message': 'Vi kunde inte hitta sidan du letar efter',
    '500Message': '{{error}} - Tyvärr kan vi inte hitta din information... vi försöker igen om en minut...',
    title: 'Något gick fel!',
    dateRequiredWhenSecureLogin: '*Obligatoriskt fält om BankID är aktiverat',
    dateNotValid: 'Ogiltigt datum',
    dateCannotBeInFuture: 'Datumet kan inte vara i framtiden',
    dateCannotBeInThePast: 'Datumet kan inte vara i förfluten tid',
    dateCannotBeOlderThanMonths: 'Datumet kan inte vara äldre än {{months}} månader',
    dateOutsideRange: 'Datum utanför giltigt intervall',
    errorMessage: 'Vi ber om ursäkt! Det här gick inte som planerat, men utvecklarna har fått information om felet.',
    errorClickToReload: 'Klicka här för att ladda om sidan',
    phoneNumber: 'Du måste ange ett giltigt telefonnummer, t.ex. +47 12345678',
    phoneNumberPrefix: 'Du måste ange en landskod, t.ex. +47 ...',
    notAValidAlphaNumeric: 'Måste vara siffror och/eller bokstäver',
    notAValidDate: 'Måste vara ett giltigt datum (åååå-mm-dd)',
    notAValidTime: 'Måste vara en giltig tid (hh:mm)',
    notAValidDuration: 'Måste vara en giltig tid (mm:ss)',
    notAValidZipCode: 'Måste vara ett giltigt postnummer',
    notAValidPostalCodeRange: "'Från postnummer' måste vara mindre än eller lika med 'Till postnummer'",
    notAValidTimezone: 'Måste vara en giltig tidszon. Prova "Europe/Oslo" eller liknande',
    somethingWentWrong: 'Något gick fel.',
    somethingWentWrongOnTheServer: 'Något gick fel på servern...',
    andMoreErrors_one: 'och {{count}} fel till',
    andMoreErrors_other: 'och {{count}} fel till',
    notAValidNumber: 'Inte ett giltigt nummer',
    somethingWentWrongWithTheRequest: 'Något gick fel med frågan till servern...',
    somethingWentWrongWithTheResponse: 'Något gick fel med svaret från servern...',
    selectAtLeastOne: 'Du måste välja minst ett av alternativen',
    requiredBreakDuration: 'Du måste ange rastens varaktighet',
    notAValidTimeWindow: 'Den tidigaste raststarten måste vara före den senaste',
    timeInWrongFormat: 'Tiden är inte giltig',
    invalidEmail: 'Du måste ange en giltig e-postadress, t.ex. name@gmail.com',
    requiredEarliestStartBreak: 'Du måste ange tidigaste raststart',
    requiredLatestStartBreak: 'Du måste ange senaste raststart',
    requiredIfWorkingTimeDuration: 'Du måste ange maximal arbetstid',
    invalidUrlParameterCombination: 'Denna kombination av URL-parametrar är ogiltig och sidan kan inte visas',
    numberCannotContainDecimals: 'Numret får inte innehålla decimaler',
    selectAtLeastOneItem: 'Välj minst ett objekt',
    mustSelectDepartment: 'Du måste välja en avdelning',
    mustSelectRoute: 'Du måste välja en rutt',
    mustProvideLabel: 'Du måste ange {{label}}',
    sizeMustBeAnIntegerGreaterThanZero: 'Storleken måste vara ett tal utan decimaler som är större än eller lika med 1'
  },
  loading: 'Vi laddar din information...',
  newAppVersion: 'GLOW blev precis lite bättre, vi laddar nu den senaste versionen.',
  loadingReceiptList: 'Kvittenslista genereras…',
  invoicing: { departmentInvoicingInProgress: 'Fakturering pågår...' },
  months: {
    january: 'Januari',
    february: 'Februari',
    march: 'Mars',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'Augusti',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December'
  },
  weekdays: {
    monday: 'Måndag',
    tuesday: 'Tisdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lördag',
    sunday: 'Söndag'
  },
  weekdaysShort: {
    sunday: 'Sön',
    monday: 'Mån',
    tuesday: 'Tis',
    wednesday: 'Ons',
    thursday: 'Tor',
    friday: 'Fre',
    saturday: 'Lör'
  },
  notifications: {
    dismiss: 'Stäng',
    dismissAll: 'Stäng alla',
    dismissAllNotifications: 'Avfärda alla aviseringar?',
    error: 'Fel',
    reload: 'Ladda om sidan',
    reloadCourier: 'Klicka här för att ladda om sidan',
    navigate: 'Gå till sidan',
    networkError: 'Det verkar vara nätverksproblem (som kan vara tillfälliga), men sidan borde laddas om.',
    networkErrorCourier: 'Du har varit offline, ladda om sidan.',
    liveUpdatesPaused: 'Liveuppdateringar pausade',
    liveUpdatesDescription:
      'Liveuppdateringar pausades medan fliken var inaktiv. Klicka för att ladda om och tillämpa de senaste uppdateringarna.'
  },
  modals: {
    preplan: {
      create: 'Förplanera sändning',
      change: 'Ändra förplanerad chaufför',
      shipmentInfo: 'Förplanera sändning {{shipmentId}} ({{pickupName}} till {{deliveryName}})',
      pickDriver: 'Välj en chaufför..',
      unpreplan: 'Ta bort planering',
      preplan: 'Förplanering',
      error: 'Sändningen kunde inte förplaneras',
      notification: {
        preplanned: 'Förplanerad',
        unpreplanned: 'Förplanering borttagen',
        preplannedMessage: 'Sändningen förplanerades till {{courierId}}',
        unpreplannedMessage: 'Förplaneringen togs bort'
      }
    },
    maps: {
      save: 'Spara',
      cancel: 'Ångra',
      delete: 'Radera',
      editMode: 'Ändra',
      mapArea: '{{routeName}} kartområde',
      saved: 'Sparat',
      deleted: 'Raderad'
    }
  },
  grid: {
    columns: {
      addressWashRecipientId: 'Mottagar ID',
      addressWashAddressId: 'Adress ID',
      department: 'Avdelning',
      deadline: 'Tidsfrist',
      failedReason: 'Felmeddelande',
      exceptions: 'Uppehåll',
      dispatchAsGroup: 'Dispatch som grupp',
      name: 'Namn',
      senderName: 'Avsändarens namn',
      puearly: 'PU',
      pulate: 'PU',
      delearly: 'LEV',
      dellate: 'LEV',
      vas: 'VAS',
      zip: 'Postnr',
      type: 'Typ',
      estimated: 'Beräknad tid',
      estimatedDepartureTime: 'ETD',
      adjusted: 'Justerad',
      timeWindow: 'Tidsfönster',
      onCar: 'på enhet',
      frequency: 'Frekvens',
      startDate: 'Startdatum',
      endDate: 'Slutdatum (valfritt)',
      from: 'Från',
      date: 'Datum',
      totalOrders: 'Antal ordrar',
      ordersInvoiced: 'Fakturerade ordrar',
      start: 'Start',
      stop: 'Stopp',
      ordersFailed: 'Misslyckade ordrar',
      to: 'Till',
      days: 'Dagar',
      holidays: 'Helger',
      startdate: 'Startdatum',
      enddate: 'Slutdatum',
      orders: 'Ordrar',
      id: 'ID',
      shipmentId: 'Sändningsnr',
      packageId: 'Kollinummer',
      errorMessage: 'Felmeddelande',
      customer: 'Kund',
      pickup: 'Upphämtning',
      delivery: 'Leverans',
      service: 'Tjänst',
      address: 'Adress',
      zipcode: 'Postnr',
      area: 'Stad',
      weight: 'Vikt',
      volume: 'Volym{{unit}}',
      bookedWeight: 'Bokad vikt{{unit}}',
      bookedVolume: 'Bokad volym{{unit}}',
      qty: 'Ant',
      preplanned: 'Förplanerad',
      preplannedRouteTemplate: 'Rutt',
      group: 'Grupp',
      finished: 'Färdiga',
      failed: 'Misslyckade',
      pickupContactPerson: 'Upphämtning kontaktperson',
      pickupPhone: 'Upphämtning telefon',
      deliveryContactPerson: 'Leverans kontaktperson',
      deliveryPhone: 'Leverans telefon',
      deliveryAddress: 'Leveransadress',
      deliveryTime: 'Leveranstid',
      contactPerson: 'Kontaktperson',
      phone: 'Telefon',
      email: 'E-post',
      deliveryReferencePlaceholder: 'Mottagarreferens',
      specificationDescriptionPlaceholder: 'Godsinformation',
      multileg: 'Multileg',
      groupName: 'Gruppnamn',
      customerNumber: 'Kundnummer',
      orderNote: 'Intern anteckning',
      returned: 'Returnerat',
      price: 'Pris',
      slotName: 'Rutt',
      estimatedArrivalTime: 'ETA',
      waitingTime: 'Väntetid',
      timeOfDelivery: 'ToD',
      timeOfPickup: 'ToP',
      deliveryEtaSmsSentAt: 'Levererings ETA SMS skickat',
      trip: 'Resa',
      addresses: {
        title: 'Adresser',
        search: 'Adresshantering',
        searchAddresses: 'Sök efter adresser',
        filterAddresses: 'Filtrera adresser',
        deleteConfirmation: 'Är du säker på att du vill radera den här adressen?',
        deleteMultipleConfirmation: 'Är du säker på att du vill radera alla valda adresser?',
        deleteSuccess: 'Adress raderad',
        deleteMultipleSuccess: 'Adresser raderade',
        delete: 'Radera',
        name: 'Namn',
        phone: 'Telefonnummer',
        address: 'Adress',
        zipArea: 'Postort',
        zipCode: 'Postnummer',
        country: 'Land',
        contactPerson: 'Kontaktperson',
        instructions: 'Instruktioner',
        deleteAddress: 'Radera adressen',
        deleteMultipleAddresses: 'Radera adresser ({{count}})',
        loc: 'Plats',
        locTitle: 'Visa på kartan'
      },
      orderGrid: { vehicleType: 'Fordonstyp', extraInfo: 'Extra information' },
      dispatch: {
        adjusted: 'Justerad',
        customerName: 'Kund',
        estimatedDepartureTime: 'ETD',
        service: 'Tjänst'
      },
      goodsType: 'Godstyp',
      orderSource: 'Orderkälla',
      postalCodes: '# postnummer',
      displayEndCustomerPriceShd: 'Visa kundpris',
      courier: 'Chaufför',
      createdBy: 'Skapad av',
      createdAt: 'Skapad',
      plannedDeliveryDate: 'Planerat datum',
      orderedDeliveryDate: 'Beställt datum',
      lastUpdatedAt: 'Senast uppdaterad',
      route: 'Rutt',
      instructions: 'Instruktioner',
      pickupDuration: 'PU stopptid',
      deliveryDuration: 'LEV stopptid',
      pickupPreparation: 'PU förberedelse',
      deliveryPreparation: 'LEV förberedelse',
      originalPickupAddress: 'Ursprunglig avsändaraddress',
      originalPickupZipCode: 'Ursprungligt avsändande postnummer',
      originalPickupZipArea: 'Ursprunglig avsändarort',
      originalPickupCountry: 'Ursprungligt avsändarland',
      originalDeliveryAddress: 'Ursprunglig leveransaddress',
      originalDeliveryZipCode: 'Ursprunglig leveranspostnummer',
      originalDeliveryZipArea: 'Ursprunglig leveransort',
      originalDeliveryCountry: 'Ursprungligt leveransland',
      packagesArrivedAtDip: 'Ankommit',
      packagesCollected: 'Upphämtad',
      packagesDelivered: 'Levererad',
      originalDeliveryEarliest: 'Urspringlig LEV',
      originalDeliveryEarliest1: 'Ursprunglig DEL 1',
      originalDeliveryLatest: 'Urspringlig LEV',
      originalDeliveryLatest2: 'Ursprunglig DEL 2',
      preAdvices: 'Preaviseringsförsök',
      preAdviceScheduledDate: 'Första preaviseringsdatum',
      hasPreAdviceSettings: 'Preaviseringsinställning',
      arrivedAtHub: 'Ankommit HUB',
      returnToSender: 'Retur till avsänder',
      preAdviceFailed: 'Misslyckades',
      deliveryAttempts: 'Leveransforsök',
      shipmentCreationDate: 'Skapandedatum för sändning',
      preAdviceResult: 'Preaviseringsresultat',
      failedPreAdviceDate: 'Datum för misslyckad preavisering',
      loadCarrierId: 'Lastbärar-ID',
      deliveryPupUnitId: 'PUP-ID',
      loadCarrier: 'Lastbärare',
      pickupZipCode: 'Upphämtningspostnummer',
      pickupArea: 'Upphämtningsområde',
      deliveryZipCode: 'Leveranspostnummer',
      deliveryArea: 'Leveransområde',
      plannedStops: 'Planerade stopp'
    },
    columnSettings: {
      header: 'Lägg till kolumner i tabellen',
      description: 'Välj den data du vill ska synas i tabellen'
    }
  },
  openBooking: {
    error: {
      pickupTimeNotWithinServiceTimeWindow: 'Upphämtningstiden ligger inte inom tjänstens tidsfönster',
      pickupTimeBeforeEarliestServicePickupTime:
        'Upphämtningstiden kan inte vara före tjänstens tidigaste upphämtningstid',
      pickupNotAvailableForWeekend: 'Upphämtning är inte tillgänglig på helger',
      invalidOrganisationNumber: 'Ogiltigt organisationsnummer'
    }
  },
  instant: {
    title: 'Trafikledning',
    openMap: 'Visa karta',
    group: 'Gruppera valda',
    editGroup: 'Redigera grupp',
    groupName: 'Gruppnamn',
    groupOrders: 'Gruppera ordrar',
    viewGroup: 'Visa grupp',
    ordersToGroup: 'Ordrar i gruppen',
    fixedOrder: 'Fast leveransordning',
    saveFixedOrder: 'Spara ordningsändringar',
    paidTogether: 'Betalas tillsammans',
    saveGroup: 'Spara grupp',
    ungroup: 'Avgruppera',
    removeSelected: 'Ta bort valda',
    split: 'Dela valda ordrar',
    noCourierSelected: 'Inga chaufförer valda',
    noOrderSelected: 'Inga sändningar valda',
    workingHours: 'Arbetstider',
    chatButton: 'Chatta med chaufför',
    offeredShipments: 'Erbjudna sändningar',
    rejectedShipments: 'Nekade sändningar',
    rejectedShipmentsSnackbar: '{{count}} nekad sändning av "{{name}}"',
    rejectedShipmentsSnackbar_other: '{{count}} nekade sändningar av "{{name}}"',
    toBeDone: 'Upphämtning och leveranser som ska utföras',
    finishedRoutePoints: 'Genomförda upphämtningar och leveranser',
    suggestedRouteApplied: 'Den föreslagna rutten har applicerats',
    suggestedRouteCancelled: 'Den föreslagna rutten har tagits bort',
    reorderValidationError: 'Den föreslagna ordningen på rutten är inte giltig',
    planSlot: 'Ruttplanera',
    createRoute: {
      vehiclePlaceholder: 'Inget fordon valt',
      title: 'Välj fordon för att skapa ny rutt',
      description:
        'Den här enheten är inte kopplad till någon rutt ännu. När de valda sändningarna läggs till på enheten skapas en ny rutt. Välj ett fordon för rutten.'
    },
    columnSettings: {
      reset: 'Återställ',
      settings: 'Inställningar',
      hideColumns: 'Visa kolumner',
      saveAndClose: 'Spara och stäng'
    },
    routePoint: { pickup: 'U', delivery: 'L', depot_call: 'PS', start: 'S', end: 'E' },
    confirmation: {
      heading: 'Orderbekräftelse',
      from: 'Från',
      to: 'Till',
      service: 'Tjänst',
      pickup: 'Upphämtning',
      delivery: 'Leverans',
      shipmentNumber: 'Sändningsnummer',
      printLabel: 'Skriv ut fraktsedel',
      copyOrder: 'Kopiera sändning',
      editOrder: 'Ändra sändning'
    },
    goods: {
      custom: 'Egen',
      letter: 'Brev',
      bag: 'Väska',
      smallbox: 'Liten låda',
      mediumbox: 'Mellanlåda',
      largebox: 'Stor låda',
      tube: 'Rör',
      quarterpallet: 'Kvartspall',
      halfpallet: 'Halvpall',
      fullpallet: 'Helpall',
      suitcase: 'Resväska',
      movingbox: 'Flyttkartong',
      trolley: 'Lastbärare',
      parcel: 'Löskolli',
      expressbox: 'Expressbox',
      '9A': 'Rullbur paket, gods',
      '9C': 'Rullbur tom',
      '9F': 'Halvpall  brev',
      '9J': 'Pall brev',
      PX: 'Pall',
      PA: 'Paket',
      AF: 'Halvpall',
      SA: 'Säck',
      CS: 'Kassett',
      '9N': 'Monsterbur, paket',
      '9O': 'Monsterbur, tom',
      '9B': 'Rullbur brev',
      '9D': 'Rullbur övrigt',
      '9E': 'Halvpall  paket, gods',
      '9G': 'Halvpall  tom',
      '9H': 'Halvpall  övrigt',
      '9I': 'Pall paket, gods',
      '9K': 'Pall tom',
      '9L': 'Pall övrigt',
      '9M': 'Brev styck',
      '9P': 'IKEA TU lång',
      '9Q': 'IKEA TU kort',
      '9Z': 'Okänd volym',
      BE: 'Bunt',
      BG: 'Påse',
      BX: 'Låda',
      CD: 'Kanna',
      CL: 'Rulle',
      CN: 'Container',
      CR: 'Back',
      CT: 'Kartong',
      CW: 'Rullbur',
      DR: 'Fat',
      ED: 'Pallåda',
      LT: 'Parti',
      OA: 'Kvartspall',
      OC: 'Sjöpall',
      OT: 'Oktabin',
      PB: 'Pallbox',
      PC: 'Paket',
      PE: 'Pall modulär',
      PI: 'Rör',
      PK: 'Kolli',
      PP: 'Styck',
      PV: 'Rörbunt',
      RK: 'Ställ',
      RO: 'Rulle',
      RV: 'Rek. värde',
      SE: 'Semitrailer',
      TY: 'Tank, cylindrisk',
      VB: 'Växelflak',
      Z1: 'Bisonpall',
      Z2: 'Blomsterbur',
      Z3: 'Bananpall',
      Z4: 'Fruktbur',
      Z5: 'Pall låg',
      Z6: 'Pall Rema',
      Z8: 'Mjölkbur',
      ZZ: 'Okänd'
    },
    instantGrid: {
      editColumnTooltip: 'Klicka för att ändra',
      deleteColumnTooltip: 'Klicka för att ta bort sändningen från enheten',
      unassignColumnTooltip: 'Klicka för att ta bort sändningen från enheten',
      dragColumnTooltip: 'Klicka och dra för att tilldela till chaufför',
      filtersActive: 'Aktiva filter',
      clearFilters: 'Ta bort alla filter',
      filterPlaceholder: 'filtrera <enter>',
      assignColumnTooltip: 'Klicka för att tilldela sändningen'
    },
    booking: {
      numberOfCopies: 'Antal kopior',
      numberOfCopiesPlaceholder: 'Fyll i ett nummer mellan {{min}} och {{max}}',
      numberOfCopiesError: 'Du måste fylla i ett nummer mellan {{min}} och {{max}}',
      afterCutoffWarning:
        'Leverans ej tillgänglig - cuttoff tid {{cutoffTime}} idag har passerat. Välj en annan tjänst eller leveransdag.',
      standaloneInvoiceCheckbox: 'Markera som fristående faktura',
      standaloneInvoiceDescription:
        'Genom att välja detta alternativ kommer denna order att behandlas individuellt och inte slås ihop med andra ordrar för fakturering.',
      addPackage: 'Lägg till nytt kolli',
      removePackageRow: 'Ta bort kolli',
      cannotRemoveLastPackageRow: 'Kan inte ta bort sista kollit',
      copyPackageRow: 'Kopiera kolli',
      title: 'Bokning',
      header: 'Bokning',
      headerCreate: 'Ny bokning',
      headerEdit: 'Ändra bokning',
      headerCopy: 'Kopiera bokning',
      headerRestore: 'Återställ bokning',
      customer: 'Kund',
      customerPlaceholder: 'Kundnummer',
      subcustomerPlaceholder: 'Underkund',
      invoiceSplitPlaceholder: 'Faktura split',
      invoiceSplitPlaceholderLegend: 'Välj faktura split',
      invalidSubcustomer: 'Subcustomer-namnet är ogiltigt',
      shipmentOrPackageId: 'Sändningsnummer eller kollinummer',
      creditBlockedCustomer: 'Kreditspärrad kund',
      sender: 'Avsändare',
      setAsDefaultAddress: 'Sätt som standardavsändare',
      setAsDefaultDisabledText: 'Koordinater saknas. Sätt adressen genom att använda adresssöket.',
      defaultAddressUpdated: 'Standardavsändare uppdaterad',
      recipient: 'Mottagare',
      pickupNamePlaceholder: 'Namn',
      pickupAddressPlaceholder: 'Adress',
      pickupZipCodePlaceholder: 'Postnummer',
      pickupZipAreaPlaceholder: 'Stad',
      pickupCountryPlaceholder: '-- Välj land --',
      pickupPhoneNumberPlaceholder: 'Telefon',
      pickupContactPerson: 'Kontaktperson',
      customerReference: 'Kundreferens',
      pickupReferencePlaceholder: 'Kundreferens - det här fältet visas på fakturan',
      pickupInformationPlaceholder: 'Upphämtningsinformation',
      pickupEmailPlaceHolder: 'E-post',
      customerContact: 'Kontaktperson hos kunden',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – det här fältet visas på fakturan',
      customerInfoPlaceholder: 'Intern kundspecifik information',
      customerInfoHelper:
        'Den här informationen är knuten till kunden. Ändringar kommer att synas internt på alla kundens ordrar.<br><br>För att lägga till orderspecifik information, använd fältet ”Anteckningar”.',
      deliveryNamePlaceholder: 'Namn',
      letterBoxPrefix: 'Brevlåda',
      letterBoxAlt: '{{operator}} brevlåda',
      deliveryAddressPlaceholder: 'Adress',
      deliveryZipCodePlaceholder: 'Postnummer',
      deliveryZipAreaPlaceholder: 'Stad',
      deliveryCountryPlaceholder: '-- Välj land --',
      deliveryPhoneNumberPlaceholder: 'Telefon',
      deliverySecondPhoneNumberPlaceholder: 'Telefon 2',
      deliveryEmailPlaceHolderPlaceholder: 'E-post',
      deliveryReferencePlaceholder: 'Mottagarreferens',
      deliveryInformationPlaceholder: 'Leveransinformation',
      orderNote: 'Intern anteckning',
      invalidInvoiceSplit: 'Ogiltig fakturadelningstext',
      clearData: 'Radera data',
      dimensions: 'Gods',
      weightPlaceholder: 'Vikt (kg)',
      lengthPlaceholder: 'Längd (cm)',
      widthPlaceholder: 'Bredd (cm)',
      heightPlaceholder: 'Höjd (cm)',
      service: 'Tjänst',
      serviceCode: 'Tjänstekod',
      servicePlaceholder: 'Tjänst',
      serviceSelect: 'Välj tjänst',
      priceDetails: 'Prisdetaljer',
      serviceSelectDisabled: 'Ändra tjänster på HD-ordrar måste göras i HappyFlow',
      deliveryOrderService: {
        description: 'Leveransorder'
      },
      goodsEditDisabled: 'Ändringar på gods på HD-ordrar måste göras i HappyFlow',
      standardServices: '-- STANDARDTJÄNSTER --',
      customizedServices: '-- KUNDUNIKA TJÄNSTER --',
      specificationDescription: 'Gods',
      specificationDescriptionPlaceholder: 'Godsinformation',
      invoiceInfo: 'Fakturainformation',
      invoiceInfoPlaceholder: 'Fakturainformation - det här fältet visas på fakturan',
      manualInvoiceInfoPlaceholder:
        'Manuell fakturahantering (om det här fältet är ifyllt med faktureringsinstruktioner, så kommer sändningen inte bli automatiskt fakturerad)',
      pickup: 'Upphämtning',
      delivery: 'Leverans',
      pickupDatePlaceholder: 'Upphämtningsdatum',
      pickupTimePlaceholder: 'Upphämtningstid',
      deliveryDatePlaceholder: 'Leveransdatum',
      deliveryTimePlaceholder: 'Leveranstid',
      deliveryContactPerson: 'Kontaktperson',
      restoreButton: 'Återställ',
      orderButton: 'Beställ',
      editButton: 'Uppdatera',
      copyButton: 'Beställ',
      created: 'Sändningen har registrerats',
      edited: 'Sändningen har uppdaterats',
      quickSelect: 'Snabbval',
      volume: 'Volym',
      points: 'Poäng',
      totalVolume: 'Total volym {{volume}}',
      totalWeight: 'Total vikt {{weight}}',
      removeItem: 'Ta bort',
      copyItem: 'Kopiera',
      addItem: 'Lägg till',
      calculatePrice: 'Beräkna pris',
      priceExplanations: {
        header: 'Prisförklaring',
        article: 'Artikel: {{article}}',
        priceListName: 'Prislistans namn: {{pricelist}}',
        explanations: 'Förklaringar',
        noInfo: 'Ingen prisinformation tillgänglig',
        details: 'Detaljer',
        notFound: 'Inga prisförklaringar tillgängliga.'
      },
      approveIncompletePrice: 'Jag godkänner alla linjer med nollpris',
      muteBomArticles: 'Exkludera {{bomArticle}} från fakturering',
      prePlan: 'Planera',
      prePlannedToCourier: 'Välj chaufför',
      prePlannedToRouteTemplate: 'Välj rutt',
      prePlannedToRouteText:
        'Tillgängliga rutter beror på de mallar som är sparade på avdelningen. För att automatisk ruttning ska fungera korrekt måste du konfigurera ruttinställningar <0>på avdelningsnivå</0> på administrationssidorna.',
      automaticDepartment: 'Automatisk',
      departmentLabel: 'Avdelning',
      notifications: 'Aviseringar',
      emailNotifications: 'E-mailaviseringar',
      eventRegistered: 'Registrerad',
      eventPickup: 'Upphämtning',
      eventDelivery: 'Leverans',
      emailAddress: 'E-mailadress',
      emailRecipientText: 'Följande e-mailadresser kommer ta emot aviseringar:',
      invalidEmail: 'Ogiltig e-mailadress',
      editIndicator: 'Ändra',
      updateIndicator: 'Uppdatera',
      copyIndicator: 'Kopiera',
      quantity: 'Kvantitet',
      additionalServices: 'Tilläggstjänster',
      paymentInformation: 'Betalningsinformation',
      paidTogetherLabel: 'Samtaxerad?',
      groupingLabel: 'Sändningsgruppering',
      groupIdPlaceholder: 'Unikt grupp-id',
      groupOrderPlaceholder: 'Ordningsföljd',
      addRecipient: 'Lägg till mottagare',
      addPickup: 'Lägg till avsändare',
      vehicleType: 'Fordonstyp',
      vehicleTypeUpdated: 'Fordonstyp uppdaterad',
      selectVehicleType: 'Välj fordonstyp',
      customerPrice: 'Kundpris',
      resourcePrice: 'Unitpris',
      priceList: 'Prislista',
      manualPrice: 'Manuellt pris',
      total: 'Totalt',
      manualInvoiceInfo: 'Manuell faktueringshantering',
      vehicleTypes: {
        car: 'Bil',
        bicycle: 'Cykel',
        truck: 'Lastbil',
        van: 'Skåpbil',
        motorcycle: 'Motorcykel',
        cargobike: 'Cargocykel'
      },
      date: 'Datum',
      unNumber: 'UN-nummer',
      hazardous: 'Klass',
      class: 'Klass',
      group: 'Grupp',
      netWeight: 'Nettovikt',
      name: 'Namn',
      restrictions: 'Restriktioner',
      totalPoints: 'Total poäng',
      unacceptableMeasurementsError:
        'Måtten är inte korrekta. Ange antingen alla dimensioner korrekt, eller ange volym för alla kollin.',
      serviceMessage: 'Kom ihåg att lägga till en kund för att se tillgängliga tjänster',
      pickupTimeEarliest: 'Tidigaste upphämtningstid',
      pickupTimeLatest: 'Senaste upphämtningstid',
      deliveryTimeEarliest: 'Tidigaste leveranstid',
      deliveryTimeLatest: 'Senaste leveranstid',
      henteordre: {
        availableTimeSlots: 'Tillgängliga tidsfönster',
        setCustomTimes: 'Ange anpassade tider',
        selectAvailableTimes: 'Välj tillgängliga tider',
        enterPickupZipCode: 'Ange upphämtningspostnummer för att se tillgängliga tidsfönster'
      },
      hazardousGoods: 'Farligt gods'
    },
    courierSorting: { title: 'Sortera på', alystraId: 'Chaufförsnummer', empty: 'Tom', full: 'Full' },
    courierFilter: {
      title: 'Filtrera chaufförer',
      all: 'Visa alla',
      inactive: 'Dölj inaktiva',
      offline: 'Dölj offline',
      both: 'Dölj inaktiva och offline'
    },
    invoicingFilter: {
      ALL: 'Visa alla',
      INVOICED_OK: 'Redan fakturerade',
      TO_BE_INVOICED: 'Ska faktureras',
      ORDER_CORRECTION: 'Med orderkorrigering',
      INVOICED_FAILED: 'Fakturering misslyckades'
    },
    shipmentFilter: {
      title: 'Filtrera sändningar',
      showAll: 'Visa alla',
      notCollected: 'Ej upphämtade',
      hideAll: 'Dölj alla'
    },
    offer: {
      carEmpty: 'Enheten är tom',
      suggestedDelivery: 'Föreslagen leveransordning',
      newShipments: 'Nya sändningar',
      manualRoute: 'Manuell ruttning',
      confirmRoute: 'Bekräfta rutt',
      assigning: 'Tilldelar',
      replanning: 'Planerar om rutt för',
      shipmentsTo: 'sändningar till',
      shipmentTo: 'sändning till'
    },
    useFlexible: 'Använd flexibel tid',
    forceOptimizing: 'Tvinga leveransordning',
    replanRoute: 'Omplanera rutten',
    recurring: {
      recurringOrderSaved: 'Återkommande uppdrag sparad',
      executeDate: 'Utförandedatum',
      confirmExecuteOrders: 'Är du säker på att du vill utföra alla återkommande uppdrag för {{date}}?',
      editRecurringOrder: 'Redigera återkommande uppdrag',
      createRecurringOrder: 'Skapa återkommande uppdrag',
      successMessage: '{{number}} har adderats till de valda grupperna',
      title: 'Återkommande',
      recurringOrders: 'Återkommande uppdrag',
      includedOrders: 'Uppdrag inkluderade i gruppen',
      details: 'Detaljer',
      editOriginal: 'Redigera original',
      copyOriginal: 'Kopiera original',
      notStarted: 'Inte startad',
      executing: 'Kör...',
      ended: 'Avslutat',
      status: 'Status',
      pending: 'Resterna',
      ok: 'OK',
      total: 'Totalt',
      failedOrders: 'Misslyckade ordrar',
      exceptionsHeading: 'Uppehåll för återkommande ordrar',
      addExceptionHeading: 'Nytt uppehåll',
      exceptionStart: 'Start',
      exceptionEnd: 'Slut',
      editExceptions: 'Redigera uppehåll',
      addRecurring: 'Återkommande',
      addToGroup: 'Välj återkommande grupp',
      exceptions: 'Uppehåll',
      recurringOrderAddedConfirmation: 'Order lagt till återkommande grupp',
      exceptionsUpdated: 'Undantag uppdaterade',
      dispatchAsGroup: 'Dispatch som grupp',
      name: 'Namn',
      frequency: 'Frekvens',
      frequencies: {
        weekly: 'Varje vecka',
        second_week: 'Varannan vecka',
        third_week: 'Var tredje vecka',
        monthly: 'Varje månad'
      },
      daysOfWeek: 'Veckodagar',
      includeHolidays: 'Inkludera helgdagar',
      endsNextDay: 'Slutar nästa dag',
      endsNextDayExplanation:
        'Endast för rutter som passerar midnatt. Starttiden är på första dagen och sluttiden dagen efter.',
      endsNextDayRequiredByShipments:
        'Avmarkera upphämtning eller leverans nästa dag på sändningarna innan du tar bort denna',
      pickupNextDay: 'Upphämtning nästa dag',
      deliveryNextDay: 'Leverans nästa dag',
      nextDayExplanation: 'Fönstret börjar på ruttens första dag. Endast senaste tid flyttas till nästa dag.',
      createBillingOrder: 'Skapa faktureringsorder',
      customerForBillingOrder: 'Kund för faktureringsorder',
      errorBeforeToday: 'Kan inte vara före idag',
      errorEndBeforeStart: 'Kan inte vara före startdatum',
      excludedDateRanges: {
        title: 'Exkluderade datum',
        add: 'Lägg till i listan',
        savedWithRoute: 'Exkluderade datum sparas när du sparar rutten',
        ongoing: 'pågår'
      },
      startDate: 'Startdatum',
      endDate: 'Slutdatum (valfritt)',
      save: 'Spara',
      fromDate: 'Från datum',
      confirmDelete: 'Är du säker på att du vill ta bort de markerade återkommande uppdragen?',
      numSelectedRoutes: '{{count}} markerade',
      deleteTemplateRoute: {
        title: 'Ta bort mallrutt',
        description: 'Den här åtgärden kan inte ångras.'
      },
      deleteTemplateRoutes: {
        title: 'Är du säker på att du vill ta bort {{count}} rutter?',
        description: 'Den här åtgärden kan inte ångras.'
      },
      rolloutTemplateRoutes: {
        title: 'Är du säker på att du vill rulla ut {{count}} rutter?',
        description: 'Rutterna rullas ut för {{date}}.',
        alreadyRolledOut: '{{count}} av rutterna är redan utrullade för {{date}}:',
        replaceWarning: 'Deras rutter och ordrar raderas och rullas ut igen. Ordrarna får nya sändningsnummer.'
      },
      from: 'Från',
      createOrders: 'Skapa uppdrag',
      showResult: 'Visa resultat',
      showRolloutResult: 'Visa utrullningsresultat',
      rolloutProblems: 'Problem med utrullning',
      rolloutProblemsFrom: 'Från föregående utrullning, {{date}}',
      rolloutProblemsHandled: 'Hanterade utrullningsproblem',
      noRolloutProblems: 'Inga utrullningsproblem under denna period',
      noOutstandingRolloutProblems: 'Alla utrullningsproblem är hanterade',
      dealtWith: 'Hanterad',
      problems: 'Problem',
      problemType: 'Problem',
      severityCritical: 'Kritisk',
      severityWarning: 'Varning',
      rangeReversed: 'Från-datumet får inte vara efter till-datumet',
      rangeTooLong: 'Perioden kan inte vara längre än {{days}} dagar',
      rangeNeedsEnd: 'För att se längre tillbaka än {{days}} dagar måste du även ange ett till-datum',
      problemRolloutFailed: 'Utrullningen misslyckades',
      problemOrderNotCreated: 'Ordern skapades inte',
      problemOrderNotOnRoute: 'Ordern finns inte på rutten',
      problemStopNotOnRoute: 'Planerat stopp finns inte på rutten',
      startdate: 'Startdatum',
      enddate: 'Slutdatum',
      orders: 'Ordrar',
      executionSummary: 'Utförandesammanfattning',
      executions: 'Utföranden',
      executionStatus: 'Utförandestatus',
      executionId: 'Utförande',
      templateShipment: 'Mallsändning',
      createdOrderId: 'Skapat order-id',
      packageIds: 'Paket-id:n',
      sentAt: 'Skickat',
      lastAttemptAt: 'Senaste försök',
      routeConnected: 'Kopplad till rutt',
      optimizationRequestId: 'Optimeringsförfrågan-id',
      failedOptimizationRequestIds: 'Misslyckade optimeringsförfrågan-id',
      routeConnectedSummary: 'Kopplad till rutt',
      onlyWithErrors: 'Endast med fel',
      rolloutResult: {
        newView: 'Ny vy',
        oldViewNotice:
          'Den här vyn tas snart bort. Den nya vyn visar problemen från detta datum och framåt, grupperade efter orsak.',
        switchToNewView: 'Byt till den nya vyn',
        earlierProblems_one: 'Det finns {{count}} ohanterat problem från utrullningen {{date}}.',
        earlierProblems_other: 'Det finns {{count}} ohanterade problem från utrullningen {{date}} och framåt.',
        showEarlierProblems: 'Visa dem',
        crumb: 'Utrullningsresultat',
        title: 'Utrullningsresultat - {{date}}',
        nothingRolledOut: 'Inget har rullats ut från detta datum',
        progress: 'Utrullningsstatus',
        showProgress: 'Visa utrullningsstatus',
        processing: 'Utrullning pågår',
        processingCount: 'Förlopp · {{processed}} av {{total}} rutter',
        done: 'Utrullning klar',
        doneCount: '{{processed}} av {{total}} rutter',
        routes: 'Skapade rutter',
        createdOrders: 'Skapade order',
        stops: 'Stopp',
        failedStops: 'Misslyckade stopp',
        orderStatus: {
          PENDING: 'Väntar',
          SENT: 'Skickad',
          CREATED: 'Skapad',
          FAILED: 'Misslyckad',
          MISSING: 'Saknas'
        },
        plannedStopStatus: {
          PENDING: 'Väntar',
          CONNECTED: 'Kopplad',
          FAILED: 'Misslyckad'
        },
        unhandled: 'Ohanterade',
        handled: 'Hanterade',
        handledToggle: 'Visa ohanterade eller hanterade problem',
        unhandledCount: 'Ohanterade problem ({{count}})',
        handledCount: 'Hanterade problem ({{count}})',
        unhandledDescription: 'Rätta felen så att nästa utrullning inte får samma fel.',
        handledDescription: 'Problem markerade som hanterade. Markera ett som ej hanterat för att få tillbaka det.',
        unhandledEmpty: 'Inga problem behöver hanteras',
        handledEmpty: 'Inga problem har markerats som hanterade',
        groupDescription:
          'När du har rättat uppgifterna, markera problemet som hanterat så försvinner det från listan.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Kundnummer saknas',
            description: 'Kunden hittades inte. Den kan ha raderats eller ändrats.'
          },
          ORDER_NOT_CREATED: {
            description: 'Ordern kunde inte skapas. Se felorsaken.'
          },
          TIME_WINDOW: {
            title: 'Tidsfönster',
            description: 'Ordern lades inte till på rutten på grund av tidsfönstret.'
          },
          MISSING_COORDINATES: {
            title: 'Koordinater saknas',
            description: 'Adressen saknar koordinater.'
          },
          CAPACITY: {
            title: 'Inte tillräcklig kapacitet i fordonet',
            description: 'Ordern fick inte plats på grund av kapacitet.'
          },
          OPTIMIZATION_FAILED: {
            title: 'Optimering misslyckades',
            description: 'Ruttoptimeringen misslyckades efter flera försök.'
          },
          ORDER_NOT_ON_ROUTE: {
            description: 'Ordern skapades men lades inte till på rutten. Orsaken är inte känd ännu.'
          },
          STOP_NOT_ON_ROUTE: {
            description:
              'Stoppet kunde inte läggas till på rutten, oftast på grund av tidsfönstret eller platsen. Rätta det på mallrutten.'
          }
        },
        filterRoutes: 'Filtrera rutter',
        allRoutes: 'Alla rutter',
        routeName: 'Ruttnamn',
        templateRoute: 'Mallrutt',
        rolledOutAt: 'Utrullad',
        handledBy: 'Markerad som hanterad av',
        selectRow: 'Välj {{route}} {{id}}',
        markAsHandled: 'Markera som hanterad',
        markAsHandledHint: 'Det försvinner från listan',
        markAsUnhandled: 'Markera som ej hanterad'
      },
      rolloutView: {
        label: 'Utrullningar',
        current: 'Gällande',
        all: 'Alla, inklusive ersatta',
        replaced: 'Endast ersatta'
      },
      replaced: 'ersatt',
      replacedAt: 'Ersatt',
      replacedBy: 'Ersatt av',
      replacesExecution: 'Ersätter utrullning',
      templateRouteId: 'Mallrutt-id',
      templateRouteName: 'Mallruttnamn',
      createdAt: 'Skapat',
      updatedAt: 'Uppdaterat',
      date: 'Datum',
      createdSlotId: 'Skapat rutt-id',
      createdBy: 'Skapad av',
      failed: 'Misslyckade',
      by: 'Av',
      on: 'den',
      reset: 'återställa',
      confirmReset: 'Vill du återställa återkommande uppdrag för {{date}}?',
      startDateExplanation: 'Uppdragen skapas samma dag som startdatumet',
      noOrderSelected: 'Inga sändningar valda',
      noOrdersFound: 'Ingen order hittad',
      groups: 'Grupper',
      routes: 'Rutter',
      newRoute: 'Ny rutt',
      recurringRoute: 'Återkommande rutt',
      tabFrequency: 'Frekvens',
      tabRoute: 'Rutt',
      tabTemplateShipments: 'Mallordrar',
      timeQuestion: 'Vilken tid ska rutten starta och sluta?',
      frequencyQuestion: 'Hur ofta vill du att rutterna ska rullas ut?',
      holidayRollout: 'Utrullning på helgdagar',
      holidayRolloutDescription:
        'Rutter rullas inte ut på helgdagar som standard. Välj detta för att ta med helgdagar i utrullningen.',
      weekdaysQuestion: 'Vilka veckodagar vill du att rutten ska leverera?',
      periodQuestion: 'När vill du att rutten ska starta och sluta?',
      routeDetails: 'Ruttdetaljer',
      searchShipments: 'Sök efter sändningar',
      editShipment: 'Ändra mallsändning',
      newTemplateShipment: 'Ny mallsändning',
      addShipments: 'Lägg till sändningar',
      saveShipment: 'Spara sändning',
      onRoute: 'På rutten',
      findYourShipmentsDescription: 'Skriv in vad du letar efter i sökfältet ovan',
      saveFrequency: 'Spara frekvensinställningar',
      saveRoute: 'Spara ruttinställningar',
      saveShipments: 'Spara sändningar på rutt',
      shipmentsAddedToRoute: 'Sändningar har lagts till på rutten',
      shipmentCopied: 'Mallförsändelse kopierad',
      routeCreated: 'Återkommande rutt skapad',
      routeUpdated: 'Återkommande rutt uppdaterad',
      editRoute: 'Redigera {{route}}',
      recurringRoutes: 'Återkommande rutter',
      selectRouteWithId: 'Välj rutt med id {{id}}',
      rolloutInfoConfigured:
        'Automatisk utrullning använder avdelningens automatiska återkommande tid {{time}} och rullar ut rutter för följande datum.',
      rolloutInfoMissing:
        'Automatisk utrullning är inte konfigurerad för denna avdelning eftersom automatisk återkommande tid är tom. Be en administratör att konfigurera detta.',
      addStop: 'Lägg till stopp',
      days: 'Dagar',
      dates: 'Datum',
      addException: 'Lägg till undantag',
      addedExceptions: 'Tillagda undantag',
      selectedOrders: 'Valda sändningar',
      moveShipment: 'Flytta sändning',
      moveShipmentModal: {
        errorMessage: 'Sändningar: {{shipmentIds}}, felmeddelande: {{error}}',
        shipmentsMovedText: 'Sändningar {{shipmentIds}}, {{stopIds}} har flyttats till rutt {{route}}',
        partialSuccessMessage: '{{count}} av {{fullCount}} sändningar flyttades',
        title: 'Flytta valda sändningar till en annan rutt'
      },
      changeRoute: 'Ändra rutt',
      viewRoute: 'Till rutt',
      plannedStops: 'Planerade stopp',
      templatePlannedStopId: 'Mall planerat stopp',
      createdPlannedStopId: 'Skapat planerat stopp',
      notRouteConnected: 'Inte på rutt'
    },
    corrections: {
      title: 'Korrigeringar',
      headline: 'Korrigeringar för {{date}}',
      accepted: 'Korrigering accepterad',
      rejected: 'Korrigering avvisad',
      approve: 'GODKÄNN',
      decline: 'AVVISA',
      shipmentId: 'Sändningsnr',
      courier: 'Enhet',
      from: 'Från',
      to: 'Till',
      details: 'Detaljer',
      pickupWaitingTime: 'Väntetid, upphämtning (min)',
      deliveryWaitingTime: 'Väntetid, leverans (min)',
      pickupLoadingTime: 'Lasttid upphämtning (min)',
      deliveryLoadingTime: 'Losstid leverans (min)',
      comment: 'Kommentar',
      weight: 'Vikt',
      volume: 'Volym',
      packages: 'Paket',
      serviceCode: 'Servicekod',
      noOrderCorrections: 'Inga orderkorrigeringar',
      minutesOutOfRangeError: 'Du måste fylla i ett nummer mellan {{min}} och {{max}}',
      timeInMinutesWarning: 'Ogiltigt tidsvärde, kontrollera om det är korrekt'
    },
    dispatch: {
      assigningMultilegDelivery: 'Tilldelar {{count}} multileg-leverans',
      assigningMultilegDelivery_other: 'Tilldelar {{count}} multileg-leveranser',
      turningThisOnExplanation: '(Om du aktiverar detta kan du åsidosätta ruttplanen)'
    },
    suggestedUnits: {
      unitName: 'Enhetsnamn',
      driverName: 'Förarens namn',
      slotName: 'Rutt',
      timeAtLocation: 'Tid på plats',
      distanceFromLocation: 'Avstånd från plats',
      shipmentInformation: 'Sändningsinformation',
      suggestedVehicles: 'Föreslagna fordon',
      suggestedVehiclesOnPickup: 'Föreslagna fordon för upphämtning',
      suggestedVehiclesOnDelivery: 'Föreslagna fordon vid leverans',
      suggestedUnits: 'Föreslagna enheter',
      noSuggestionsAvailable: 'Inga förslag tillgängliga',
      pickupTime: 'Upphämtningstid',
      deliveryTime: 'Leveranstid',
      filterBy: 'Sortera efter'
    },
    shipmentSummary: {
      unPrePlan: 'Ta bort förplanering',
      prePlanTo: 'Förplanera till'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'Detta utlämningsställe är redan kopplat till en annan DIP. Ladda om sidan för att se aktuella kopplingar.',
    ALREADY_ENQUEUED_FOR_INVOICING: 'Redan köad för fakturering',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'Ogiltigt avdelnings-ID',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE: 'Välj en mindre avdelningsgrupp eller ett kortare exportdatumintervall',
    ENTITY_DOES_NOT_EXIST: 'Enheten existerar inte',
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE:
      'Återkommande rutter kan bara rullas ut igen för ett datum efter idag',
    RECURRING_ROUTE_NOT_ROLLED_OUT: 'En vald rutt är inte utrullad för detta datum. Ladda om sidan och försök igen',
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS: 'En vald rutt rullas fortfarande ut. Vänta några minuter och försök igen',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'Rutten är redan kopplad till en annan ruttregel, uppdatera sidan och försök igen',
    INVALID_DATE_RANGE: 'Ogiltigt datumintervall',
    INVALID_DELIVERY_LATITUDE: 'Ogiltig leveranslatitud',
    INVALID_DELIVERY_LONGITUDE: 'Ogiltig leveranslongitud',
    INVALID_LATITUDE: 'Ogiltig latitud',
    INVALID_LONGITUDE: 'Ogiltig longitud',
    INVALID_OR_MISSING_TIME: 'Ogiltig eller saknad tid',
    INVALID_PHONE_NUMBER: 'Ogiltigt telefonnummer',
    DUPLICATE_PHONE_NUMBER: 'Telefonnumret finns redan registrerat!',
    DUPLICATE_PHONE_NUMBER_COURIER: 'En chaufför är redan registrerad med detta telefonnummer',
    INVALID_PICKUP_LATITUDE: 'Ogiltig upphämtningslatitud',
    INVALID_PICKUP_LONGITUDE: 'Ogiltig upphämtningslongitud',
    INVALID_SLOT_TYPE: 'Ogiltig ruttyp',
    MISSING_ADDRESS: 'Saknad adress',
    MISSING_ALYSTRA_ID: 'Saknar id',
    MISSING_AREA: 'Saknat område',
    MISSING_CAPACITY: 'Saknar kapacitet',
    MISSING_COLOR: 'Saknar färg',
    MISSING_CONSIGNMENT_INPUTS: 'Saknar sändningsinformation',
    MISSING_CONSIGNMENT: 'Saknar sändning',
    MISSING_CONSIGNMENTS: 'Saknar sändningar',
    MISSING_COURIER_ID: 'Saknar chaufförs-id',
    MISSING_COURIER: 'Du måste välja en chaufför',
    MISSING_CREATED_AT: 'Saknar skapad-datum',
    MISSING_CUSTOMER_ID: 'Saknar kundnummer',
    MISSING_CUSTOMER_REF: 'Saknar kundreferens',
    MISSING_DATE: 'Saknar datum',
    MISSING_DAYS: 'Saknar dagar',
    MISSING_DEPARTMENT: 'Saknar avdelning',
    MISSING_DESCRIPTION: 'Saknad beskrävning',
    MISSING_DEVIATION_TEXT: 'Saknar avvikstext',
    MISSING_END_LOCATION_LATITUDE: 'Saknar slutplatsens latitud',
    MISSING_END_LOCATION_LONGITUDE: 'Saknar slutplatsens longitud',
    MISSING_EVENT_DATA: 'Saknar eventdata',
    MISSING_EVENT_TYPE: 'Saknar eventtyp',
    MISSING_FILE_NAME: 'Saknar filnamn',
    MISSING_FROM_DATE: 'Saknar från-datum',
    MISSING_ID: 'Saknar id',
    MISSING_LOCATION_LATITUDE: 'Saknar platsens latitud',
    MISSING_LOCATION_LONGITUDE: 'Saknar platsens longitud',
    MISSING_LOCATION_POSITION: 'Saknar platsens position',
    MISSING_LOCATION_TIME: 'Saknar platsens tid',
    MISSING_NAME: 'Saknar namn',
    MISSING_GROUP: 'Saknar gruppering',
    MISSING_PACKAGE_ID: 'Saknar kollinummer',
    MISSING_PHONE: 'Saknar telefonnummer',
    MISSING_PLANNER_ID: 'Saknar trafikplanerar-id',
    MISSING_SERVICE_CODE: 'Saknar tjänstekod',
    MISSING_SHIPMENT_ID: 'Saknar sändningsnummer',
    MISSING_SLOT_ID: 'Saknar rutt-id',
    MISSING_SLOT_TYPE: 'Saknar slot-typ',
    MISSING_SMS_TOKEN: 'Saknar sms-kod',
    MISSING_START_LOCATION_LATITUDE: 'Saknar startpositionens latitud',
    MISSING_START_LOCATION_LONGITUDE: 'Saknar startpositionens longitud',
    MISSING_TO_DATE: 'Saknar till-datum',
    MISSING_ZIP_AREA: 'Saknar stad',
    MISSING_ZIP_CODE: 'Saknar postnummer',
    MISSING_COUNTRY_CODE: 'Saknar landskod',
    NO_SUCH_USER: 'Det finns ingen sådan användare',
    BILLING_ORDER_AMOUNT_OUT_OF_VALID_RANGE: 'Maximalt tillåten pristotal ({{limit, number}}) har överskridits',
    PARAM_NOT_OF_EXPECTED_TYPE: 'Parameterna är inte av förväntad typ',
    PARAM_NULL_NOT_ALLOWED: 'Parameter null är inte tillåten',
    PTW_ALREADY_EXISTS: 'Produktionstidsfönster finns redan för mottagar-ID {{recipientId}}.',
    QUERY_NAME_MISSING: 'Query-namn saknas',
    QUERY_PARAMS_MISSING: 'Query-parameter saknas',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: 'Användare saknas eller har felaktig roll',
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: 'Användare finns men har en annan roll',
    SLOT_CANNOT_BE_STARTED: 'Rutt kan inte startas',
    SLOT_CANNOT_BE_DELETED: 'Rutt kan inte raderas',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Chauffören tillhör inte avdelningen',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Sändningar i felaktig status och kan inte uppdateras',
    ORDER_DOES_NOT_EXISTS: 'Sändningarna finns inte',
    OPTIMIZE_ALREADY_RUNNING: 'Optimering pågår redan',
    CANNOT_CHANGE_ORDER: 'Kan inte ändra sändning',
    NO_ACCESS: 'Ingen tillgång',
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'Inga relevanta sändningar för valda rutter',
    NO_RELEVANT_CONSIGNMENTS: 'Inga relevanta sändningar för valda rutter',
    NO_RELEVANT_SLOTS: 'Endast rutter som inte har startats eller är pausade kan användas för denna optimering',
    NOT_EQUAL_PICKUP_ADDRESSES:
      'Alla hämtningsadresser måste vara lika för att begränsa alla försändelser till en förare',
    NO_SUCH_QUERY: 'Ingen sådan query',
    EXCEL_MISSING_SHIPMENT_ID: 'Saknar sändningsnummer i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Saknar kundreferens i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'Saknar kundnummer i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Saknar avdelning i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'Saknar kollinummer i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_NAME: 'Saknar namn i cell {{col}} på rad {{row}}',
    EXCEL_INVALID_PHONE: 'Saknar telefonnummer i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_ADDRESS: 'Saknar adress i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Saknar postnummer i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Saknar stad i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Saknar från-datum i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_TO_DATE: 'Saknar till-datum i cell {{col}} på rad {{row}}',
    EXCEL_INVALID_FROM_DATE: 'Från-datum kan inte vara före idag. Hittades i cell {{col}} på rad {{row}}',
    EXCEL_INVALID_TO_DATE: 'Till-datum kan inte vara före idag. Hittades i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_NOTIFICATION_SMS: 'Saknar SMS-information i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_SIZE: 'Saknar antal i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_ORDERS: 'Inga ordrar hittades i Excel-arket.',
    EXCEL_MISSING_COUNTRY: 'Saknar landsnamn eller landskod i cell {{col}} på rad {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'Ingen tillgång till avdelning "{{dept_ref}}" som hittades på rad {{row}}',
    EXCEL_MISSING_DESCRIPTION: 'Saknar beskrivning i cell "{{cell}}" på rad {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Saknar upphämtningsbeskrivning i "{{cell}}" på rad {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Saknar leveransbeskrivning i "{{cell}}" på rad {{row}}',
    EXCEL_TOO_MUCH_DATA:
      'Rapporten är för stor. Överväg att exportera för ett smalare datumintervall eller färre avdelningar.',
    MISSING_PICKUP_LOCATION_AND_TIME: 'Saknar upphämtningsplats och tid',
    MISSING_EARLIEST_PICKUP_DATE: 'Saknar tidigaste upphämtningsdatum',
    MISSING_LATEST_PICKUP_DATE: 'Saknar senaste upphämtningsdatum',
    MISSING_EARLIEST_DELIVERY_DATE: 'Saknar tidigaste leveransdatum',
    MISSING_LATEST_DELIVERY_DATE: 'Saknar senaste leveransdatum',
    INVALID_EARLIEST_PICKUP_DATE: 'Ogiltigt tidigaste upphämtningsdatum',
    INVALID_LATEST_PICKUP_DATE: 'Ogiltigt senaste upphämtningsdatum',
    INVALID_EARLIEST_DELIVERY_DATE: 'Ogiltigt tidigaste leveransdatum',
    INVALID_LATEST_DELIVERY_DATE: 'Ogiltigt senaste leveransdatum',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE:
      'Kan inte ändra beställningar som kommit in via EDI eller API med Excel-filer',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Upphämtningstid måste vara före leveranstid',
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Tidigaste leverantiden bör vara före senaste leveranstiden',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Kan inte leverera på en helgdag',
    MISSING_TEMPLATE_ID: 'Saknar mall-id',
    TEMPLATE_DOES_NOT_EXIST: 'Mall-id saknas',
    TEMPLATE_CANNOT_BE_DELETED: 'Mallen kan inte raderas',
    MISSING_TEMPLATE_SLOTS: 'Mallen saknar rutter',
    TEMPLATE_NAME_ALREADY_EXISTS: 'En mall med det här namnet finns redan',
    COURIER_ALREADY_EXISTS: 'Det finns redan en chaufför med det här telefonnumret',
    ORDER_EXIST_FOR_SERVICE: 'Kan inte radera tjänsten eftersom det finns sändningar med den här tjänsten',
    NO_SERVICE_FOUND: 'Lägg till en tjänst innan du ändrar kundmappning',
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Ta bort kundens tjänstekoppling du raderar tjänsten',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Rutten är inte i ett giltigt tillstånd för den här uppdateringen',
    GRAPHHOPPER_UNASSIGNED:
      'Kan inte tilldela alla sändningar (på grund av tid, kapacitet eller andra faktorer), detaljer: {{details}}',
    GRAPHHOPPER_REQUEST_FAILED: 'Begäran om optimering av rutten misslyckades',
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      'Senaste ankomst till leverans kan inte vara före tidigaste avresa från upphämtning - är tidsfönstret för upphämtning från tidigare idag?',
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST:
      'Den tidigaste tiden kan inte vara senare än den senaste tiden - är tiderna från tidigare idag eller tidigare dagar?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      'Tidsfönstret för upphämtning för sändning {{shipmentId}} kan inte ha passerat ({{pickupEarliest}} - {{pickupLatest}})',
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Tidsfönstret för leverans för sändning {{shipmentId}} kan inte ha passerat ({{deliveryEarliest}} - {{deliveryLatest}})',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Saknar upphämtningskoordinater för försändelse {{shipmentId}}. Vänligen åtgärda adressen via sidan 'Sätt koordinater'.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Saknar leveranskoordinater för försändelse {{shipmentId}}. Vänligen åtgärda adressen via sidan 'Sätt koordinater'.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'Gränsen för antalet förfrågningar till Graphhopper har nåtts, försök igen om en minut',
    SLOT_CANNOT_BE_EDITED: 'Rutten är inte i ett giltigt tillstånd för den här uppdateringen',
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Ogiltigt postnummer och landskod',
    INVALID_BASIC_SERVICE_CODE: 'Ogiltig tjänst',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: 'Ogiltig tidigaste upphämtnings-format',
    INVALID_PICKUP_DATE_LATEST_FORMAT: 'Ogiltig senaste upphämtnings-format',
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Ogiltig senaste leverans-format',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Ogiltig tidigaste leverans-format',
    INVALID_POSTAL_CODE: 'Ogiltigt postnummer',
    INVALID_MEASUREMENT_UNIT: 'Ogiltig måttenhet',
    MISSING_CONSIGNMENT_SET: 'Saknar sändningsset',
    MISSING_UPDATE_INDICATOR: 'Saknar uppdateringsindikator',
    MISSING_CONSIGNMENT_ID: 'Saknar sändnings-id',
    MISSING_REFERENCE_NO: 'Saknar referens-id',
    MISSING_PACKAGE: 'Saknar kolli',
    MISSING_DELIVERY_DATE_EARLIEST: 'Saknar tidigaste leveransdatum',
    MISSING_DELIVERY_DATE_LATEST: 'Saknar senaste leveransdatum',
    MISSING_CONSIGNEE: 'Saknar mottagare',
    MISSING_CONSIGNOR: 'Saknar avsändare',
    MISSING_POSTAL_CODE: 'Saknar postnummer',
    MISSING_CITY: 'Saknar stad',
    MISSING_PICKUP_DATE_LATEST: 'Saknar senaste upphämtningsdatum',
    MISSING_PICKUP_DATE_EARLIEST: 'Saknar tidigaste upphämtningsdatum',
    MISSING_CONSIGNOR_PARTY_ID: 'Saknar avsändar-id',
    INVALID_CUSTOMER_NO_MAPPING: 'Ogiltig kundnummermappning',
    INVALID_ROUTING: 'Ogiltig ruttning',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'Ingen tjänst matchar tjänstekoden',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'Ingen tjänst matchar veckodagen',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES: 'Ingen tjänst matchar upphämtnings- och leveranstiden',
    ORDER_WAS_AFTER_CUTOFF_TIME: 'Ordern lades efter deadline',
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: 'Måste ha pickup- och leveranstider',
    ORDER_CANNOT_BE_MOVED: 'Sändningen kan inte flyttas, den måste tilldelas en rutt',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Saknar avdelnings-id',
    SHIPMENT_NOT_FOUND: 'Sändningen hittades inte',
    SHIPMENT_IN_INCORRECT_STATE: 'Sändningen är redan tilldelad en rutt',
    DURATION_IS_MORE: 'Du behöver begränsa din sökning till {{maxDuration}} dagar.',
    DUPLICATE_EXCEL_IMPORT:
      'Samma filnamn har redan importerats till den här avdelningen idag. Du kan se resultaten av importen <0>här</0>. Ändra filnamnet om du vill importera igen.',
    SHIPMENT_INVALID_QUERY:
      'Under peak är vårt sök begränsat för att säkra god prestanda. Du kan söka efter alla ordrar under en dag elller lägga till en sökparameter.',
    ADDRESS_CANNOT_BE_DELETED: 'Adressen används som standardadress och kan inte raderas.',
    UNKOWN_ERROR: 'Ändringarna kunde inte sparas',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'Felaktig status eller tilldelad till rutt',
    CANNOT_MOVE_ORDERS: 'Går ej att flytta sändningar',
    DESTINATION_DEPARTMENT_INELIGIBLE: 'Avdelningen är inte tillgänglig',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: 'Avdelningen saknar adressuppgifter',
    MISSING_DELIVERY_PHONE_NUMBER: 'Telefonnummer saknas för',
    INVALID_DELIVERY_PHONE_NUMBER: 'Ogiltigt telefonnummer för',
    ROLE_IN_USE: 'Rollen kan inte tas bort eftersom rollen används.',
    INVALID_NAME: 'Rollnamnet måste vara unikt. En roll med detta namn finns redan.',
    BANNER_ALREADY_EXISTS: 'Bannernamn måste vara unikt. En banner med detta namn finns redan.',
    BANNER_NAME_TOO_BIG: 'Bannernamnet är för långt. Det får vara högst 200 tecken.',
    CMS_NEWS_ALREADY_EXISTS:
      'Namnet på uppdateringen måste vara unikt. Det finns redan en uppdatering med det här namnet.',
    CMS_NEWS_NAME_TOO_BIG: 'Namnet på uppdateringen är för långt. Det får vara högst 200 tecken',
    INVALID_CMS_NEWS_NAME: 'Ogiltigt namn på uppdatering',
    TEXT_CANNOT_BE_DELETED:
      'Texten används i en tjänst och kan inte raderas. Koppla bort texten från tjänsten för att radera den.',
    INVALID_INVOICING_STATUS: 'Ordern har en status som inte är giltig för fakturering',
    ORDER_NOT_READY_FOR_INVOICING: 'Ordern är inte redo att faktureras',
    ORDER_IS_PAUSED_FROM_INVOICING: 'Ordern är pausad från fakturering',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'Ordern är exkluderad från fakturering',
    MISSING_ORDER_CORRECTION: 'Ordern saknar en korrigering',
    INVALID_MULTILEG_STATE_FOR_INVOICING: 'Det finns order i multileg-gruppen som inte är redo att faktureras',
    DUPLICATE: 'Duplicerad data',
    MISSING_DEPARTMENT_DETAILS:
      'Avdelningen saknar område och postnummerinformation. Vänligen lägg till det innan du fortsätter.',
    INVALID_BANNER_NAME: 'Ogiltigt bannernamn.',
    INVALID_WHATS_THIS_NAME: 'Ogiltigt "Vad är detta"-modalnamn.',
    INVALID_CREDIT_ORDER: 'Kan inte kreditera en order som inte har fakturerats eller redan har krediterats.',
    OVERLAPPING_BANNERS: 'URL överlappar med en befintlig banner.',
    OVERLAPPING_WHATS_THIS_MODALS: 'URL överlappar med en befintlig "Vad är detta"-modal.',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'Inga förare är kvalificerade för beställningarna.',
    noOrdersForDateAndCourier: 'Inga beställningar finns för det valda datumet och enheten.',
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      '{{locale}}Faktureringskundnumret för typen - {{orderBillingType}} är ogiltigt',
    MISSING_ORDER_BILLING_TYPE: 'Saknad orderfaktureringstyp.',
    INVALID_ORDER_BILLING_TYPE:
      'Orderfaktureringstyp måste vara en av {{orderBillingTypes}}, men var - {{orderBillingType}}.',
    INVALID_ORDER_BILLING_INFO: 'Ogiltig orderfaktureringsinformation.',
    SMS_SERVICE_NOT_ORDERED: 'SMS-tjänst är inte beställd för.',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Mester Grønn-begravning är beställd för.',
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Tidsluckan är dirigerad i Happy Flow för.',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Servicenivån är "ingen" för.',
    SLOT_NAME_ALREADY_CREATED: 'Routnamnet finns redan.',
    ORDER_IN_INCORRECT_STATE: 'Ordern är i felaktigt tillstånd.',
    ORDER_IN_INCORRECT_STATE_other: 'Ordern är i felaktigt tillstånd.',
    INVALID_PARAMETERS: 'Ogiltiga parametrar, {{description}}.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'Webhook-prenumeration kunde inte raderas. Försök igen senare.',
    DEFAULT_ROLE_ALREADY_EXISTS: 'En annan roll {{name}} är redan standard för samma användartyp.',
    VEHICLE_IN_USE:
      'Fordonet är anslutet till enhet {{units}} och kan inte raderas. Ta bort fordonet från enheten och försök igen.',
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Endast en avdelningsmatris stöds',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Endast en cutoff-matris stöds',
    MISSING_ACCESS_TO_DEPARTMENTS: 'Du saknar åtkomst till avdelningar {{missingDepartments}}',
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      'Det kan inte finnas flera planerade stoppplatser med samma namn i en avdelning. Använd unika namn för varje planerad stoppplats.',
    AREA_PINS_TOO_CLOSE:
      'Kartpunkterna på rutten måste ligga minst {{minDistanceInMeters}} meter från varandra. Flytta dem längre isär.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'En annan återkommande rutt i den här avdelningen har samma namn. Rutter med samma namn slås ihop till en rutt när de rullas ut, så välj ett annat namn.',
    PLANNED_STOP_LOCATION_IN_USE:
      'Det går inte att redigera eller ta bort planerade stoppplatser - [{{locations}}] som redan används.',
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'Mallen kan inte tas bort eftersom den är inställd som standard för en avdelning. Ändra standardmallen för avdelningen innan du tar bort denna mall.'
  },
  customer: {
    useTerminalAddressModalHeading: 'Använd terminaladress',
    useTerminalAddressModalDescription:
      'Om du väljer "Ja" används avdelningens terminaladress när ordrar skapas. "Nej" innebär att logiken för terminaladress hoppas över.',
    settings: {
      webhook: {
        overviewTitle: 'Webhook-konfiguration',
        count: '{{count}} prenumeration',
        count_other: '{{count}} prenumerationer',
        noSubscriptions: 'Du har inga prenumerationer för tillfället',
        events: {
          prefix: 'Prenumererar på ',
          all: 'alla',
          suffix: ' händelser'
        },
        state: {
          running: 'Aktiv',
          paused: 'Pausad'
        },
        event: {
          CREATED: 'ordern är registrerad',
          ROUTE_PLANNING_COMPLETE: 'leveransrutten har fastställts',
          COLLECTED: 'chauffören har hämtat godset',
          DELIVERED: 'chauffören har levererat godset',
          DEVIATED: 'chauffören har lagt till en avvikelse på ordern',
          SCANNED: 'ordern har passerat transitterminal',
          ARRIVED_AT_TERMINAL: 'ordern har ankommit till distributionsterminal',
          DAMAGED: 'ordern har skadats',
          RETURNED: 'chauffören har lämnat tillbaka godset till terminalen',
          PICKUP_ETA_SMS_SENT: 'sms med beräknad ankomsttid för upphämtning har skickats',
          ETA_SMS_SENT: 'sms med beräknad ankomsttid för leverans har skickats',
          PRE_ADVICE_PULL_SMS_SENT: 'sms med möjliga leveransfönster har skickats',
          DELIVERY_TIME_ORDERED: 'mottagaren har valt leveranstid',
          PRE_ADVICE_PUSH_SMS_SENT: 'sms med beställt leveransfönster har skickats till mottagaren',
          PICKUP_SMS_SENT: 'sms om kommande leverans har skickats till mottagaren',
          APARTMENT_INFORMATION_UPDATED: 'mottagaren har uppdaterat leveransinformationen'
        },
        create: 'Klicka på knappen för att skapa en Webhook-konfiguration',
        delete: {
          title: 'Radera prenumeration',
          description: 'Den här åtgärden kan inte ångras',
          successfullyDeleted: 'Webhook-prenumerationen har raderats'
        },
        newOrEdit: {
          createTitle: 'Skapa ny webhook-konfiguration',
          editTitle: 'Redigera webhook-konfiguration',
          created: 'Ny webhook-konfiguration har skapats',
          updated: 'Webhook-konfigurationen har uppdaterats',
          endpoint: 'Endpoint',
          endpointDescription: 'Ange URL:en som händelsedata ska skickas till',
          httpAuthentication: 'HTTP Basic-autentisering',
          username: 'Användarnamn',
          password: 'Lösenord', // betterleaks:allow a form label, not a secret
          retryPolicy: 'Policy för återförsök',
          retryPolicyDescription: 'Om webhooken misslyckas, ange antal och fördröjning mellan återförsöken.',
          retry: '{{count}} återförsök',
          retry_other: '{{count}} återförsök',
          retryDescription: 'Antal återförsök',
          delay: {
            description: 'Fördröjning före återförsök',
            value: 'Fördröjning {{seconds}} sekunder'
          },
          pause: 'Pausa den här prenumerationen tills vidare',
          pauseTooltip: 'Händelser köas under pausen och skickas när pausen hävs.',
          validation: {
            endpointError: 'Du måste ange en giltig URL',
            endpointRequired: 'URL krävs',
            usernameRequired: 'Användarnamn krävs',
            passwordRequired: 'Lösenord krävs',
            passwordNotLongEnoughError: 'Lösenordet måste vara minst 8 tecken',
            noEventSelectedError: 'Du måste välja minst en händelse',
            retryDelayRequired: 'Fördröjning för återförsök krävs'
          }
        }
      }
    },
    returnLastLegModalHeading: 'Skapa returben',
    returnLastLegModalDescription:
      'Att välja "ja" betyder att vi delar upp beställningen i två ben och lägger till ett returben. "Nej" betyder att inget returben behöver skapas. "Ej angivet" betyder att returhanteringsregeln inte är definierad för en specifik kund.',
    connectMatrices: 'Anslut matriser',
    customerMatrices: 'Kundmatriser',
    customerMatricesIngress: 'Koppla kundnummer till befintliga matriser.',
    useTerminalAddressUpdated: 'Status för användning av terminaladress uppdaterad',
    brandedTrackingModalHeading: 'Branded Tracking fakturering',
    scanToCreatePackages: {
      title: 'Skanna för att skapa paket',
      enabled: 'Aktiverad',
      disabled: 'Inaktiverad',
      label: 'Använd skanning för att skapa paket',
      details:
        'När skanning för att skapa paket är aktiverat måste kuriren skanna paket vid upphämtning. De skannade paketen uppdateras automatiskt på försändelsen',
      success: 'Skanning för att skapa paket har uppdaterats'
    },
    invoiceSplit: {
      title: 'Fakturadelning',
      legend: 'Förklaring',
      label: 'Ange fakturadelning',
      NotSet: 'Inte inställd',
      Department: 'Avdelning',
      Service: 'Tjänst',
      Custom: 'Anpassad',
      columLabel: 'Namn',
      addedItems: 'Tillagda faktureringsregler ({{count}})',
      newItemLabel: 'Skriv in fakturadelning',
      existingItem: 'Texten finns redan. Prova att söka efter texten nedan.',
      existingItemShort: 'Texten finns redan.',
      emptyItem: 'Texten får inte vara tom.',
      updated: 'Fakturadelningen har lagts till'
    },
    activateNPSFromDate: 'Aktivera NPS från datum',
    activateNPSFromDateIngress:
      'Ange ett startdatum för att aktivera NPS (Net Promoter Score) från Medallia. Funktionen kräver att kunden även är uppsatt i Medallia.',
    npsFromDateUpdated: 'Startdatum för NPS har ändrats',
    AddEdit: 'Lägg till/redigera',
    startTypingPlaceHolder: 'Börja skriva',
    findCustomer: 'Hitta en kund',
    manageCustomers: 'Hantera kunder',
    searchAndSelect: 'Sök och välj kund',
    changeCustomer: 'Byt kund',
    customerPlaceHolder: 'Sök efter kunder',
    emailRecipients: 'E-postmottagare',
    smsRecipients: 'SMS-mottagare',
    addEditEmails: 'Lägg till/redigera e-post',
    addEditSms: 'Lägg till/redigera sms',
    addEditDeviations: 'Lägg till/redigera avvikelser',
    live: 'Live',
    customer: 'Kund',
    groups: {
      titleSingular: 'Kundgrupp',
      titleWithCount: '{{count}} kundgrupper',
      name: 'Gruppnamn',
      description: 'Beskrivning',
      numberOfCustomers: 'Antal kunder',
      none: 'INga kundgrupper',
      new: 'Ny kundgruppe',
      edit: 'Redigera kundgruppe',
      searchCustomer: 'Sök kund',
      members: 'Kunder i gruppen',
      save: 'Spara',
      deleteConfirm: 'Radera {{name}}?',
      deleteDescription: 'Du kan inte ångra den här åtgärden',
      deleted: 'Kundgruppen är raderad',
      mustProvideName: 'Du måste ange ett gruppnamn',
      cannotDelete: 'Kundgruppen kan inte raderas då den används i en aviseringsregel.'
    },
    customerTitle: 'Kunder',
    customerNo: 'Kund nr',
    name: 'Namn',
    emailToSender: 'E-post till avsändaren',
    emailSubscriptions: 'E-postprenumerationer',
    emailToSenderDescription:
      'Ange standardaviseringar för alla ordrar från detta kundnummer, till exempel orderregistrering och leveranser.',
    deviations: 'Avvikelser',
    deviationsDescription: 'Konfigurera kundspecifika avvikelser i chaufförsappen.',
    add: 'Lägg till',
    noOrders: 'Inga sändningar i Glow',
    noOrdersDescription: 'De kundnummer du har tillgång till har inga sändningar i Glow',
    choose: 'Välj en kund',
    search: 'Sök',
    customerNumber: 'Kundnummer',
    customerNumberAlreadyExists: 'Kundnumret finns redan',
    searchHint: 'Sök för sändningar baserat på sändningsnummer, kundreferens, kollinummer, mottagarnamn eller adress',
    accountingType: 'Faktureringstyp',
    accountingTags: 'Kundtaggar',
    isDeleted: 'Borttagen',
    deletedCannotBeUsed: 'Kunden är borttagen och kan inte användas. Välj en annan kund.',
    scanOnPickup: {
      title: 'Skanna kollin vid upphämtning',
      ingress: 'Aktivera om chauffören ska tvingas skanna kollin vid upphämtning.'
    },
    senderName: 'Avsändarnamn',
    senderNameIngress: 'Åsidosätt kundnamnet som är angivet i Glow när sms-aviseringar skickas.',
    addSenderName: 'Lägg till avsändarens namn',
    senderNameAdded: 'Avsändarens namn tillagt',
    addInvoiceHDOrdersFromDate: 'Lägg till startdatum från vilka fakturering av HD-order ska ske i Glow',
    invoiceHDOrdersFromDate: 'Startdatum för fakturering av HD-order i Glow',
    invoiceHDOrdersFromDateDescription: 'Ange ett datum för när Glow Pricing Engine aktiveras för HD-kunder.',
    invoiceHDOrdersFromDateAdded: 'Startdatum för fakturering av HD-order lagrat',
    billingCustomerNumber: 'Betalande kundnummer',
    billingCustomerNumberIngress: 'Åsidosätt fakturanumret om faktureringen ska ske på ett annat kundnummer.',
    addBillingCustomerNumber: 'Lägg till betalande kundnummer',
    billingCustomerNumberAdded: 'Betalande kundnummer tillagt',
    searchPage: {
      fromDate: 'Från datum',
      toDate: 'Till datum',
      today: 'Idag',
      tomorrow: 'Imorgon',
      yesterday: 'Igår',
      last30days: 'Senaste 30 dagarna',
      plusMinus15Days: '+/- 15 dagarna',
      plusMinus30Days: '+/- 30 dagarna'
    },
    smsText: {
      title: 'SMS Text',
      ingress: 'Konfigurera kundunika texter i SMS till mottagare.',
      addEditSmsText: 'Lägg till/redigera texter',
      smsTextUpdated: 'SMS-text tillagd/uppdaterad',
      en: 'ENG',
      se: 'SVE',
      no: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      fr: 'FRA',
      description: 'Beskrivning',
      smsType: 'Aviseringstyp',
      smsTypeTexts: {
        common: 'SMS',
        preadvice: 'Preavisering',
        pickup: 'Spårnings-SMS',
        pre_pickup: 'Förhandsspårnings-SMS',
        manual_delay: 'SMS om manuell försening',
        eta_pickup: 'ETA-SMS upphämtning',
        eta_delivery: 'ETA-SMS leverans',
        flex_delivery_confirmation: 'SMS-bekräftelse Flex-leverans',
        advise: 'Aviserings-SMS',
        delivery_confirmation: 'Leveransbekräftelse-SMS',
        pre_advice_push: 'Push-SMS',
        pre_advice_push_for_prebooked: 'Push-SMS för förbokade kunder',
        pre_advice_push_return: 'Push-SMS retur',
        pre_advice_push_email: 'Push-e-post',
        pre_advice_push_2nd: 'Push andra aviserings SMS',
        pre_advice_push_2nd_email: 'Push andra aviserings email',
        pre_advice_push_return_to_sender_email: 'Push retur till avsändaren email',
        pre_advice_pull: 'Pull-SMS',
        pre_advice_pull_email: 'Pull-e-post',
        pre_advice_pull_reminder: 'Pull påminnelse SMS',
        pre_advice_pull_reminder_email: 'Pull påminnelse email',
        pre_advice_pull_reminder_to_sender_email: 'Pull påminnelse till avsändaren email',
        pre_advice_pull_return_to_sender_email: 'Pull retur till avsändaren email',
        pre_advice_return: 'Returleverans-SMS',
        pre_advice_return_email: 'Returleverans-e-post',
        pre_advice_return_reminder: 'Påminnelse-SMS returleverans',
        pre_advice_return_reminder_email: 'Påminnelse-e-post returleverans',
        pre_advice_return_2nd: 'Return delivery andra aviserings SMS',
        pre_advice_return_2nd_email: 'Returleverans andra preaviserings-e-post',
        pre_advice_return_return_to_sender_email: 'Return delivery retur till avsändaren email',
        pre_advice_pup: 'PUP-SMS',
        pre_advice_pup_email: 'PUP-e-post',
        pre_advice_pup_reminder: 'PUP-påminnelse-SMS',
        pre_advice_pup_reminder_email: 'PUP-påminnelse-e-post',
        pre_advice_pup_reminder_to_sender_email: 'PUP Påminnelse till avsändaren email',
        pre_advice_pup_return_to_sender_email: 'PUP retur till avsändaren email',
        delivery: 'Leverans SMS',
        deviated: 'Leveransavvikelse-SMS',
        pre_advice_push_prebooked_recycle_sms: 'Push-SMS förbokad återvinning'
      }
    },
    showNotCollected: 'Ej upphämtade',
    booking: {
      pickupReady: 'Klar för upphämtning',
      pickup: 'Upphämtning',
      delivery: 'Leverans',
      deliveryAvailable: 'Leverans tillgänglig',
      serviceMessage:
        'Kom ihåg att lägga till både upphämtnings- och leveransinformation för att se tillgängliga tjänster',
      priceComment: 'Du kommer faktureras enligt ditt avtal med Bring. Avgifter är inte inkluderade i detta pris.',
      serviceUnavailable: 'Den valda tjänsten erbjuds inte till postnummer {{postalCode}}',
      recipientPrice: 'Mottagarpris:',
      customerContactPlaceholder: 'Beställt av – Det här fältet visas på fakturan'
    },
    email: {
      addToList: 'Lägg till e-post på listan',
      addChangesToList: 'Lägg till e-poständringar på listan',
      emailTitle: 'E-post till kund',
      getNotificationsFor: 'Få aviseringar för',
      emailAddress: 'E-postadress',
      emailAddressError: 'Du måste ange en e-postadress',
      createdEvent: 'Registrerad',
      collectedEvent: 'Upphämtning',
      deliveredEvent: 'Leverans',
      returnToSender: 'Retur till avsändare',
      reminderToSender: 'Påminnelse till avsändare',
      save: 'Spara',
      email: 'E-post',
      edit: 'Redigera',
      delete: 'Radera',
      emailExists: 'E-postadressen finns redan',
      invalidEmail: 'Ogiltig e-postadress',
      true: 'Ja',
      false: 'Nej',
      claimsReported: 'Reklamationer rapporterade av mottagare',
      claims: 'Skadeärenden',
      notificationType: {
        standard: 'Standardinformation',
        hdPreAdvice: 'HD avisering',
        reportsFromRecipients: 'Rapporter från mottagare',
        error: 'Du måste ange typ av aviseringar'
      },
      customizedNotifications: 'Anpassade aviseringar ({{count}})',
      mustAddEmailToList:
        'För att e-postadresserna ska sparas när du trycker på Lägg till inställning måste du lägga till dem på listan',
      informationToCustomer: 'Information till kund',
      returnToCustomer: 'Retur till kund',
      addEmailToList: 'Lägg till e-post på listan',
      registeredEmailSubscription: 'Registrerad e-postprenumeration',
      updateEmail: 'Uppdatera e-post',
      noRegisteredEmails: 'Inga registrerade e-postmeddelanden',
      detailsSavedSuccessfully: 'E-post till avsändare har sparats framgångsrikt'
    },
    customerDeviations: {
      new: 'Lägg till ny avvikelse',
      deviationTitle: 'Avvikelser för kund',
      addDeviation: 'Lägg till ny avvikelse',
      editDeviation: 'Redigera avvikelse',
      en: 'ENG',
      sv: 'SVE',
      nb: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      event: 'Händelse',
      reason: 'Orsak',
      action: 'Åtgärd',
      submit: 'Skicka in',
      deviationType: 'Typ av avvik',
      description: 'Beskrivning',
      code: 'Kod',
      edit: 'Redigera',
      delete: 'Radera',
      deviationAdded: 'Avvikelse tillagd',
      deviationEdited: 'Avvikelse redigerad',
      deviationExists: 'Avvikelsen finns redan',
      deviationDeleted: 'Avvikelse raderad',
      deviation: 'Avvik',
      deviationCode: 'Avvikelsekod',
      deviationCodesLabel: 'Avvikelsekoder'
    },
    customerInfo: 'Kundinformation',
    customerInformation: 'Kundinformation',
    customerName: 'Kundnamn',
    invoicingAddress: 'Fakturaadress',
    organisationNumber: 'Organisationsnummer',
    visitingAddress: 'Besöksadress',
    creditBlocked: 'Kredit spärrad',
    creditBlockedFrom: 'Kredit spärrad från datum',
    creditBlockedFromInfo: 'Spärra kredit för denna kund från det valda datumet',
    creditBlockedIngress: 'Ange sista datum för att skapa ordrar i Glow för denna kund.',
    from: 'Från',
    address: 'Adress',
    zipCode: 'Postnummer',
    zipArea: 'Plats',
    country: 'Land',
    edit: 'Redigera {{name}}',
    selectCountry: 'Välj land',
    settingsInGlow: 'Inställningar i Glow',
    addSetting: 'Lägg till inställning',
    editSetting: 'Redigera inställning',
    addNewCustomer: 'Lägg till ny kund',
    bookingPageModalHeading: 'Bokning i kundportalen',
    bookingPageModalDescription: 'Kunden ska kunna boka sändningar på detta kundnumret i kundportalen i Glow',
    bookingActive: 'På',
    bookingInactive: 'Av',
    brandedTrackingActive: 'På',
    brandedTrackingInactive: 'Av',
    brandedTrackingAccessUpdated: 'Faktureringsstatus för Branded Tracking har uppdaterats',
    brandedTrackingModalDescription: 'Aktivera för att slå på fakturering för Branded Tracking.',
    bookingPageAvailable: 'Ja',
    bookingPageHidden: 'Nej',
    customerBookingPageAccessUpdated: 'Åtkomst till bokningssidan har uppdaterats',
    returnLastLegUpdated: 'Status för sista retursträckan har uppdaterats',
    addNPSFromDate: 'Lägg till startdatum för NPS',
    bookingPage: 'Bokningssida',
    bookingPageCustomerPortal: 'Bokningssida i kundportalen',
    bookingPageIngress:
      'Stäng av bokning om kunden inte ska kunna boka sändningar på detta kundnummer i Glows kundportal.',
    returnAddressUpdated: 'Returadress uppdaterad',
    returnAddressRemoved: 'Returadress borttagen',
    returnAddressModalHeading: 'Returadress för varor',
    removeReturnAddressModalHeading: 'Ta bort nuvarande returadress',
    removeReturnAddressConfirm: 'Är du säker på att du vill ta bort den nuvarande returadressen?',
    returnAddressModalDescription: 'Ange returadressen som ska användas när varor returneras från terminalen',
    token: {
      warningDark:
        'Den här kunden är blockerad och kan inte skapa några bokningar. Avblockera för att aktivera kunden.',
      warningLight: 'Se till att kopiera API-nyckeln nu. Du kommer inte att kunna se den igen!',
      success: 'Du har redan genererat en API-nyckel för den här kunden',
      allowApiKey: 'Tillåt API-nyckel för kund',
      allowApiKeyDescription: 'Innan du genererar en API-nyckel måste du först tillåta att denna åtgärd utförs.',
      allowApiKeyButtonText: 'Tillåt API-nyckel',
      apiKeyCopied: 'API-nyckeln har kopierats',
      generateApiKeyDescription:
        'API-nyckeln är en unik nyckel per kund. Nyckeln används när din kund skapar en bokning i kundportalen. Läs mer om vårt API <0>här</0>.',
      generateApiKey: 'Generera API-nyckel'
    },
    nonInvoiceable: 'Ej faktura',
    internalNonInvoiceable: 'Intern / Kund faktureras ej'
  },
  texts: {
    tabTitle: 'Texter och översättningar',
    successfullyAdded: 'Texten har lagts till i listan',
    successfullyUpdated: 'Texten har uppdaterats',
    successfullyDeleted: 'Texten har raderats',
    allTextsAndVases: 'Lista över alla texter och översättningar',
    searchText: 'Sök efter text',
    deleteModalTitle: 'Radera text',
    deleteModalDescription: 'Den här åtgärden kan inte ångras',
    createNewText: 'Skapa ny text',
    title: 'Tjänstetexter',
    update: 'Uppdatera text',
    name: 'Textens namn',
    group: 'Gruppering',
    edit: 'Ändra',
    delete: 'Radera',
    add: 'Lägg till text',
    reset: 'Ångra',
    confirmDelete: 'Är du säker på att du vill radera texten?',
    added: 'Texten har lagts till',
    deleted: 'Texten har raderats',
    updated: 'Texten har uppdaterats',
    nameToolTip: 'Namn visas när text länkas till tjänsten'
  },
  billingType: { day: 'dag', evening: 'kväll', weekend: 'helg', weekendEvening: 'kväll på helg' },
  importExport: {
    dropText: 'Släpp filen här för att ladda upp',
    export: 'Exportera',
    exportAddresses: 'Exportera kundadresser till Excel',
    importExcel: 'Importera från Excel',
    imported: 'adresser importerade',
    or: 'eller',
    selectFile: 'Välj fil',
    uploadingFile: 'Laddar upp...'
  },
  customMeasurements: {
    name: 'Namn',
    weight: 'Vikt',
    height: 'Höjd',
    length: 'Längd',
    width: 'Bredd',
    heading: 'Egna godstyper',
    error: 'Fel när godstyp skulle sparas: ',
    confirmDelete: 'Är du säker på att du vill radera den här godstypen?',
    new: 'Skapa ny',
    customGoodsTypes: 'Egna godstyper',
    defaultGoodsTypes: 'Standardgodstyper',
    invalidName: 'Namnet måste innehålla minst en bokstav'
  },
  unresolved: {
    unresolvedAddresses: 'Obekräftad adresser',
    allResolved: 'Alla adresser är bekräftade!',
    address: 'Adress',
    noOfShipments: 'Antal sändningar',
    shipment: 'sändning',
    shipment_other: 'sändningar',
    shipmentNumber: 'Sändningsnummer',
    customerRef: 'Kundreferens',
    senderName: 'Avsändarens namn',
    senderPhone: 'Avsändarens telefonnummer',
    recipientName: 'Mottagarens namn',
    recipientPhone: 'Mottagarens telefonnummer',
    searchAndSetLocation: 'Sök och sätt adress',
    setALocationToContinue: 'Ange en adress för att fortsätta',
    resolveAddress: 'Bekräfta adress',
    suggestedAddressFound: 'Föreslagen adress hittad',
    thereIsOneUnresolvedAddress: 'Det finns {{count}} obekräftad adress',
    thereIsOneUnresolvedAddress_other: 'Det finns {{count}} obekräftade adresser'
  },
  optimizing: {
    title: 'Optimering',
    optimizingId: 'Optimerings-ID',
    reqTime: 'Tid för anrop',
    respTime: 'Tid för svar',
    showOnlyErrors: 'Visa endast fel',
    department: 'Avdelning',
    userName: 'Användare',
    graphID: 'ID',
    request: 'Anrop',
    response: 'Svar',
    error: 'Fel',
    viewReqResp: 'Visa',
    status: 'Status',
    totalTime: 'Tid',
    selectOptimizingObjective: 'Välj optimeringsmål',
    cancelRequest: 'Avbryt förfrågan',
    noOptimizations: 'Inga optimeringar för vald sökning',
    viewRaw: 'Visa rådata',
    quality: {
      STANDARD: 'Standard',
      HIGH: 'Hög',
      PREMIUM: 'Premium'
    },
    objectives: {
      completion_time: 'Minsta totala leveranstid (standard)',
      min_vehicles: 'Minsta totala antal fordon',
      work_time: 'Jämn leveranstid',
      number_of_deliveries: 'Jämnt antal leveranser',
      deliveries_and_work_time: 'Jämn arbetstid och jämnt antal leveranser'
    },
    kbSize: 'KB förfrågan',
    showAll: 'Visa alla',
    numberOfShipments: 'Antal sändningar',
    numberOfVehicles: 'Antal fordon',
    processingTime: 'Behandlingstid',
    stats: 'Statistik',
    addToCompare: 'Lägg till körning att jämföra med',
    noRunsToCompare: 'Inga andra slutförda körningar den här dagen',
    removeFromCompare: 'Ta bort från jämförelse',
    noStats: 'Ingen statistik',
    routesUsed: 'Använda rutter',
    leftOut: 'Ej planerade',
    stops: 'Stopp',
    distanceKm: 'Distans (km)',
    drivingTime: 'Körtid',
    waitingTime: 'Väntetid',
    routeTime: 'Total ruttid',
    longestRoute: 'Längsta rutt',
    type: 'Typ'
  },
  date: {
    date: 'Datum',
    today: 'Idag',
    tomorrow: 'I morgon',
    yesterday: 'Igår',
    dateAndTime: 'Datum och tid',
    from: 'Från',
    fromDate: 'Från datum',
    rangeOptions: {
      '15d': '+/- 15 dagar',
      '30d': '+/- 30 dagar',
      custom: 'Anpassade datum',
      last30d: 'Senaste 30 dagarna',
      last7d: 'Senaste 7 dagarna',
      month: 'Månad',
      months: 'Månader',
      today: 'Idag',
      tomorrow: 'Imorgon',
      yesterday: 'Igår',
      thisMonth: 'Denna månad',
      lastMonth: 'Förra månaden'
    },
    to: 'Till',
    toDate: 'Till datum'
  },
  areaSequence: {
    title: 'Sekvensområde',
    description:
      'Lägg till upp till {{max}} kartpunkter för att styra leveransordningen. Leveransen närmast varje punkt prioriteras i vald ordning, medan leveranserna mellan punkterna optimeras för den mest effektiva rutten. Detta styr ordningen men tvingar inte fram hela områden.',
    order: 'Ordning på områden',
    orderWhileEditing: 'Ordning på områden - dra korten för att ändra ordningen',
    added: '{{count}} av {{max}} områden tillagda',
    save: 'Spara område',
    unsaved: 'Spara eller ångra ändringarna i kartområdena innan du sparar rutten.',
    pin: 'Område {{number}}',
    overlap: 'Område {{number}} överlappar område {{other}}. Flytta ett av dem längre bort.',
    maxReached: 'Du kan lägga till upp till {{max}} kartpunkter.',
    tool: {
      add: 'Lägg till område',
      move: 'Flytta områden',
      delete: 'Ta bort områden'
    },
    hint: {
      add: 'Klicka på kartan för att lägga till ett område',
      move: 'Dra markören för att flytta området. Spara för att behålla ändringarna, eller Ångra för att slänga dem.',
      delete: 'Klicka på en markör för att ta bort området'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Skriv ut kvittenslista',
    noRoutesInfoAvailable: 'Ingen ruttinformation tillgänglig ännu.'
  },
  homeDeliveryRouteList: {
    receiptList: 'Kvittenslista',
    shipments: 'Sändningar',
    weight: 'Vikt',
    volume: 'Volym',
    bookedWeight: 'Bokad vikt{{unit}}',
    bookedVolume: 'Bokad volym{{unit}}',
    sender: 'Avsändare',
    package: 'Kolli',
    shipmentNo: 'Sändningsnr',
    ref: 'Ref',
    recipient: 'Mottagare',
    time: 'Tid',
    mobile: 'Mobil',
    other: 'Övrigt',
    attemptedDelivery: 'Bomkörning',
    receipt: 'Kvittens',
    dateOfBirth: 'Födelsedatum',
    signature: 'Signatur',
    nameClarification: 'Namnförtydligande',
    goodsLine1: 'Kom ihåg att kontrollera godset för synliga skador före signering.',
    goodsLine2: 'Om det finns synliga skador bör föraren registrera dem innan du som mottagare signerar.',
    damage: 'Skada',
    missing: 'Saknat',
    packageNumber: 'Kollinummer',
    comments: 'Kommentar'
  },
  columnCategories: {
    aboutTheShipment: 'Om sändningen',
    goods: 'Varor',
    timeAndDate: 'Tid och datum',
    planning: 'Planering',
    pickupInformation: 'Upphämtningsinformation',
    customer: 'Kund',
    deliveryInformation: 'Leveransinformation',
    originalSender: 'Ursprunglig avsändare',
    originalDelivery: 'Ursprunglig leverans',
    service: 'Tjänst',
    preAdvice: 'Förhandsråd',
    invoicingInformation: 'Fakturainformation'
  },
  shipment: {
    offeredOrdersPending: 'Erbjudna ordrar väntar på svar',
    shipment: 'Sändning',
    multileg: 'multileg',
    pickupLeg: 'Upphämtningsdel',
    deliveryLeg: 'Leveransdel',
    customer: 'Kund',
    customerContact: 'Kontaktperson hos kunden',
    customerReference: 'Kundreferens',
    customerNumber: 'Kundnummer',
    route: 'Rutt',
    service: 'Tjänst',
    additionalServices: 'Tilläggstjänster',
    quantity: 'Kvantitet',
    totalWeight: 'Total vikt',
    totalVolume: 'Total volym',
    totalLoadingMeters: 'Total flakmeter',
    totalPalletFootPrints: 'Total pallplats',
    goodsInfo: 'Godsinformation',
    packages: 'Paket',
    pickupInfo: 'Upphämtningsinformation',
    pickupDate: 'Upphämtningsdatum',
    pickupTime: 'Upphämtningstid',
    pickupInstructions: 'Upphämtningsinstruktioner',
    deliveryInfo: 'Leveransinformation',
    deliveryDate: 'Leveransdatum',
    deliveryTime: 'Leveranstid',
    eta: 'ETA',
    ata: 'ATA',
    receiverReference: 'Mottagarreferens',
    deliveryInstructions: 'Leveransinstruktioner',
    trackingPage: 'Spårningssida för mottagare',
    internalNote: 'Intern anteckning',
    name: 'Namn',
    address: 'Adress',
    zipCode: 'Postnummer',
    zipArea: 'Stad',
    phone: 'Telefon',
    secondPhone: 'Telefon 2',
    email: 'E-postadress'
  },
  bookingTimeWindow: {
    week: 'Vecka',
    bookButton: 'Boka',
    customButton: 'Anpassat tidsfönster',
    removeBookingButton: 'Ta bort bokning',
    noBookingYet: 'Ingen bokning ännu',
    serverError: 'Ett fel inträffade på servern. Vänligen försök igen senare..',
    previousButton: 'Föregående',
    nextButton: 'Nästa',
    noAvailableDeliveryTimes: 'Inga tillgängliga leveranstider denna månad',
    customTimeTitle: 'Välj anpassat tidsfönster för leverans',
    customDateLabel: 'Datum',
    errorEarliestNotBeforeLatest: ' Leveranstid tidigast kan inte vara före senaste',
    arrivedAtTerminal: 'Ankommit på terminal',
    bookCustomTimeSlot: 'Boka tid',
    shipmentBooked: 'Sändning bokad',
    shipmentBookedWithCustomTimeWindow: 'Sändning bokad med anpassat tidsfönster',
    updateBooking: 'Uppdatera bokning',
    bookingChanged: 'Bokningen ändrad',
    bookingSuccessful: 'Bokning genomförd',
    customTimeWindowAdded: 'Anpassat tidsfönster har lagts till',
    timeFrom: 'Tid från',
    timeTo: 'Tid till',
    timeFieldError: 'Den tidigaste leveranstiden måste vara före den senaste',
    availableTimeSlot: 'Tillgängliga tidsfönster',
    submitNotSelectedError: 'Du måste välja ett tidsfönster'
  },
  manualOverride: {
    manuallyAddEvents: 'Manuellt lägga till händelser',
    selectEvent: 'Välj händelse',
    shipmentEvent: 'Sändningshändelse',
    terminalEvent: 'Terminalhändelse',
    scannedFormDescription: 'Typ av ankomstscan triggas av vilken avdelning du väljer.',
    suggestPageReload: 'Något gick fel. Ladda om sidan och försök igen.',
    eventType: {
      delivered: 'Levererad',
      collected: 'Upphämtad',
      returned: 'Returnerad',
      deviated: 'Avvik',
      scanned: 'Skannat',
      preadvised: 'Preadvice-försök',
      'order-sorted': 'Sorterad',
      'not-arrived-at-distributing-terminal': 'Ej ankommit',
      'ready-for-pickup': 'Redo för hämtning (PUP på terminal)'
    },
    selectEventType: 'Välj en typ av event',
    noEventSelected: 'Inget event valt',
    selectManifest: 'Välj flight',
    noManifestSelected: 'Inget flight valt',
    disabledEventReason: {
      returned: ' - Avvikelse krävs',
      collected: ' - Behöver vara tilldelad rutt',
      default: ' - Ej tillåtet',
      'order-sorted': 'Endast för H2-ordrar',
      'not-arrived-at-distributing-terminal': 'Endast för HD-ordrar'
    },
    fillDeliverOrReturnEventInfo: 'Fyll i namn, datum och tid',
    fillDeviationEventInfo: 'Välj avvik och fyll i datum och tid',
    fillGeneralEventInfo: 'Fyll i datum och tid',
    eventMessage: 'Händelse skapad',
    noActiveDriverError: 'Inga aktiva chaufförer på enheten',
    allPackagesSelected: 'Alla kollin valda',
    selectPackages: 'Välj kolli',
    selectDriver: 'Välj chaufför',
    selectUnit: 'Välj enhet',
    selectDepartment: 'Välj annan avdelning'
  },
  zendesk: {
    email: 'Din e-postadress:',
    confirmEmail: 'Upprepa din e-postadress:',
    send: 'Spara',
    missingEmail:
      'För att kunna använda de nya supportsidorna måste du registrera din Posten- eller Bring-e-postadress. Du behöver bara göra det första gången.'
  },
  shipmentFormPage: {
    activeOrders: 'Aktiva order',
    deletedOrders: 'Raderade order',
    deletedOrdersDescription: 'Raderade order söks separat och kan innehålla annan information än aktiva order.',
    searchPhraseError: 'Du måste ange minst 3 tecken',
    selectStateLabel: 'Välj status',
    selectDateLabel: 'Välj datum',
    submit: 'Visa resultat',
    inputPlaceholder: 'Sök på sändningsnummer, telefonnummer, address, område, postnummer ...',
    clearButtonLabel: 'Knapp för rensa sökterm',
    allStates: 'Alla statusar',
    customDate: 'Anpassat',
    noDate: 'Inget datum',
    withoutDeliveryDate: 'Utan leveransdatum',
    selectFromDate: 'Välj från datum',
    selectToDate: 'Välj till datum',
    include: 'Inkludera',
    exclude: 'Exkludera',
    tableColumn: 'Tabell kolumn',
    condition: 'Villkor',
    searchTerm: 'Sökterm',
    tableDropdown: 'Välj tabell',
    conditionDropdown: 'Välj villkor',
    typeSearch: 'Skriv sökterm',
    typeSearchCommaSeparated: 'Skriv söktermer, separerade med komma',
    addNewRow: 'Lägg till rad',
    deleteRow: 'Ta bort rad',
    service: 'Tjänst',
    goodsDescription: 'Godsbeskrivning',
    unit: 'Enhet',
    deliveryArea: 'Leveransområde',
    deliveryZipcode: 'Leverans postnummer',
    state: '{{count}} Status',
    state_other: '{{count}} statusar',
    today: 'Idag',
    tomorrow: 'Imorgon',
    yesterday: 'Igår',
    last30Days: 'Senaste 30 dagarna',
    plusMinus15Days: '+/- 15 dagarna',
    plusMinus30Days: '+/- 30 dagarna',
    shipmentIds: 'Flera sändningar',
    advancedFilter: 'Utökat filter',
    advancedSearch: 'Avancerad sökning',
    closeAdvancedSearch: 'Stäng avancerad sökning',
    selectTable: 'Välj tabell',
    selectCondition: 'Välj villkor',
    orderId: 'Internt ordernummer',
    allAnd: 'Alla (och)',
    anyOr: 'Någon (eller)',
    customers: {
      placeholder: 'Alla kunder',
      label: 'Välj kunder'
    },
    allOrderSources: 'Alla interna orderkällor',
    orderSource: '{{count}} intern orderkälla',
    orderSource_other: '{{count}} interna orderkällor',
    vasCodes: '{{count}} tilläggstjänst',
    vasCodes_other: '{{count}} tilläggstjänster',
    vasCodesPlaceholder: 'Sök tilläggstjänst på kod eller namn',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW kundbokning',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached: 'Visar de {{limit}} senast raderade ordrarna. Begränsa din sökning.',
    noResultTitle: 'Inget resultat',
    batchLimitReached: 'Vi visar max 2000 sändningar. Begränsa din sökning',
    withoutDateLimitReached:
      'När du söker på sändningar utan datum så visar vi maximalt {{limit}} sändningar. Begränsa din sökning.',
    withoutDeliveryDateLimitReached:
      'När du söker efter sändningar utan leveransdatum visar vi högst {{limit}} sändningar. Överväg att begränsa din sökning.',
    findYourShipments: 'Hitta dina sändningar',
    findYourShipmentsDescription:
      'Skriv in vad du letar efter i sökfältet ovan. Fler alternativ finns under avancerad sökning',
    searchByShipmentIdsLimitReached:
      'Vid sökning efter sändnings-ID visar vi högst {{limit}} sändningar. Överväg att begränsa din sökning.',
    searchError: 'Sökningen misslyckades. Försök att ladda om sidan eller ändra sökparametrarna'
  },
  shipmentTable: {
    quantity: 'Antal',
    delEta: 'ETA Lev.',
    delDuration: 'Lev. varaktighet',
    delDurationTitle: 'Varaktighet för leverans (minuter)',
    delPreparation: 'Lev. förb.',
    delPreparationTitle: 'Förberedelse leverans',
    delDeliveryFrom: 'Lev. från',
    delDeliveryFromTitle: 'Tidigaste leveranstid ',
    delDeliveryTo: 'Lev. till',
    delDeliveryToTitle: 'Senaste leveranstid ',
    timeOfDelivery: 'Leveranstidpunkt',
    puDuration: 'Upph. varaktighet',
    puDurationTitle: 'Varaktighet för upphämtning (minuter)',
    puPreparation: 'Upph. förb.',
    puPreparationTitle: 'Förberedelse upphämtning',
    puPickupFrom: 'Upph. från',
    puPickupFromTitle: 'Tidigaste upphämtningstid ',
    puPickupTo: 'Upph. till',
    puPickupToTitle: 'Senaste upphämtningstid ',
    timeOfPickup: 'Upphämtningstidpunkt ',
    timeFrom: 'Tid från',
    timeFromTitle: 'Tidigaste stopptid',
    timeTo: 'Tid till',
    timeToTitle: 'Senaste stopptid',
    delEtaTitle: 'Estimerad leveranstid',
    recipientRef: 'Mottagarereferens',
    loading: 'Laddar …',
    pickupName: 'Upphämtningsnamn',
    deliveryName: 'Leveransnamn',
    pickupColumn: 'Upphämtning: {{column}}',
    deliveryColumn: 'Leverans: {{column}}',
    selectAllOnPage: 'Markera allt på sidan ({{count}})',
    selectAll: 'Markera allt ({{count}})',
    deselectAll: 'Avmarkera',
    numSelectedShipments: '{{numSelected}} markerade',
    createLabels: 'Skapa fraktsedel',
    yourSearchResult: 'Ditt sökresultat',
    numberOfShipmentsFound: '{{count}} sändningar hittades',
    orderedDeliveryDate: 'Beställt leveransdatum',
    vendorInvoice: 'Leverantörsfaktura',
    customerInvoice: 'Kundfaktura'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Ta bort sändning?',
    confirmDuplicateTitle: 'Duplicera sändning?',
    confirmDuplicateButton: 'Duplicera',
    deleteSuccess: 'Sändningen har tagits bort',
    manuallyPreAdviceSuccess: 'Manuel preadvisering lagrat för sändning',
    manuallyPreAdviceSuccess_other: 'Manuel preadvisering lagrat för sändningar',
    confirmDeleteTitle_other: 'Ta bort sändningar?',
    deleteSuccess_other: 'Sändningen  togs bort framgångsrikt',
    invoiceActions: 'Fakturaåtgärder',
    shipmentActions: 'Sändningsåtgärder',
    showInvoicePayloadDisableTooltip: 'Sändningen måste ha faktureringsstatus misslyckad eller OK'
  },
  moveDepartmentModal: {
    errorMessage: 'Order: {{orderIds}}, fel: {{error}}',
    ordersMovedText: 'Ordern har flyttats till avdelning {{department}}',
    errorMessage_other: 'Ordrar: {{orderIds}}, fel: {{error}}',
    ordersMovedText_other: 'Ordrarna har flyttats till avdelning {{department}}',
    partialSuccessMessage: '{{count}} av {{fullCount}} sändningar har flyttats',
    title: 'Flytta markerade sändningar till en annan avdelning'
  },
  updateDeliveryTimeBulk: {
    menuItem: 'Ändra leveransdatum och tid',
    heading: 'Ändra leveransdatum och tid',
    buttonTitle: 'Ändra och avisera',
    smsDescription:
      'Mottagarna får ett SMS med nytt leveransdatum och nytt tidsfönster, samt en länk där de kan ändra leveranstiden.',
    successMessage: '{{count}} sändning har uppdaterats',
    successMessage_other: '{{count}} sändningar har uppdaterats',
    notNotified:
      'Inget SMS har skickats för {{shipmentIds}} - mottagaren saknar giltigt telefonnummer eller giltig e-postadress',
    notNotified_other:
      'Inget SMS har skickats för {{shipmentIds}} - mottagarna saknar giltigt telefonnummer eller giltig e-postadress',
    disabledTooltip: 'Leveranstiden kan bara ändras innan sändningen är tilldelad en rutt',
    dateInPast: 'Leveransdatumet kan inte vara tillbaka i tiden',
    invalidDate: 'Ogiltigt datum'
  },
  sendManualDelaySmsModal: {
    errorMessage: '{{error}} {{shipmentIds}}',
    partialSuccessMessage: '{{count}} av {{fullCount}} SMS har skickats',
    successMessage: 'Manuellt försenings-SMS har skickats'
  },
  sendPrePickupSmsModal: {
    successMessage: 'Förhandsspårnings-SMS har skickats',
    'return-order': 'Ordrarna får inte vara returordrar',
    'invalid-state': 'Ordrarna måste ha status Tilldelad rutt'
  },
  multistopModal: {
    title: 'Gruppinformation',
    description: 'Gruppvy för sändningar som betalas tillsammans.',
    debitLines: 'Orderrader',
    notFound: 'Ingen gruppinformation hittades',
    shipmentId: 'Sändningsnummer',
    deliveryDate: 'Leveransdatum',
    stopAddress: 'Stoppadress',
    postalCode: 'Postnummer',
    noPrice: 'Ingen prisinformation tillgänglig för denna grupp',
    priceUpdated: 'Gruppens priser har uppdaterats'
  },
  shipmentDetails: {
    notFoundTitle: 'Sändningen hittades inte',
    notFoundDescription: 'Den kan ha raderats.',
    overview: 'Översikt',
    details: 'Detaljer',
    orderInformation: 'Orderinformation',
    volumeAndWeight: 'Volym och vikt',
    references: 'Referenser',
    goods: 'Gods',
    contactInformation: 'Kontaktinformation',
    pickupContactInformation: 'Kontaktinformation för upphämtning',
    deliveryContactInformation: 'Kontaktinformation för leverans',
    eventWasAdded: 'Händelse har lagts till',
    issueSaving: 'Det uppstod ett problem vid sparandet',
    noSelectedPackages: 'Inga paket är markerade',
    pickupAndDelivery: 'Upphämtning och leverans',
    whereIsTheOrder: 'Var är sändningen?',
    communicationToRecipient: 'Kommunikation till mottagaren',
    yesPremium: 'Ja, premium',
    alerts: 'Varningar',
    pickupDeliveryInfo: 'Upphämtning- och leveransinformation',
    quickEdit: 'Snabbredigering',
    quickEditTitle: 'Ändra upphämtning- och leveransinformationen',
    aboutShipment: 'Om sändningen',
    mapLinkText: 'Visa kartkoordinater',
    copyShipment: 'Kopiera sändning',
    editShipment: 'Ändra sändningsinformationen',
    location: 'Plats',
    time: 'Tid',
    selectDate: 'Välj datum',
    manualChangeEvent: 'Ändra händelse manuellt',
    disabledEventReason: {
      returned: 'Avvikelse krävs',
      collected: 'Behöver vara tilldelad rutt',
      default: 'Ej tillåtet'
    },
    selectDeviation: 'Välj avvik',
    required: 'Obligatoriskt',
    allPackages: 'Alla paket',
    packages: 'Paket',
    package: 'paket',
    changeDepartment: 'Ändra avdelning',
    moveDepartment: 'Flytta avdelning',
    shipmentMoved: 'Sändning flyttad',
    shipmentMovedText: 'Sändning {{shipmentId}} har flyttats till avdelning  {{department}}',
    shipmentMovedGoBack: 'Gå tillbaka till söksidan',
    shipmentCouldNotBeMoved: 'Sändningen kunde inte flyttas',
    moveShipmentDescription:
      'Om du inte har tillgång till avdelningen så kommer du inte kunna söka upp sändningen efter flytten',
    moveShipmentConfirmText: 'Flytta sändning till en annan avdelning? ',
    addShipmentToSlot: 'Lägg till sändning på {{slot}}?',
    changeSlotConfirm: 'Ändra rutt för sändningen till {{slot}}?',
    changeSlot: 'Ändra rutt',
    selectSlot: 'Välj rutt',
    AddToSlot: 'Lägg till på rutt',
    optimisationInProgress: 'Optimering pågår. Du kan inte ändra rutten medan den optimeras.',
    removeFromSlot: 'Ta bort från rutt',
    removeShipmentFromSlot: 'Ta bort sändning från rutt',
    removeShipmentFromSlotHeading: 'Ta bort sändning från denna rutt?',
    successRemoveFromSlot: 'Sändningen har tagits bort från rutten',
    successChangeSlot: 'Sändningen bytte rutt',
    successAddToSlot: 'Sändning har lagts till på rutten',
    changeSlotDescription: 'Byte av rutt görs utan ruttoptimering.',
    addToSlotDescription: 'Den valda rutten kommer att optimeras utan att de existerande sändningarna ändrar ordning',
    pickupOrDeliveryChange: 'Upphämtnings- eller leveransinformation har ändrats',
    pickupOrDeliveryChangeDescription:
      'Upphämtnings- eller leveransaddressen har ändrats. Om du vill ändra tillbaka, klicka på någon av knapparna under.',
    addressWasUnresolved: 'Addressen är obekräftad',
    eventTimeCannotBeInFuture: 'Händelsetiden kan inte vara i framtiden',
    shipmentSuccessfullyUpdated: 'Sändningen har uppdaterats',
    connectedShipments: 'Relaterade sändningar',
    goToShipment: 'Gå till sändning',
    currentShipment: 'Nuvarande sändning',
    duplicate: 'Duplikat'
  },
  terminal: 'Terminal',
  location: 'Plats',
  scannedAtDelegatedDepartment: 'Skannat från den delegerade avdelningen.',
  pickupOrders: {
    acceptOrders: 'Acceptera ordrar',
    selected: 'markerade',
    handleOrders: 'Hanterade upphämtningsordrar',
    found: 'hittades',
    accept: 'Acceptera',
    reject: 'Neka',
    noResultText: 'Vi kunde inte hitta några resultat. Försök att söka med ett annat datum.',
    last7d: 'Idag + senaste 7 dagarna',
    rejectOptions: {
      notFound: 'Avsändaren fanns ej på upphämtningsadressen. Inga fler försök. Upphämtning avslutad',
      terminatesPickupOrder: 'Avsändaren har avbokat upphämtningsordern. Inga fler försök. Upphämtning avslutad',
      handedOver:
        'Avsändaren har lämnat över upphämtningsordern till en annan transportör. Inga fler försök. Upphämtning avslutad',
      noMoreAttempts: 'Avsändaren har flyttat. Inga fler försök. Upphämtning avslutad',
      pickupCorrected: 'Avsändaren har flyttat. Upphämtning korrigerad och skickad tillbaka till underleverantör.',
      goodsNotReady: 'Godset är inte redo för upphämting. Inga fler försök. Upphämtning avslutad',
      incorrectBooking: 'Felaktig bokning. Upphämtning avslutad.',
      senderRefuses: 'Avsändaren vägrar överlämna gods. Inga fler försök. Upphämtning avslutad.',
      addressCorrected: 'Felaktig upphämtningadress. Addressen korrigerad.',
      incorrectAddressNoMoreAttempts: 'Felaktig upphämtningadress. Inga fler försök. Upphämtning avslutad.',
      senderNotified: 'Felaktig upphämtningadress. Inga fler försök. Upphämtning avslutad.',
      forbiddenGoods: 'Förbjudet gods. Inga fler försök. Upphämtning avslutad.',
      timeFrame: 'Upphämtning kan inte göras inom tidsramen. Upphämtningsorder skickas tillbaka till bokningskontoret.'
    },
    mustSelectReason: 'Du behöver ange en orsak för avslaget',
    selectRejectReason: 'Välj orsak för avslag',
    selectReason: 'Välj orsak',
    commentPlaceholder: 'Valfritt - ge mer information om avslaget',
    acceptedSuccessToast: 'accepterades',
    rejectedSuccessToast: 'avslogs',
    errorToast: 'Något gick fel',
    rejectOrders: 'Neka sändningar',
    shipment: '{{count}} sändning',
    shipment_other: '{{count}} sändningar'
  },
  editShipments: {
    pickupShouldBeBeforeDeliveryForAllShipments:
      'Sändning [{{shipmentIds}}] kunde inte ändras eftersom kombinationen av nya och befintliga tider inte är giltig. Avmarkera sändningen som misslyckades och försök igen.',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      '{{count}} sändningar kunde inte ändras eftersom kombinationen av nya och befintliga tider inte är giltig. Avmarkera sändningarna som misslyckades och försök igen. Misslyckade sändningsnummer - {{shipmentIds}}',
    useExistingTimes: 'Använd befintliga tider',
    pickupShouldBeBeforeDelivery: 'Upphämtningstiden måste vara före leveranstiden',
    pickupEarliestShouldBeBeforeLatest: 'Den tidigaste upphämtningstiden behöver vara före den senaste',
    deliveryEarliestShouldBeBeforeLatest: 'Den tidigaste leveranstiden behöver vara före den senaste',
    success: 'Sändningsinformationen har uppdaterats',
    pickupDateTime: 'Upphämtning datum och tid',
    deliveryDateTime: 'Leverans datum och tid',
    earliestPickupTime: 'Tidigaste upphämtningstid',
    latestPickupTime: 'Senaste upphämtningstid',
    earliestDeliveryTime: 'Tidigaste leveranstid',
    latestDeliveryTime: 'Senaste leveranstid',
    pickupName: 'Namn till avsändare',
    pickupPhoneNumber: 'Telefonnummer till avsändare',
    deliveryName: 'Namn till mottagare',
    deliveryPhoneNumber: 'Telefonnummer till mottagare',
    pickupInstructions: 'Upphämtningsinstruktioner',
    deliveryInstructions: 'Leveransinstruktioner',
    mixedShipmentsSelected: 'Du har valt sändningar med och utan datum. Information om upphämtning och leverans krävs.',
    fieldNotEditable: 'Informationen kan ej ändras för sändningar med status tilldelad rutt och upphämtad',
    bulkActionDisabledReason: 'Sändning med status levererad, avvikt, nekad eller retunered kan ej ändras',
    withoutDateDisabledReason:
      'Sändningar utan datum och med antingen status tilldelad rutt eller upphämtad går inte att ändra.'
  },
  shipmentSelectColumn: {
    titleDeletedOrders: 'Anpassa datatabellen för raderade order',
    title: 'Anpassa kolumnrubriker',
    addColumnHeader: 'Lägg till tabellrubriker',
    addColumnBody:
      'Välj de rubriker du vill ska visas i datatabellen. Vårt tips är att välja cirka 10-15 rubriker för att information ska visas på ett så bra sätt som möjligt. Exakt antal beror lite på vilken skärmstorlek du har.',
    orderOfTable: 'Ordning på kolumnrubriker'
  },
  bulkActions: {
    routeReceiptList: { disabledTooltip: 'Sändning kan inte ha status bekräftad eller obekräftad' },
    unassignShipmentFromSlot: 'Ta bort från rutt ',
    unassignShipmentFromSlotDisabledReason: 'Ordrarna måste ha status Tilldelad rutt eller Erbjuden',
    forceUnassignShipmentFromSlot: 'Tvinga bortagning från rutt',
    disabledMoveDepartmentTooltip:
      'Sändningar behöver ha status skapad, bekräftad, obekräftad eller avvisad för att kunna flyttas',
    deleteDisableTooltip:
      'Sändningen kan ej tas bort om den har status skapad, obekräftad, bekräftad, erbjuden eller tilldelad',
    duplicateDisableTooltip: 'Sänding behöver tillhöra avdelningstyp Courier samt ha status avvik eller returnerad',
    onlyReleasePausedOrders: 'Du kan endast släppa pausade ordrar.',
    onlyOverrideTheseInvoicingStatuses: 'Du kan endast skriva över ordrar med dessa faktureringsstatusar: {{statuses}}',
    shipmentForPauseDisableText:
      'Sändningarna måste ha status med orderkorrigering, ska faktureras eller fakturering misslyckades',
    creditDisableTooltip: 'Du kan endast kreditera ordrar som har status Fakturerad OK',
    copyDisableTooltip:
      'Kopiera till faktureringsorder är endast tillåtet för ordrar med faktureringsstatus Fakturerad OK',
    createWaybills: 'Skapa fraktsedlar',
    createWaybillsTooltip: 'Fraktsedlar kan endast skapas för IKEA-sändningar',
    createDeliveryNotes: 'Skapa följesedlar',
    createDeliveryNotesTooltip: 'Följesedlar kan endast skapas för IKEA-sändningar',
    viewGroupDisabledTooltip: 'Ordern måste tilldelas innan du kan visa och redigera dess grupp'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Inte fakturerat',
    INVOICING_FAILED: 'Fakturering misslyckades',
    CORRECTION_PENDING: 'Inväntar korrigering',
    INVOICING_PAUSED: 'Fakturering pausad',
    EXCLUDED_FROM_INVOICING: 'Exkluderad',
    NOT_READY_FOR_INVOICING: 'Inte redo',
    INVOICED_OK: 'Fakturerad OK',
    ZERO_PRICE: 'Ofullständigt pris',
    AWAITING_ACKNOWLEDGEMENT: 'Inväntar bekräftelse',
    disallowedStatusLegend:
      'Order med statusen "Fakturerad OK" och "Inväntar bekräftelse" kan inte ställas in på "Inte fakturerat" eller "Exkluderad".'
  },
  invoice: {
    articleCode: 'Artikel',
    allOrdersInvoice: 'Alla order är fakturerade',
    allOrdersInvoiceDescription: 'Vi kunde inte hitta några order som skall faktureras',
    handledBy: 'Hanterad av',
    invoicing: 'Fakturering',
    credit: 'Kreditnota',
    invoiceVerb: 'Fakturera',
    searchShipmentIdOrCustomerRef: 'Sök på sändningsnummer eller kundreferens',
    state: '{{count}} status',
    state_other: '{{count}} statusar',
    invoiceOrderAction: 'Fakturera order',
    invoiceOrderAction_other: 'Fakturera order',
    quantity: 'Antal',
    perUnitCustomer: 'Kundpris per enhet',
    carrierPerUnitPrice: 'Transportörspris per enhet',
    enableCalculator: 'Aktivera multiplikation av pris och antal',
    mustBeNegative: 'Måste vara < 0',
    mustBePositive: 'Måste vara > 0',
    description: 'Beskrivning',
    customerAmount: 'Kundbelopp',
    carrierAmount: 'Enhetsbelopp',
    failedPriceListLink: 'Fejlat prislista i Prismotor',
    failedPriceList: 'Mislyckad prislista',
    priceFailureDetail: 'Feldetaljer',
    priceFailureReason: 'Felorsak',
    priceFailureReasons: {
      missingAttributeValue: 'Attribut saknas',
      matrixLookupMiss: 'Matrisfel',
      invalidExpression: 'Ogiltigt uttryck',
      scriptError: 'Skriptfel'
    },
    invoiceFailureDetail: 'Fakturafelindetaljer',
    invoiceDepartment: 'Fakturera avdelning',
    invoiceDepartment_other: 'Fakturera avdelningar',
    invoiceDepartments: 'Fakturera avdelningar',
    dashboard: 'Dashboard',
    invoicingJobsSummary: 'Summering av faktureringsjobb',
    invoicingStatus: 'Fakturastatus',
    invoicingStatusDescription: 'Visar order från de senaste {{months}} månaderna',
    ordersOnPage: '{{count}} order på sidan',
    ordersFoundCount: '{{count}} order hittades',
    ordersFoundCount_other: '{{count}} order hittades',
    ordersNotInvoiced: 'Order som ej har fakturerats',
    invoicingFailedDescription: 'Fakturering av order misslyckades',
    text: 'Fakturatext',
    correctionPendingDescription: 'Order som inväntar korrigering',
    ordersPausedFromInvoiced: 'Order som är pausade från fakturering',
    invoicingZeroPriceDescription: 'Order med ej godkända nollrader',
    sendInvoices: 'Skapa fakturor',
    sendInvoicesDescription:
      'Du är på väg att fakturera {{departments}}. Var god välj datum för vilken period som skall faktureras.',
    sendInvoiceDateValidationErrorOneMonth: 'Perioden kan inte överstiga 1 månad',
    invoicingInProgress: 'Fakturering av {{departmentName}} är påbörjad. {{count}} jobb återstår.',
    invoicingInFinished: 'Fakturering av {{departmentName}} är avslutad.',
    orderEnqueuedForInvoicing: 'Ordern är satt i kö för fakturering',
    orderEnqueuedForInvoicing_other: 'Order är satta i kö för fakturering',
    orderSuccessNotInvoiced: 'Fakturastatus ändrades till ej fakturerad',
    orderSuccessNotInvoiced_other: 'Fakturastatus ändrades till ej fakturerad',
    orderSuccessInvoicedOk: 'Ordern markerades som fakturerad OK',
    orderSuccessInvoicedOk_other: 'Order markerades som fakturerade OK',
    orderSuccessExcluded: 'Ordern har exkluderats från fakturering',
    orderSuccessExcluded_other: 'Order har exkluderats från fakturering',
    howManyInvoices: 'Hur många fakturor kommer skickas',
    fetchAmount: 'Hämta belopp',
    wantToResend: 'Denna order är redan fakturerad. Är du säker på att du vill fakturera igen?',
    adHocInvoiceOrder: 'Du är på väg att fakturera denna order. Vill du fortsätta?',
    adHocInvoiceOrder_other: 'Du är på väg att fakturera dessa order. Vill du fortsätta?',
    pauseOrders: 'Pausa fakturering',
    datePeriod: 'Datumperiod',
    ordersWereSuccessfullyPaused: '{{count}} order har pausats från fakturering',
    ordersWereSuccessfullyPaused_other: '{{count}} order har pausats från fakturering',
    releaseOrders: 'Återuppta order',
    recalculatePrices: 'Beräkna om priser',
    ordersSentForPriceRecalculation: '{{count}} order har lagts till i kön för omberäkning av priser',
    ordersSentForPriceRecalculation_other: '{{count}} order har lagts till i kön för omberäkning av priser',
    ordersWereSuccessfullyReleased: '{{count}} order har placerats i kö för omräkning',
    ordersWereSuccessfullyReleased_other: '{{count}} order har återupptagits för fakturering',
    addUnit: 'Lägg till enhet',
    overrideUnit: 'Överstyr enhet',
    addUnitDescription: 'Lägg till enhet på valda order. Enheten kommer att internfaktureras.',
    addUnitToOrders: 'Lägg till enhet på order',
    addUnitToOrder: '{{unit}} lades till på {{count}} order',
    addUnitToOrder_other: '{{unit}} lades till på {{count}} order',
    addUnitBulkDisabled: 'Enhet kan endast läggas till på order som saknar enhet',
    approveIncompletePrices: 'Godkänn med ofullständiga priser',
    manualOverrideTitle: 'Överstyr faktureringsstatus',
    selectStatus: 'Välj ny faktureringsstatus',
    status: 'Den nuvarande statusen är',
    status_other: 'De nuvarande statusarna är',
    manualOverrideLegend:
      'Du är på väg att ändra faktureringsstatusen för en vald order. Nuvarande status är: {{statuses}}.',
    manualOverrideLegend_other:
      'Du är på väg att ändra faktureringsstatusen för {{count}} valda ordrar. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Välj önskad faktureringsstatus för denna order nedan.',
    manualOverrideLegend2_other: 'Välj önskad faktureringsstatus för dessa ordrar nedan.',
    unitId: 'Enhets-ID',
    bannerOldInvoicePage:
      'Den 26 augusti kommer <0>den nya faktureringssidan</0> att öppnas som standard. Vi uppmuntrar dig att börja använda den nya sidan. Mer info om den nya sidan <1>här</1>.',
    acceptIncompletePricesTitle: 'Godkänn ofullständiga priser',
    acceptIncompletePricesModalQuestion:
      'Du är på väg att godkänna {{count}} order med ofullständiga priser. Är du säker på att du vill fortsätta?',
    acceptIncompletePricesModalQuestion_other:
      'Du är på väg att godkänna {{count}} ordrar med ofullständiga priser. Är du säker på att du vill fortsätta?',
    confirmCancelDialog: {
      title: 'Du har osparade ändringar',
      question: 'Du har osparade ändringar. Vill du fortsätta?',
      abort: 'Stanna på sidan',
      confirm: 'Fortsätt utan att spara'
    },
    download: 'Ladda ner faktura',
    downloadVendor: 'Leverantörsfaktura',
    downloadInvoiceTooltip: 'Faktura kan endast visas när den har utfärdats av externt system',
    multilegFilter: {
      label: 'Filtrera delvis multileg',
      ALL: 'Visa alla',
      ONLY_PARTIALLY_READY_MULTILEG: 'Visa endast delvis klara',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Exkludera delvis klara'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Fakturerade order som inväntar registreringsbekräftelse från externt system',
    invoicedOn: 'Senast skickad',
    filterStates: 'Filtrera status',
    filterDeliveryDate: 'Leveransdatum',
    clearFilters: 'Rensa filter'
  },
  live: {
    onlyDeviated: 'Visa endast rutter med avvik',
    bannerOldLivePage:
      '<0>Testa</0> den nya Live-sidan, med förbättrade funktioner och ny design. Vi uppmuntrar dig att använda den nya livesidan för att vänja dig vid den innan vi tar bort sidan helt.',
    shipment: 'Sändning',
    shipmentFrom: 'Från',
    shipmentTo: 'Till',
    confirm: 'Bekräfta',
    unconfirm: 'Ångra',
    confirmedBy: 'Bekräftad av {{name}} kl. {{time}}',
    theCourier: 'Chauffören',
    activeRoutes: 'Aktiva rutter',
    routeDeviation: 'Avvik på rutten',
    routeDeviations: 'Avvik på rutten',
    multipleDeviations: 'Flera avvik',
    recentDeviations: 'Senaste avvik',
    noRoutesFound: 'Inga rutter hittades',
    noDeviationsFound: 'Inga avvik hittades',
    consignmentDamage: 'Skada på sändning ',
    shipmentDeviation: 'Avvik på sändning ',
    outsideServiceTime: 'Utanför servicetiden',
    outsideEstimatedTime: 'Utanför beräknat tidsfönster',
    deliveryLocationDeviation: 'Felaktig leveransplats',
    eventTextDeviationOne: '{{name}} har ett avvik',
    eventTextDeviationMany: '{{name}} har {{count}} avvik',
    eventTextDamageOne: '{{name}} har skada på {{count}} sändningar.',
    eventTextDamageMany: '{{name}} har skada på en sändning.',
    eventTextServiceTimeWindow: '{{name}} har levererat utanför tjänstens tidsfönster.',
    eventTextEstimatedTimeWindow: '{{name}} har levererat utanför det beräknade tidsfönstret.',
    eventTextDeviated: '{{name}} har avvikt från sin rutt.',
    eventTextDeliveryLocationDeviation: '{{name}} levererade/avvek {{distance}} meter från den förväntade platsen.',
    eventHelpDeviation: '{{name}} har ett avvik på sändningsnummer {{shipmentId}}.',
    eventHelpDamage: '{{name}} har en skada på sändningsnummer {{shipmentId}}.',
    filterOngoing: 'Pågående',
    filterNotStarted: 'Ej startad',
    filterFinished: 'Visa slutförda rutter',
    filterOnlyDeviated: 'Visa enbart rutter med avvik',
    filterShipmentDeviations: 'Avvik på sändning',
    filterShipmentDamage: 'Skadat gods',
    filterEstimatedTime: 'Beräknad tid',
    filterServiceTime: 'Servicetid',
    filterRouteDeviations: 'Avvik på rutt',
    filterDeliveryLocationDeviation: 'Felaktig leveransplats',
    filterConfirmed: 'Bekräftad',
    routeProgress: 'Slutfört {{complete}} av {{total}}',
    routeDuration: 'Från {{from}} till {{to}}',
    routeDelayed: 'Försenad',
    routeAhead: 'Tidig',
    routeOnTime: 'I tid',
    routeUnknown: 'Okänd ',
    routeDeviationsNone: 'Inga avvikelser',
    routeDeviationCount: '{{unhandledDeviations}} av {{totalDeviations}}',
    routeHasHandleDeviations: 'Rutten har {{count}} hanterad avvikelse',
    routeHasHandleDeviations_other: 'Rutten har {{count}} hanterade avvikelser',
    openRoute: 'Se rutt',
    openShipment: 'Se sändning',
    viewRoute: 'Se rutt',
    deviated: 'Avvikt',
    offRoute: 'Följer ej rutten',
    onRoute: 'Följer rutten',
    allRoutesStates: 'Alla ruttstatusar',
    selectedRouteStates: '{{count}} ruttstatus',
    selectedRouteStates_other: '{{count}} ruttstatusar',
    noSelectedStates: 'Ingen status vald',
    allDeviationTypes: 'Alla avvikelsetyper',
    selectedDeviationTypes: '{{count}} avvikelsetyp',
    selectedDeviationTypes_other: '{{count}} avvikelsetyper',
    showHandledDeviations: 'Visa hanterade avik ({{count}})',
    noSelectedTypes: 'Inga valda typer',
    viewShipment: 'Se sändning',
    selectAllRouteStates: 'Välj alla ruttstatusar',
    noRoutesWithDeviations: 'Inga rutter tillgängliga',
    selectAllDeviationTypes: 'Välj alla avvikelsetyper',
    noDeviationOnRoute: 'Inga avvik på rutten',
    noDeviationAvailable: 'Inga avvik tillgängliga',
    noDeviationsOnFilter:
      'Det finns inga tillgängliga avvikelser för det valda filtret.Testa att använda ett annat filter',
    noRoutesOnFilter: 'Det finns inga tillgängliga rutter för det valda filtret.Testa att använda ett annat filter',
    eventHelpServiceTimeWindow:
      '{{name}} har levererat sändningsnummer {{shipmentId}} kl. {{actual}}, vilket är utanför tjänstens tidsfönster {{earliest}}-{{latest}}.',
    eventHelpEstimatedTimeWindow:
      '{{name}} har levererat försändelsenummer {{shipmentId}} kl. {{actual}} vilket är utanför det uppskattade tidsfönstret {{earliest}}–{{latest}}.',
    eventHelpDriverDeviated: '{{name}} har levererat sändningsnummer {{shipmentId}} i fel ordning.',
    eventHelpDriverDeviatedAtPickup: '{{name}} har hämtat sändningsnummer {{shipmentId}} i fel ordning.',
    eventHelpDriverDeviatedAtPickupBefore:
      '{{name}} har hämtat sändningsnummer {{shipmentId}} i fel ordning, #{{actual}} har hämtats före #{{expected}}.',
    eventHelpDriverDeviatedAtPickupAfter:
      '{{name}} har hämtat sändningsnummer {{shipmentId}} i fel ordning, #{{actual}} har hämtats efter #{{expected}}.',
    eventHelpDriverDeviatedBefore:
      '{{name}} har levererat sändningsnummer {{shipmentId}}  i fel ordning  #{{actual}}  har levereats före  #{{expected}}.',
    eventHelpDriverDeviatedAfter:
      '{{name}} har levererat sändningsnummer {{shipmentId}} i fel ordning  #{{actual}}  har levereats efter  #{{expected}}.',
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        '{{name}} har levererat eller avvikit sändningsnummer {{shipmentId}} <4>här</4>, {{distance}} meter från den <9>förväntade platsen</9>.',
      withoutShipmentId:
        '{{name}} har levererat eller avvikit <4>här</4>, {{distance}} meter från den <9>förväntade platsen</9>.'
    },
    search: 'Sök efter rutt, enhet eller chaufför',
    unhandled: 'ohanterade',
    deviations: 'avvikelser',
    mostDeviations: 'Flest avvikelser',
    latestInTime: 'Senast i tiden',
    earliestInTime: 'Tidigast i tiden',
    sortOn: 'Sortera på',
    late: 'sen',
    early: 'tidig',
    stops: 'Stopp: {{stops}}',
    deviatedFromRoute: 'Avvikit från rutten',
    totalTimeMajorDeviations: 'Total tid för större avvikelser (≥5 min)',
    totalTimeMinorDeviations: 'Total tid för mindre avvikelser (<5 min)',
    lateOrEarlyFirstStop: 'Sen eller tidig till första leveransen',
    showAdjusted: 'Visa justerad tid',
    showAdjustedTooltip: 'Justerad tid visas på mottagarens spårningssida',
    showDiff: 'Visa stoppskillnad',
    diff: 'Stoppskillnad',
    showDiffTooltip: 'Skillnad mellan planerad (ETD) och faktisk tid mellan stopp',
    modalTableSummary: 'Total ruttid',
    liveModalActualTooltip1: 'Jämfört med ETD:',
    liveModalActualTooltip2: 'Grön: Upp till 15 min',
    liveModalActualTooltip3: 'Orange: 15–30 min',
    liveModalActualTooltip4: 'Röd: Mer än 30 min',
    routeStateFilter: 'Ruttstatus',
    departmentFilter: 'Avdelning',
    allDepartments: 'Alla avdelningar',
    deviationTypeFilter: 'Avvikelsestyp',
    showSummary: 'Visa sammanfattning'
  },
  deliveryNote: {
    title: 'Följesedel',
    sender: 'Avsändare',
    vatNumber: 'Momsnummer',
    orderNumber: 'Ordernummer',
    receiver: 'Mottagare',
    phone: 'Telefon',
    shipmentId: 'Sändningsnummer',
    articles: 'Artiklar',
    orderDate: 'Beställningsdatum',
    deliveryDate: 'Leveransdatum',
    deliveryTime: 'Leveranstid',
    printedDate: 'Utskriftsdatum',
    receiversReference: 'Mottagarens referens',
    receiversReferenceNote: 'Använd detta nummer vid all kontakt med oss',
    articleNumber: 'Nummer',
    articleName: 'Namn',
    articlePrice: 'Styckpris',
    articleQuantity: 'Antal',
    numberOfPackages: 'Antal paket',
    totalWeight: 'Total vikt',
    totalVolume: 'Total volym',
    print: 'Skriv ut följesedel'
  },
  userRolesAdmin: {
    price: 'Pris',
    searchPlaceholder: 'Sök efter användarroll',
    userRoles: 'Användarroller',
    successCreateMessage: '{{name}} skapades',
    successUpdateMessage: '{{name}} uppdaterades',
    saveRole: 'Spara roll',
    editRole: 'Redigera {{name}}',
    createNewRole: 'Skapa ny roll',
    nameOfRole: 'Rollens namn',
    nameRequired: 'Namn är obligatoriskt',
    descriptionRequired: 'Beskrivning är obligatoriskt',
    descriptionLabel: 'Beskrivning (max 240 tecken)',
    iconLabel: 'Välj vilken ikon du vill ha för användarrollen',
    selectRoleTitle: 'Välj tillgångsrättigheter för roll',
    emptyState: 'Inga roller hittades för sökfrasen',
    deleteConfirm: 'Är du säker på att du vill radera {{name}}?',
    deleteSuccess: 'Rollen {{name}} raderades',
    settings: 'Inställningar',
    accessRights: 'Tillgångsrättigheter',
    settingsTitle: 'Inställningar för roll',
    settingsDescription:
      'Engelska är obligatoriskt. Om inget annat språk väljs kommer engelska att användas som reservspråk.',
    additionalLanguagesTitle: 'Lägg till ytterligare språk',
    customerPortalAccess: 'Tillgång till kundportal',
    defaultForUserRole: 'Använd som standardroll (valfritt)',
    event: 'Händelse',
    financialAccess: 'Finansiella rättigheter',
    invoiceActions: 'Fakturaåtgärder',
    orderAttributes: 'Orderattribut',
    findApiOrder: 'Hitta API-order',
    optimus: 'Optimus',
    noAccess: 'Ingen tillgång',
    noAccessToApiOrder: 'Ingen åtkomst till Hitta API-order',
    noAccessToOptimus: 'Ingen åtkomst till Optimus',
    optimusViewDescription: 'Användare kan visa tjänster på avdelningar och kunder, men kan inte göra ändringar',
    optimusFullDescription: 'Användare kan lägga till och redigera tjänster för avdelningar och kunder',
    ordersApiSearchRestrictedDescription:
      'Användare kan söka efter order från de avdelningar eller kunder de har åtkomst till',
    ordersApiSearchFullDescription: 'Användare kan söka efter order från alla avdelningar och kunder',
    addRole: 'Lägg till roll',
    addedRole: 'Tillagd roll',
    removeRole: 'Ta bort roll',
    importExport: 'Import / Export',
    importExportExtendedDescription: 'Inklusive åtkomst till utökad rapport för chaufför.',
    importExportExtendedSaaSDescription: 'Inklusive åtkomst till slutrapport för dagen.',
    billingOrdersReadOnlyDescription: 'Begränsad läsbehörighet till {{billingOrderTypes}}',
    billingOrdersDescription: 'Full åtkomst till {{billingOrderTypes}}'
  },
  webhook: {
    messages: {
      title: 'Webhook-meddelanden',
      resendConfirmation: 'Webhook-meddelandet skickades igen'
    },
    resend: 'Skicka igen',
    requestedAfter: 'Begärd efter',
    messageDetails: {
      title: 'Webhook-meddelande',
      generalHeading: 'Allmän information',
      requestHeading: 'Information om förfrågan',
      loading: 'Hämtar webhook-meddelande...',
      copyTooltip: 'Kopiera payload',
      copied: 'Payload har kopierats'
    },
    messageId: 'Meddelande-ID',
    messageCreatedAt: 'Meddelande skapat',
    eventType: 'Händelsetyp',
    packageId: 'Kollinummer',
    shipmentId: 'Sändningsnummer',
    subscriptionUrl: 'Prenumerations-URL',
    subscriptionId: 'Prenumerations-ID',
    request: {
      at: 'Förfrågan skickad',
      after: 'Förfrågan skickad',
      retry: 'Nytt försök för meddelande'
    },
    response: {
      heading: 'Information om svar',
      at: 'Svar mottaget',
      status: 'Svarsstatus'
    },
    responseCategories: {
      Informational: 'Information (100-199)',
      Successful: 'Lyckad (200-299)',
      Redirect: 'Omdirigering (300-399)',
      ClientError: 'Klientfel (400-499)',
      ServerError: 'Serverfel (500-599)',
      UnknownError: 'Okänt fel',
      Pending: 'Väntande'
    }
  },
  validationError: {
    provideEmail: 'Du måste ange en e-post',
    provideValidEmail: 'Du måste ange en giltig e-post',
    youMustSelectCustomer: 'Du måste välja en kund'
  },
  roles: {
    ADMIN_OPTIMIZING: 'Optimering',
    ADMIN_LM_EVENTS: 'LM-händelser',
    ADMIN_PH: 'ParcelHub',
    ADMIN_INTEGRATIONS: 'Integrationer',
    ADMIN_NUMBER_SERIES: 'Nummerserier',
    ADMIN_TEXTS: 'Tjänster',
    ADMIN_JOBS: 'Jobbövervakning',
    ADMIN_PRE_ADVICE: 'Preavisering',
    ADMIN_SETTINGS: 'Inställningar',
    ADMIN_SHD: 'SHD',
    ADMIN_CUSTOMER: 'Begränsad tillgång',
    ADMIN_CUSTOMER_GROUP: 'Kundgrupper',
    ADMIN_HOLIDAYS: 'Helgdagar',
    ADMIN_MATRIX: 'Matris',
    ADMIN_USERS: 'Användare',
    ADMIN_DEPARTMENT: 'Avdelningar',
    ADMIN_DEPARTMENT_GROUP: 'Avdelningsgrupper',
    ADMIN_CUSTOMER_ALL: 'Full tillgång',
    ADMIN_VENDORS: 'Leverantörer',
    ADMIN_PRICE_ARTICLE: 'Skapa och underhålla artiklar',
    ADMIN_PRICE_ACCOUNTING: 'Ändra inställningar för redovisningssystem',
    ADMIN_PRODUCTION_TIME_WINDOW: 'Produktionstidsfönster',
    OPTIMUS_VIEW: 'Läsbehörighet till Optimus',
    OPTIMUS_EDIT: 'Full tillgång till Optimus',
    ORDERS_API_SEARCH_RESTRICTED: 'Begränsad sökbehörighet i Hitta API-order',
    ORDERS_API_SEARCH_FULL: 'Full sökbehörighet i Hitta API-order',
    CUSTOMER_PORTAL: 'Kundbehörighet till kundportalen',
    CUSTOMER_PORTAL_ADMIN: 'Administratörsbehörighet till kundportalen',
    CUSTOMER_PORTAL_VIEW_PRICE: 'Kan se priser i kundportalen',
    VIEW_PRICE: 'Kan se priser',
    VIEW_PRICE_EVENTS: 'Kan se prishändelser',
    FINANCIAL_VIEW_CUSTOMER_AND_UNIT_PRICE: 'Kan se priser på rutter',
    BOOK_SHIPMENT: 'Kan boka sändningar',
    PLANNER_ADDRESSES: 'Adresser',
    PLANNER_BILLING_ORDERS: 'Faktureringsorder',
    PLANNER_BILLING_ORDERS_READ: 'Faktureringsorder (endast läsning)',
    PLANNER_BOOKING: 'Bokning',
    PLANNER_CORRECTIONS: 'Korrigeringar',
    PLANNER_COURIERS: 'Chaufförer',
    PLANNER_DISPATCHING: 'Trafikledning',
    PLANNER_IMPORT_EXPORT: 'Begränsad tillgång till rapporter',
    PLANNER_IMPORT_EXPORT_EXTENDED: 'Tillgång till alla rapporter',
    PLANNER_INVOICING: 'Fakturering',
    PLANNER_LIVE: 'Live',
    PLANNER_MANAGE_RETURNS: 'Hantera returer',
    PLANNER_PICKUP_ORDERS: 'Upphämtningsordrar',
    PLANNER_RECURRING_ORDERS: 'Återkommande',
    PLANNER_ROUTE_PLANNING: 'Ruttplanering',
    PLANNER_SHIPMENTS: 'Sändningar',
    PLANNER_UNITS: 'Enheter',
    PLANNER_UNITS_REMOVE: 'Ta bort enheter från avdelning',
    PLANNER_UNRESOLVED: 'Obekräftade',
    PLANNER_REPORTS: 'Rapporter',
    PLANNER_VEHICLES: 'Fordon',
    PLANNER_PRE_ADVICE: 'Preavisering',
    ADMIN_ALCOHOL_DELIVERY_EDUCATION: 'Kan lägga till alkoholleveransutbildning för chaufförer',
    FINANCIAL_SHOW_INVOICING_PAYLOAD: 'Visa fakturans payload',
    FINANCIAL_DOWNLOAD_INVOICE: 'Ladda ner faktura',
    FINANCIAL_CREDIT_NOTE: 'Kreditnota',
    FINANCIAL_COPY_TO_BILLING_ORDER: 'Kopiera till faktureringsorder',
    FINANCIAL_VIEW_GROUP: 'Visa grupp',
    FINANCIAL_VIEW_MULTILEG: 'Visa multileg',
    FINANCIAL_REINVOICE_INVOICED_ORDERS: 'Fakturera fakturerade order på nytt',
    FINANCIAL_INVOICE_ACTIONS: 'Fakturaåtgärder på sändningar',
    PRICING_ENGINE: 'Prismotor',
    READ_ANY_SHIPMENT: 'Sändning'
  },
  manageReturns: {
    title: 'Hantera returer',
    typesOfReturns: 'Typer av returer',
    ordersOverAPeriod: 'Visar beställningar från den senaste månaden.',
    ordersOverAPeriod_other: 'Visar beställningar från de senaste {{count}} månaderna.',
    pickedUpByCustomer: 'Hämtad av kund',
    pickedUpByCustomerDescription: 'Returer som ska hämtas av kunden',
    transferToDifferentTerminal: 'Överför till annan terminal',
    transferToDifferentTerminalDescription: 'Returer som ska skickas till en annan terminal',
    environmentalReturns: 'Miljöreturer',
    environmentalReturnsDescription: 'Returer för återvinning, samlade i en container',
    returnForDelivery: 'Retur för leverans',
    returnForDeliveryDescription: 'Returer som ska dirigeras och levereras',
    MANUAL_RETURNS: 'Manuella returer',
    manualReturnsDescription: 'Beställning där retursegmentet inte har skapats ännu',
    returnToSenderTitle: 'Vill du returnera sändningarna till avsändaren',
    manuallyMarkAsHandled: 'Markera manuellt som hanterad',
    manuallyMarkAsHandledTooltip: 'När en sändning markeras som hanterad försvinner den från listan',
    ordersFoundCount: '{{count}} beställning hittad',
    ordersFoundCount_other: '{{count}} beställningar hittade',
    PICKED_UP_BY_CUSTOMER: 'Hämtad av kund',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Överför till annan terminal',
    ENVIRONMENTAL_RETURNS: 'Miljöreturer',
    RETURN_FOR_DELIVERY: 'Retur för leverans',
    ordersAlreadyHandled: 'Alla beställningar är hanterade',
    ordersAlreadyHandledDescription: 'Vi kunde inte hitta några ohanterade beställningar.',
    manuallyMarkAsHandledModal: {
      title: 'Markera manuellt som hanterad',
      shipmentsCount: '{{count}} sändning',
      shipmentsCount_other: '{{count}} sändningar',
      description:
        'När sändningen/-arna markeras som hanterad försvinner de från listan. Du kan inte ångra denna åtgärd. Sändning/-arna kan hittas på söksidan.',
      confirm: 'Markera som hanterad'
    },
    manuallyMarkAsHandledSuccess: '{{count}} sändning markerades som hanterad',
    manuallyMarkAsHandledSuccess_other: '{{count}} sändningar markerades som hanterade',
    returnToSenderSuccess: '{{count}} sändning returnerades till avsändaren',
    returnToSenderSuccess_other: '{{count}} sändningar returnerades till avsändaren',
    selectCustomer: 'Välj kund',
    customer: 'Kund',
    customer_other: 'Kunder',
    allCustomers: 'Alla kunder',
    selectDestination: 'Välj destination',
    destination: 'Slutdestination',
    destinationDIP: 'Destinations-DIP',
    returnShipmentColumns: 'Returinformation',
    allDestinations: 'Alla destinationer',
    noDate: 'Alla',
    zeroDays: '0 dagar',
    oneTo6Days: '1–6 dagar',
    moreThan7Days: '> 7 dagar',
    moreThan15Days: '> 15 dagar',
    moreThan30Days: '> 30 dagar',
    customerDate: 'Anpassad',
    daysOnTerminal: 'Dagar på terminal',
    months: 'Månader',
    lastMonths: 'Senaste {{count}} månad',
    lastMonths_other: 'Senaste {{count}} månader',
    printList: 'Skriv ut lista',
    returnToSender: 'Returnera till avsändare',
    returnToSenderQueued: 'Returnering till avsändare är köad',
    returnToSenderConfirmation: 'Vill du returnera denna sändning till avsändaren?',
    returnToSenderFailed: 'Kunde inte returnera sändning till avsändaren',
    returnToSenderDisabledTooltip:
      'Du kan inte returnera försändelser som har avvikit, levererats eller redan är markerade för retur',
    senderDIP: 'Avsändande DIP',
    createReturnLabel: 'Skapa returetikett'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Sök efter en sändning',
    startDescription: 'Ange ett sändningsnummer och klicka på sök.',
    noResultsTitle: 'Inga meddelanden hittades',
    loadFailedTitle: 'Kunde inte hämta meddelanden',
    loadFailedDescription: 'ParcelHub-consumern svarade inte. Försök igen eller kontrollera att tjänsten körs.',
    payloadLoadFailed: 'Kunde inte hämta payload för det här meddelandet.',
    shipment: 'Sändning',
    topic: 'Topic',
    partition: 'Partition',
    offset: 'Offset',
    operation: 'Operation',
    packageId: 'Kolli-ID',
    timestamp: 'Tidsstämpel',
    payload: 'Payload',
    viewPayload: 'Visa payload',
    consignmentEvents: 'Sändningshändelse',
    consignmentItemEvents: 'Kollihändelse',
    eventCode: 'Händelsekod',
    event: 'Händelse',
    receivedAt: 'Mottagen',
    queuedAt: 'Köad',
    processed: 'Behandlad',
    processedAt: 'Behandlad',
    processingLag: 'Behandlingstid',
    eventsNoResultsTitle: 'Inga händelser hittades',
    eventsLoadFailedTitle: 'Kunde inte hämta händelser',
    eventsLoadFailedDescription: 'Hämtningen av händelser misslyckades. Försök igen.',
    eventPayloadLoadFailed: 'Kunde inte hämta payload för den här händelsen.'
  },
  apolloAdmin: {
    title: 'Integrationer',
    emptyTitle: 'Inga anrop',
    emptyDescription: 'Välj vilket datum du vill se och klicka på sök.',
    reqType: 'Typ av anrop',
    routeId: 'Rutt-ID',
    routeName: 'Ruttnamn'
  },
  preAdviceFollowup: {
    title: 'Hantera föravisering',
    toBeHandled: 'Ska hanteras',
    failedOrders: 'Misslyckade ordrar',
    failedOrdersDescription: 'Mottagaren har inte fått någon avisering',
    manualPreAdvice: 'Manuell föravisering',
    manualPreAdviceDescription: 'Ordrar med manuell aktivering från admin-sidan',
    preAdviceLocked: 'Föravisering låst',
    preAdviceLockedDescription: 'Ordrar som är låsta och väntar på åtgärd',
    missingRules: 'Saknade regler',
    missingRulesDescription: 'Ordrar saknar en föraviseringsregel.',
    inProgress: 'Pågår',
    inProgressDescription: 'Ordrar med pågående föravisering',
    notStarted: 'Inte påbörjad',
    notStartedDescription: 'Ordrar med regel där föravisering inte har startat',
    ordersFoundCount: '{{count}} order hittad',
    ordersFoundCount_other: '{{count}} ordrar hittade',
    FAILED_ORDERS: 'Misslyckade ordrar',
    MANUAL_PRE_ADVICE: 'Manuell föravisering',
    PRE_ADVICE_LOCKED: 'Föravisering låst',
    MISSING_RULES: 'Saknade regler',
    IN_PROGRESS: 'Pågår',
    NOT_STARTED: 'Inte påbörjad',
    ordersAlreadyHandled: 'Alla ordrar är hanterade',
    ordersAlreadyHandledDescription: 'Vi kunde inte hitta några ohanterade ordrar.',
    updatePhoneNumber: 'Ändra eller lägg till telefonnummer',
    updateEmailAddress: 'Ändra eller lägg till e-postadress',
    removeShipmentFromPreAdvice: 'Ta bort försändelse från föravisering',
    bookDateAndTime: 'Boka datum och tid',
    manuallyPreAdvice: 'Manuell föravisering',
    unlockPreAdvice: 'Lås upp föravisering',
    lockPreAdvice: 'Lås föravisering',
    triggerPreAdvice: 'Trigga föravisering',
    selectedCustomers: '{{count}} kund',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alla kunder',
    selectRowWithOrderId: 'Välj rad med order-id {{id}}',
    updateRecipientPhoneNumber: 'Uppdatera telefonnummer',
    phoneNumberUpdated: 'Telefonnumret har uppdaterats för försändelse-ID: {{shipmentId}}',
    phoneNumberUpdatedAndPreAdviceSent:
      'Telefonnumret uppdaterades och föravisering skickades för försändelse-ID: {{shipmentId}}',
    samePhoneNumberAlreadySet: 'Samma telefonnummer är redan inställt på försändelsen.',
    updateRecipientEmailAddress: 'Uppdatera e-postadress',
    emailAddressUpdated: 'E-postadressen har uppdaterats för försändelse-ID: {{shipmentId}}',
    emailAddressUpdatedAndPreAdviceSent:
      'E-postadressen uppdaterades och föravisering skickades för försändelse-ID: {{shipmentId}}',
    emailAddressUpdatedBulk: 'E-postadressen har uppdaterats för {{count}} försändelse',
    emailAddressUpdatedBulk_other: 'E-postadressen har uppdaterats för {{count}} försändelser',
    emailAddressUpdatedAndPreAdviceSentBulk:
      'E-postadressen uppdaterades och föravisering skickades för {{count}} försändelse',
    emailAddressUpdatedAndPreAdviceSentBulk_other:
      'E-postadressen uppdaterades och föravisering skickades för {{count}} försändelser',
    sameEmailAddressAlreadySet: 'Samma e-postadress är redan inställd på försändelsen.',
    manuallyPreAdvicedSuccess: 'Framgångsrikt triggad föravisering för {{count}} försändelser',
    nrOfSelected: '{{count}} vald',
    nrOfSelected_other: '{{count}} valda',
    sendPreAdvice: 'Skicka föravisering',
    unlockPreAdviceSuccess: 'Framgångsrikt låst upp föravisering för {{count}} försändelser',
    unlockPreAdviceAndPreAdviceSent: 'Framgångsrikt låst upp och skickat föravisering för {{count}} försändelser',
    lockPreAdviceSuccess: 'Framgångsrikt låst föravisering för {{count}} försändelser',
    saveAndSendPreAdvice: 'Spara och skicka föravisering',
    finishPreAdviceFollowupSuccess: 'Framgångsrikt borttagna {{count}} försändelser från föravisering'
  },
  articles: {
    title: 'Artiklar',
    number: 'Artikelnummer',
    name: 'Artikelnamn',
    quantity: 'Antal',
    shipmentArticles: 'Sändningens artiklar',
    noArticlesPresent: 'Inga artiklar finns'
  },
  coordinates: {
    setCoordinates: 'Sätt koordinater',
    title: 'Sätt koordinater för adresser',
    setCoordinatesCount: 'Sätt koordinater ({{count}})',
    zipCodeRange: 'Postnummerintervall',
    goodJob: 'Bra jobbat',
    noUnresolvedShipments: 'Inga ohanterade sändningar hittades för denna avdelning eller avdelningsgrupp',
    coordinateSaved: 'Koordinater sparade för {{address}}',
    checkMapProvider: 'Kontrollera {{name}}',
    noDeliveryDate: 'Inget leveransdatum',
    created: 'Skapad',
    withDeliveryDate: 'Med leveransdatum ({{count}})',
    withoutDeliveryDate: 'Utan leveransdatum ({{count}})',
    applyFilter: 'Använd filter',
    thereAreUnsetCoordinates: 'Du har {{count}} koordinat att sätta.',
    thereAreUnsetCoordinates_other: 'Du har {{count}} koordinater att sätta.',
    noCoordinateFound:
      'Vi kunde inte hitta koordinater för adressen. Sök efter adressen eller skriv in koordinater (t.ex. 59.289976807684084, 18.010318840107406) i sökfältet. '
  },
  relatedOrders: {
    NONE: 'Inga relaterade order',
    MULTILEG: 'Multileg',
    PICKUP: 'Upphämtning',
    TRANSPORT: 'Transport',
    DELIVERY: 'Leverans',
    CUSTOMER: 'Kundorder'
  },
  vendors: {
    title: 'Leverantörer',
    viewDetails: 'Visa detaljer',
    notFound: 'Kunde inte hitta leverantör med sökfrasen',
    initialSearch: 'Sök för att hitta leverantörer',
    informationAboutTheVendor: 'Information om leverantören',
    searchLabel: 'Sök efter leverantörsnamn, leverantörs-ID eller enhets-ID',
    searchVendorPlaceholder: 'Sök efter leverantörsnamn eller leverantörs-ID',
    searchUnitPlaceholder: 'Sök efter enhets-ID',
    vendorOption: 'Leverantörsnamn/ID',
    unitOption: 'Enhets-ID',
    connectUnit: 'Koppla enhet',
    connectUnits: 'Koppla enheter',
    connectedUnits: 'Kopplad enhet ({{count}})',
    connectedUnits_other: 'Kopplade enheter ({{count}})',
    unitsConnected: '{{count}} Kopplad enhet',
    unitsConnected_other: '{{count}} Kopplade enheter',
    unitsConnected_zero: 'Inga kopplade enheter',
    paymentTerms: 'Betalningsvillkor',
    connected: 'Kopplad',
    searchForUnitDescription: 'Att välja en enhet innebär att avdelningen som enheten tillhör tar kostnaden.',
    searchForUnitTitle: '{{vendorSite}} för {{operatingUnitName}}',
    successToast: 'Uppdaterade kopplade enheter till leverantör {{name}}',
    showConnectedUnits: 'Visa kopplade enheter',
    editConnectedUnits: 'Redigera kopplade enheter',
    searchForUnit: 'Sök efter enhet',
    searchPage: 'Sök sida',
    currencyCode: 'Valutakod',
    connectedToCompany: 'Ansluten till detta företag',
    noConnection: 'Ingen anslutning',
    connectedTo: 'Ansluten till',
    nothingHereYet: 'Det finns inget här ännu!',
    emptyStateSelectedVendor: 'Välj en platskod för att koppla enheter eller visa befintliga anslutningar.',
    selfBilling: 'Avräkning',
    setUnitSettingsTitle: 'Uppdatera enhetsinställningar för {{name}}',
    setUnitSettingsSelfBillingInternalTrade: 'Avräkning och interna handelstransaktioner är aktiverade.',
    setUnitSettingsNone: 'Avräkning och interna handelstransaktioner är inte aktiverade.',
    setUnitSettingsInternalTrade: 'Avräkning är inte aktiverad, interna handelstransaktionen är aktiverade.',
    state: {
      COMPLETE: 'Fullständig',
      INCOMPLETE: 'Ofullständig',
      ALL: 'Alla',
      label: 'Välj leverantörsstatus'
    }
  },
  shdAdmin: {
    successfullyDeleted: 'Tidsmatrisen har raderats',
    successfullyUploaded: 'Tidsmatrisen har laddats upp',
    timeWindowForHomeDelivery: 'Tidsfönster för hemleverans',
    filterByCustomerData: 'Sök efter kundnamn, underkund eller kundnummer',
    uploadTimeMatrixFile: 'Ladda upp tidsmatrisfil',
    downloadExcelTemplate: 'Ladda ner Excel-mall',
    clickHereOrDragAndDrop: 'Klicka här eller dra och släpp',
    allowedFormats: 'Tillåtna format är XLS och XLSX',
    existingCustomers: 'Existerande kunder med SHD',
    customerPriceTooltip: "Om slutkundens pris ska visas, sätt reglaget på 'på'",
    deleteModalTitle: 'Ta bort tidsfönster',
    deleteModalDescription:
      'Om du tar bort detta tidsfönster tas alla SHD-tidsfönster för denna kund bort. Du kommer inte kunna återställa denna åtgärd.',
    exportToExcel: 'Exportera till Excel',
    toggleLabel: 'Växla kundens pris',
    customerNumber: 'Kundnummer',
    subCustomer: 'Underkund',
    customerName: 'Kund',
    amountOfPostalCodes: 'Antal postnummer',
    lastUpdatedAt: 'Senast uppdaterad',
    showCustomerPrice: 'Visa kundpris',
    uploadMaximumFileSizeLimit: 'Filstorleken får inte överstiga {{size}} KB'
  },
  matrix: {
    title: 'Matris',
    id: 'ID',
    pageTitle: 'Matrisadministration',
    name: 'Namn',
    filename: 'Filnamn',
    uploaded: 'Uppladdad',
    uploadedBy: 'Uppladdad av',
    downloadTemplate: 'Ladda ner mall',
    byUser: 'Av användare',
    country: 'Land',
    ROUTING: 'Routing',
    LINEHAUL: 'Linehaul',
    HUB: 'HUB',
    DELIVERY: 'Leverans',
    VAS: 'VAS',
    DEPARTMENT: 'Avdelning',
    CUTOFF: 'Cutoff',
    PARCEL_DELIVERY: 'Paketleverans',
    parcelDelivery: {
      searchLabel: 'Sök efter postnummer, avdelning eller hubb',
      noRouting: 'Inga ruttrader i den här matrisen ännu'
    },
    terminals: 'Terminaler',
    searchLabel: 'Sök efter namn eller kundnummer',
    bookingLimitsSearchLabel: 'Sök efter terminalnamn',
    'baggage-delivery': 'Bagage',
    baggage: {
      title: 'Bagagematriser',
      name: 'Bagage {{country}}',
      legend: "Om du vill uppdatera befintliga bagagematriser gör du detta genom att välja 'ladda upp matrixdata'.",
      uploadTitle: 'för {{country}}',
      custom: 'Anpassad DS-kodmatris',
      uploadCustomTitle: 'för anpassade DS-koder',
      status: 'Status',
      uploadFail:
        '{{label}} accepterades inte på grund av felaktig information. Ändra informationen och ladda upp matrisen igen.',
      statuses: { accepted: 'Accepterad', pending: 'Väntande', rejected: 'Avvisad' }
    },
    cutoff: {
      departments: 'Paketavdelningar ({{count}})',
      searchDepartment: 'Sök efter avdelning eller hubb',
      hubCount: '{{count}} hubb',
      hubCount_other: '{{count}} hubbar',
      department: 'Paketavdelning',
      selectDepartment: 'Välj en paketavdelning',
      noDepartments: 'Inga paketavdelningar hittades',
      hubName: 'Hubbnamn',
      hubId: 'Hubb-ID',
      addHub: 'Lägg till hubb',
      sameDay: 'Leverans samma dag',
      noHubs: 'Inga hubbar har registrerats för den här avdelningen ännu',
      saved: 'Cutoff-tiderna sparades',
      deleted: 'Hubben raderades',
      delete: {
        question: 'Radera {{hubName}}?',
        description: 'Hubben och dess cutoff-tid tas bort från den här avdelningen.'
      },
      unsaved: {
        question: 'Förkasta osparade cutoff-tider?',
        description: 'Dina ändringar för den här avdelningen har inte sparats. Om du byter avdelning förkastas de.',
        discard: 'Förkasta ändringar'
      }
    },
    terminalDetails: {
      details: 'Detaljer',
      alystraDepartmentId: 'Alystra avdelnings-ID',
      matrices: 'Matriser',
      type: 'Typ',
      noMatrices: 'Den här terminalen refereras inte till i några matriser',
      aliases: 'Alias',
      departmentId: 'Avdelnings-ID',
      createdAt: 'Skapad',
      noAliases: 'Den här terminalen har inga alias'
    },
    bookingLimits: {
      title: 'Bokningsbegränsningar',
      header: '{{name}} - Redigera bokningsgränser',
      rules: '#Regler',
      total: 'Total',
      rank: 'Prioritet',
      customer: 'Kund',
      customerNo: 'Kundnummer',
      serviceCode: 'Tjänst',
      timeWindow: 'Tidsfönster',
      selectTimeWindow: 'Välj tidsfönster',
      noTimeWindow: 'Inget tidsfönster',
      noCustomer: 'Ingen kund',
      bookingLimit: 'Bokningsgräns',
      removeLimit: 'Ta bort gräns',
      addMoreLimits: 'Lägg till fler gränser',
      delete: 'Ta bort bokningsgränser',
      deleteModalDescription: 'Du kommer inte att kunna återställa denna åtgärd',
      deleted: 'Bokningsgränserna raderades framgångsrikt',
      updated: 'Bokningsgränserna ändrades framgångsrikt'
    },
    master: 'Master',
    select: 'Välj {{matrix}}-matris...',
    overflow: '+{{overflow}} fler..',
    vasCodes: 'VAS-koder',
    connectedCustomers: {
      title: 'Anslutna kunder',
      button: 'Se {{connectedCustomers}} anslutna kunder',
      search: 'Sök efter kundens namn eller nummer',
      subcustomer: 'Underkund'
    },
    upload: {
      success: 'Matrixdata laddades upp framgångsrikt',
      question: 'Ladda upp matrixdata',
      text: 'Ladda upp Excel',
      description: 'Ladda upp Excel-kalkylblad med data för denna matris',
      error: 'Fel vid uppladdning av data till {{name}}. {{error}}',
      invalidformat: 'Ogiltigt filformat'
    },
    delete: {
      question: 'Ta bort matris {{name}}',
      description: 'Detta kan inte ångras',
      success: 'Matris {{name}} raderades framgångsrikt',
      error: 'Fel vid radering av {{name}}. {{error}}'
    },
    new: {
      question: 'Skapa ny matris',
      description: 'Skapar en ny matris',
      success: 'Matris {{name}} skapades framgångsrikt',
      error: 'Fel vid skapande av matris. {{error}}'
    },
    edit: {
      question: 'Redigera matris {{name}}',
      error: 'Fel vid uppdatering av {{name}}. {{error}}',
      success: 'Matris {{name}} sparades framgångsrikt'
    },
    type: 'Välj typ',
    day: {
      monday: 'Mån',
      tuesday: 'Tis',
      wednesday: 'Ons',
      thursday: 'Tor',
      friday: 'Fre',
      saturday: 'Lör',
      sunday: 'Sön'
    },
    leadTime: 'Ledtid',
    terminal: 'Terminal',
    terminalFrom: 'Terminal från',
    terminalTo: 'Terminal till',
    postalCode: 'Postnummer',
    postalCodeFrom: 'Från postnummer',
    postalCodeTo: 'Till postnummer',
    offsetDays: 'Offsetdagar',
    cutoffTime: 'Cutoff-tid',
    city: 'Stad',
    error: {
      duplicateName: 'Duplicerat namn',
      duplicateServiceCode: 'Bokningsbegränsningar är redan definierade för denna kombination av kund och tjänstekod',
      duplicateTimeWindow: 'Duplicerat tidsfönster'
    }
  },
  serviceMapping: {
    title: 'Tjänster',
    serviceName: 'Tjänstnamn',
    pickupTime: 'Upphämtningstid',
    pickupDuration: 'Stopptid vid upphämtning',
    pickupPreparation: 'Förberedelse upphämtning',
    deliveryTime: 'Leveranstid',
    deliveryDuration: 'Stopptid vid leverans',
    deliveryPreparation: 'Förberedelse leverans',
    internalName: 'Internt namn',
    internalDescription: 'Intern beskrivning',
    externalName: 'Externt namn',
    externalDescription: 'Extern beskrivning',
    allowFlexDelivery: 'Tillåt flexibel leverans',
    timeWindow: 'Tidsfönster',
    serviceMappingType: 'Typ',
    serviceLevel: 'Servicenivå',
    service: 'Tjänst',
    vas: 'VAS',
    stopsBeforeShowEta: 'ETA stopp',
    minutesUntilDelivery: 'ETA minuter',
    sendAutomaticEtaSmsHeading: 'ETA SMS',
    createNew: 'Skapa ny',
    serviceAndVasCodes: 'Tjänster och VAS-koder',
    successfullyAdded: 'Tjänstkoppling har lagts till i listan',
    successfullyUpdated: 'Tjänstkoppling har uppdaterats',
    successfullyDeleted: 'Tjänstkoppling har raderats',
    editService: 'Redigera tjänst',
    createNewService: 'Skapa ny tjänst',
    settingsHeading: 'Inställningar för tjänst eller VAS',
    selectLevel: 'Välj nivå',
    standardLevel: 'Standard',
    customerLevel: 'Kund',
    customerSpecific: 'Kundanpassad',
    selectServiceType: 'Välj typ av tjänst',
    vasToolTip: 'Tilläggstjänst, t.ex. ID-kontroll',
    customerNumber: 'Kundnummer',
    pickupTimeInSeconds: 'Servicetid för upphämtning (sekunder)',
    pickupPreparationTime: 'Förberedelsetid för upphämtning (sekunder)',
    deliveryTimeInSeconds: 'Servicetid för leverans (sekunder)',
    deliveryPreparationTime: 'Förberedelsetid för leverans (sekunder)',
    pickupDurationSecondsApartment: 'Upphämtningstid för lägenheter (sekunder)',
    deliveryDurationSecondsApartment: 'Leveranstid för lägenheter (sekunder)',
    deliveryDurationApartmentHeading: 'Leveranstid för lägenheter (för närvarande endast för H2)',
    timeWindowInMinutes: 'Tidsfönster (minuter)',
    stopsLeftHeading: 'När vill du att exakt ETA ska visas för kunden?',
    stopsLeftDescription: 'Om detta fält lämnas tomt visas tidsfönstret',
    amountOfStops: 'Antal stopp',
    flexibleDelivery: 'Flexibel leverans',
    flexibleDeliveryDescription: 'Tillåt mottagaren att välja att paketet lämnas utanför dörren',
    flexibleDeliveryCheckboxText: 'Ja, mottagaren ska kunna välja',
    flexOptions: 'Flex-alternativ',
    flexOptionsDescription:
      'Vi erbjuder kunderna två olika Flex-leveransalternativ. Det första alternativet, Utökad Flex, låter föraren lämna varorna på olika överenskomna platser vid leveransadressen. Det andra alternativet, Flex, är ett enklare alternativ där varorna placeras vid fastighetsgränsen. Utökad Flex är standardalternativet, men kunder kan välja att byta till det enklare Flex-alternativet om så önskas.',
    unattendedFlex: 'Flex (Obevakad)',
    extendedFlex: 'Utökad Flex (Flex)',
    linkTextToService: 'Länka text till tjänst',
    linkTextToServiceDescription: 'Om ingen text väljs används standardtext',
    defaultText: 'Standardtext',
    listOfServicesAndVases: 'Lista över tjänster och VAS-koder',
    searchService: 'Sök efter tjänst, VAS eller kundnummer',
    customizedText: 'Anpassad text',
    deleteModalTitle: 'Radera tjänstkoppling',
    deleteModalDescription: 'Den här åtgärden kan inte ångras',
    infoModal: {
      title: 'Vad visas var i Glow',
      subHeading1: 'Planerare och förare',
      description1: 'Internt namn: Tjänstens namn, t.ex. "Hemleverans"',
      description2:
        'Intern beskrivning: Utökad information om tjänsten, t.ex. "Denna ska bäras in i mottagarens valda rum."',
      subHeading2: 'Kunder och mottagare',
      description3: 'Externt namn: Tjänstens namn, t.ex. "Hemleverans"',
      description4:
        'Extern beskrivning: Utökad information om tjänsten, t.ex. "Dina varor kommer att bäras in i ett rum du väljer".'
    },
    routeOptimizing: 'Ruttplanering',
    routeOptimizingDescription:
      'Den information du anger här kommer att åsidosätta standardtiden och påverka ruttoptimeringen. Förberedelsetid kan användas för tjänster där många försändelser levereras till samma mottagare. Den första försändelsen kommer då att ha en leveranstid som motsvarar förberedelsetiden plus leveranstiden, medan ytterligare försändelser till samma mottagare endast får en leveranstid som motsvarar leveranstiden. <br><br>Standardinställning för upphämtningar är 15 sekunders förberedelsetid och 1 sekund per sändning.<br>Standardinställning för leveranser är 180 sekunders förberedelsetid och 10 sekunder per sändning.<br><strong>Observera att det kan ta upp till 10 minuter innan eventuella ändringar visas i systemet.</strong>',
    settingsRecipientTrackingPage: 'Mottagarens spårningssida',
    etaComponentHeading: 'Visa exakt ETA på mottagarens sida',
    etaComponentDescription:
      'Om du aktiverar detta kan du välja när exakt ETA ska visas för mottagaren istället för tidsfönstret.',
    displayExactEta: 'Ja, visa exakt ETA',
    stopsLeftSelected: 'Antal stopp kvar till leverans',
    minutesLeftSelected: 'Antal minuter kvar till leverans',
    numberOfMinutes: 'Antal minuter',
    numberOfStops: 'Antal stopp',
    sendAutomaticEtaSmsTitle: 'Skicka automatiskt SMS till mottagaren',
    sendAutomaticEtaSmsDescription:
      'Om du aktiverar detta inaktiveras samtidigt funktionen för föraren att skicka SMS från förarappen.',
    sendAutomaticEtaSms: 'Skicka SMS automatiskt',
    missingNumberOfStops: 'Vänligen ange ett giltigt antal stopp när "Skicka SMS automatiskt" är markerat',
    missingNumberOfMinutes: 'Vänligen ange ett giltigt antal minuter när "Skicka SMS automatiskt" är markerat',
    minutesNotInRange: 'Vänligen ange minuter mellan {{from}} och {{to}}',
    serviceDeliveryType: 'Typ av tjänstleverans',
    noServiceDeliveryTypeSelected: 'Ej valt',
    serviceDeliveryTypes: { Delivery: 'Leverans', Return: 'Retur', PickupPoint: 'Upphämtningspunkt' },
    Delivery: 'Leverans',
    Return: 'Retur',
    Pickup: 'Upphämtning',
    PickupPoint: 'Upphämtningspunkt',
    courierApp: 'Chaufförsapp',
    allowCourierDescription: 'Tillåt chauffören att acceptera eller avvisa sändningar med denna tjänstekod',
    allowCourierCheckbox: 'Ja, chauffören ska kunna välja',
    none: 'Ingen'
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Finansiella intressenter',
    item: 'Artikel',
    customerTotal: 'Kundens total',
    unitTotal: 'Enhetstotal',
    orderTotal: 'Ordertotal',
    disconnectToOrginalOrder: 'Koppla bort från ursprungligt sändningsnummer'
  },
  upsalesRulesAdmin: {
    title: 'Merförsäljningsregler',
    titleSingular: 'Merförsäljningsregel',
    name: 'Namn',
    type: 'Typ',
    searchPlaceholder: 'Sök uppförsäljningsregler',
    settings: 'Inställningar',
    successfullyAdded: '{{name}} lades till i listan',
    successfullyUpdated: '{{name}} uppdaterades',
    createNewRule: 'Skapa ny regel för merförsäljning',
    edit: 'Redigera',
    serviceUpgrade: 'Service uppgradering',
    SERVICE_UPGRADE: '$t(upsalesRulesAdmin.serviceUpgrade)',
    shorterTimeWindow: 'Kortare tidsfönster',
    SHORTER_TIME_WINDOW: '$t(upsalesRulesAdmin.shorterTimeWindow)',
    ruleName: 'Namn på merförsäljningsregel',
    serviceUpgradeDescription1: 'Tjänsten uppgraderas från 3123 till 2870.',
    serviceUpgradeDescription2:
      'VAS 1381 kommer automatiskt att läggas till för att säkerställa att föraren får rätt betalning.',
    zipCodeRangeTitle: 'Postnummer',
    zipCodeRangeDescription:
      'Välj vilka postnummer du vill inkludera eller exkludera i regeln. Om du behöver ta bort ett specifikt postnummer eller ett område från ett inkluderat område, använd exkluderingsalternativet för att finjustera ditt val.',
    fromZipCode: 'Postnummer från',
    toZipCode: 'Postnummer till',
    addRange: 'Lägg till postnummerområde',
    addZipCode: 'Lägg till postnummer',
    noZipCodeRangesAdded: 'Du måste ange ett postnummerområde',
    zipCodeRangeError: '"Postnummer från" får inte vara större än "Postnummer till"',
    deleteModalTitle: 'Radera merförsäljningsregel',
    deleteModalDescription: 'Du kommer inte kunna ångra denna åtgärd',
    successfullyDeleted: 'Merförsäljningsregeln raderades',
    shorterTimeWindowDescription1: 'Kortare tidsfönster är tillgängligt för 3332',
    windowOnlyInEvening: 'Kortare tidsfönster ska endast vara tillgängligt på kvällen',
    timeWindowOffer: 'Vilket tidsfönster ska erbjudas mottagaren?',
    oneHour: '1 timme',
    twoHours: '2 timmar',
    threeHours: '3 timmar',
    mustSelectTimeWindow: 'Du måste ange det tidsfönster som erbjuds mottagaren',
    include: 'Inkludera',
    exclude: 'Exkludera',
    zipCodeRangeType: 'Typ',
    exactZipCode: 'Exakt',
    zipCodeRange: 'Område',
    zipCode: 'Postnummer',
    mustSelectCountry: 'Du måste välja ett land först',
    includedZipCodes: 'Inkluderade postnummer ({{count}})',
    excludedZipCodes: 'Exkluderade postnummer ({{count}})',
    noZipCodesAddedYet: 'Inga postnummer har lagts till ännu',
    noMatchOnZipCodeSearch: 'Inget postnummer hittades. Försök filtrera med ett annat postnummerområde.',
    zipCodesFound: '{{count}} postnummer hittat',
    zipCodesFound_other: '{{count}} postnummer hittade',
    filterOnDepartments: 'Filtrera på avdelningar',
    UPSALES_RULE_COLLISION_OCCURRED:
      'Regeln finns redan! Ta bort antingen följande avdelningar: {{departments}} eller följande kunder: {{customers}}',
    status: 'Status',
    active: 'Aktiv',
    paused: 'Pausad',
    pauseRule: 'Pausa regel',
    activateRule: 'Aktivera regel',
    activateRuleModalDescription:
      'Du håller på att aktivera regeln. Detta innebär att merförsäljning kommer att vara tillgänglig för mottagarna. Vill du fortsätta?',
    pauseRuleModalDescription:
      'Du håller på att pausa regeln. Detta innebär att merförsäljning inte kommer att vara tillgänglig för mottagarna. Vill du fortsätta?',
    successfullyActivated: 'Merförsäljningsregeln aktiverades',
    successfullyPaused: 'Merförsäljningsregeln pausades'
  },
  billingOrder: {
    create: 'Skapa faktureringsorder',
    copyTo: 'Kopiera till faktureringsorder',
    copyToBillingOrder: 'Kopiera till faktureringsorder',
    keepConnection: 'Behåll koppling',
    disconnect: 'Koppla från',
    creditMode: 'Kredit',
    debitMode: 'Debet',
    createCredit: 'Skapa kreditnota',
    credit: 'Kreditnota',
    done: 'Faktureringsorder skapades. Försändelse-ID: {{shipmentId}}',
    invalidOrderForEdit:
      'Denna order kan inte redigeras. Endast fakturerings- eller kreditordrar som inte har fakturerats kan redigeras.',
    cannotBeCredited: 'Du kan inte kreditera en order som är fakturerad i {{systemId}}.',
    invalidOrderForCopy: 'Kan inte kopiera kreditnota.',
    standaloneInvoice: 'Separat faktura',
    standaloneInvoiceLabel:
      'Jag vill att denna order behandlas individuellt och inte grupperas med andra ordrar för fakturering',
    noUnitNotSelfBilled: 'Order utan enhet kommer inte att avräknas.',
    manualInvoiceInformation: {
      descriptionText:
        'Om det här fältet är ifyllt med faktureringsinstruktioner, så kommer sändningen inte bli automatiskt fakturerad',
      label: 'Manuell fakturahantering'
    },
    expensive: 'Det ifyllda priset verkar vara ovanligt högt',
    creditInvoiceText: 'Kredit för försändelse {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Kundkredit för försändelse {{shipmentId}}',
      PICKUP_LEG: 'Kredit för upphämtning av försändelse {{shipmentId}}',
      DELIVERY_LEG: 'Kredit för leverans av försändelse {{shipmentId}}'
    },
    legSelectionLabel: 'Välj transportben',
    legSelectionError: 'Välj vilket transportben som ska krediteras',
    legSelection: {
      NONE: 'Ingen',
      CUSTOMER_ORDER: 'Kundorder',
      PICKUP_LEG: 'Upphämtning',
      DELIVERY_LEG: 'Leverans'
    },
    wrongPageWarning: 'Faktureringsordrer kan inte nås från den här sidan',
    wrongPageLink: 'Gå till sidan för faktureringsorderdetaljer',
    type: {
      Invoice: 'Fakturaorder',
      Invoice_other: 'Fakturaorder',
      Credit: 'Kreditnota',
      Credit_other: 'Kreditnotor',
      InternalTrade: 'Intern handelsorder',
      InternalTrade_other: 'Interna handelsorder'
    }
  },
  formValidation: {
    mustProvideName: 'Du måste ange ett namn',
    mustProvideDescription: 'Du måste ange en beskrivning',
    mustProvideServiceCode: 'Du måste ange en tjänstekod',
    mustProvideCalendarDays: 'Du måste ange kalenderdagar',
    mustProvideCutOffTime: 'Du måste ange en sluttid',
    mustProvideCutOffMinutes: 'Du måste ange avstängningsminuter',
    mustProvideDeliveryAttempts: 'Du måste ange antal leveransförsök',
    mustProvideCustomer: 'Du måste ange en kund',
    mustProvideQuantity: 'Du måste ange en kvantitet',
    mustProvideArticle: 'Du måste ange en artikel',
    mustProvideDate: 'Du måste ange ett datum',
    mustProvideTime: 'Du måste ange en tid',
    mustProvideDuration: 'Du måste ange en varaktighet',
    mustProvideCustomerOrUnitAmount: 'Du måste ange kund- eller enhetsbelopp',
    allowedRangeIs: 'Tillåtet intervall är {{min}} - {{max}}'
  },
  units: {
    title: 'Enheter',
    new: 'Skapa ny enhet',
    connectFromOtherDepartments: 'Anslut från andra avdelningar',
    connect: {
      title: 'Anslut enheter till den aktuella avdelningen',
      description: 'Du kan bara söka efter enheter i avdelningar du har åtkomst till',
      selected: 'Valda enheter',
      noneSelected: 'Inga enheter',
      submit: 'Anslut'
    },
    assigned: 'Enhet(er) har anslutits framgångsrik'
  },
  dispatchModal: {
    title: 'Upphämtningar och leveranser på rutt {{name}}',
    overridePalletRule: {
      question: 'Åsidosätta pallregeln?',
      description:
        'Sändningen innehåller pallar, men fordonet på denna rutt är inte markerat som att det kan transportera pallar. Vill du ändå lägga den på rutten?',
      confirm: 'Lägg på rutten ändå'
    },
    palletRule: 'Pallregel',
    ignorePalletRule: 'Tillåt pallar på fordon som inte kan transportera pallar',
    partialForcedOrderLabel: 'Definiera ordning för områden/ordrar',
    partialForcedOrder: 'Vald ordning',
    partialForcedOrderInfo:
      'Du har valt att ange ordningen för utvalda stopp/områden. Övriga stopp optimeras runt dessa.',
    flex: 'Flex',
    force: 'Force',
    optimizingEngine: 'Optimeringsmotor',
    invalidRouteOrder: 'Leveranser kan inte ske före upphämtningar. Ändra ruttordningen',
    submitDisabled: 'Planera om rutten för att aktivera knappen',
    replanDisabled: 'Ruttordningen måste vara giltig för att planera om',
    replan: 'Planera om rutt',
    noShipments: 'Inga sändningar på rutten',
    openRowMenu: 'Öppna radmeny',
    openPlannedStopMenu: 'Öppna meny för planerat stopp',
    newPositionForStop: 'Välj ny position för stoppet',
    noShipmentsDescription:
      'Du har avmarkerat alla sändningar på rutten, tryck på <i>Bekräfta rutt</i> för att spara ändringar',
    unassignBreakFromRoute: 'Klicka för att ta bort rast från rutt',
    editBreakOnRoute: 'Klicka för att redigera rast på rutt',
    routeEnd: 'Ruttslut',
    routeStart: 'Ruttstart',
    earliestStartOfBreak: 'Tidigaste start av rast',
    latestStartOfBreak: 'Senaste start av rast',
    overrideOptimizingEngine: 'Åsidosätt standardoptimeringsmotorn',
    warning:
      'Du har valt att inte använda en optimeringsmotor för denna rutt. Detta kommer att påverka mottagarens upplevelse.',
    flexDisabled: 'Det är inte tillåtet att <strong>flexa</strong> enskilda ordrar i en grupp',
    forceDisabled: 'Det är inte tillåtet att <strong>forca</strong> enskilda ordrar i en grupp',
    removeDisabled: 'Det är inte tillåtet att <strong>ta bort</strong> enskilda ordrar i en grupp',
    orderDisabled: 'Det är inte tillåtet att <strong>ändra ordningen</strong> på enskilda ordrar i en grupp',
    plannedStopRowDisabled:
      'Du har inte tillåtelse att <strong>ändra ordningen</strong> på ett planerat stopp medan du redigerar',
    showStops: 'Visa stopp',
    viewStopsOnSameAddress: 'Visa stopp på samma adress grupperade',
    addPlannedStopLocations: 'Lägg till planerade stopplokation',
    selectPlannedStopLocation: 'Välj planerad stopplokation',
    plannedStop: 'Planerat stopp',
    visitEarliest: 'Tidigast besök',
    visitLatest: 'Senast besök',
    serviceTime: 'Varaktighet',
    addPlannedStop: 'Lägg till stopp och planera om',
    updatePlannedStop: 'Uppdatera stopp och planera om',
    editPlannedStopOnRoute: 'Redigera planerat stopp på rutt',
    unassignPlannedStopFromRoute: 'Ta bort planerat stopp från rutt',
    settings: 'Inställningar',
    multipleRecipients: 'Flera mottagare ({{number}})',
    multiplePickups: 'Flera upphämtningar ({{number}})',
    mustProvideStopLocation: 'Du måste ange en stoppplats',
    editingLockBanner: 'Rutten redigeras av {{name}} sedan {{time}}.',
    editingLockBannerBody: 'Du måste ta över ruttplaneringen för att planera om rutten.',
    takeOver: 'Ta över',
    routeChangedByOtherUser: '{{name}} är klar med redigeringen. Ladda om för att fortsätta.',
    reloadRoute: 'Ladda om rutt',
    noShipmentsRouteUpdated: 'Ladda om rutten för att se sändningar',
    duplicateTabBanner: 'Denna rutt är öppen i en annan flik (sedan kl. {{time}}).',
    duplicateTabBannerBody: 'Ta över här för att redigera i den här fliken.'
  },
  vehicle: {
    createNewVehicle: 'Skapa nytt fordon',
    vehiclesInDepartment: 'Fordon i {{departmentName}}',
    listAllVehicle: 'Lista alla fordon i denna avdelning',
    deleteSuccessMessage: 'Fordonet har tagits bort',
    createdSuccessMessage: 'Fordonet har skapats',
    updatedSuccessMessage: 'Fordonet har uppdaterats',
    deleteVehicle: 'Ta bort fordon',
    notRecover: 'Denna åtgärd kan inte återställas',
    createVehicle: 'Skapa fordon',
    editVehicle: 'Redigera {{name}}',
    vehicleInformation: 'Fordonsinformation',
    selectFuelType: 'Välj bränsletyp',
    selectEuroClass: 'Välj Euro-klass',
    settings: 'Inställningar',
    activeDriver: 'Aktiv förare',
    noVehicleControl: 'Ingen fordonskontroll',
    slower: 'Långsammare',
    slow: 'Långsam',
    normal: 'Normal',
    faster: 'Snabbare',
    speedFactorVehicle: 'Fordonets hastighetsfaktor',
    driverSpeed: 'Förarehastighet',
    serviceSpeed: 'Servicehastighet',
    defaultStartLocation: 'Standard startplats är avdelningsadressen',
    specifyEndLocation: 'Ange slutdestination',
    earliest: 'Tidigast',
    latest: 'Senast',
    maxRangeKm: 'Räckvidd',
    weightCapacity: 'Viktkapacitet',
    volumeCapacity: 'Volymkapacitet'
  },
  lmEvents: {
    heading: 'LM-händelser',
    event: 'Händelse',
    lmEventReasonAction: 'LM händelse-orsak-åtgärd',
    eventTime: 'Händelsetid',
    eventSentAt: 'Händelse skickad',
    lmPayload: 'LM-payload',
    view: 'Visa',
    enterShipmentId: 'Du måste ange ett sändningsnummer',
    searchForShipmentId: 'Sök efter sändningsnummer'
  },
  cms: {
    scheduleBanner: 'Schemalägg banner',
    cms: 'CMS',
    publicationDate: 'Publiceringsdatum',
    lastEdited: 'Senast redigerad',
    dateForUnpublish: 'Datum för avpublicering',
    createNewBanner: 'Skapa ny banner',
    createNewWhatsThisModal: 'Skapa ny "Vad är detta"-modal',
    publish: 'Publicera',
    schedule: 'Schemalägg',
    unpublish: 'Avpublicera',
    savePublish: 'Spara och publicera',
    saveAsDraft: 'Spara som utkast',
    saveAsDraftUnpublish: 'Spara som utkast och avpublicera',
    noBannersFound: 'Inga banners hittades',
    noModalsFound: 'Inga modaler hittades',
    DRAFT: 'Utkast',
    PUBLISHED: 'Publicerad',
    SCHEDULED: 'Schemalagd',
    content: 'Innehåll',
    nameOfBanner: 'Namn på banner',
    placementOfBanner: 'Placering av banner',
    placementOfBannerDescription:
      'Klistra in Glow-URL:en du vill lägga till en banner på. Om du vill publicera en banner för alla avdelningar eller specifika, kan du antingen trycka på knappen "Lägg till URL" eller ändra länken själv.',
    urlToPageInGlow: 'URL till sida i Glow',
    addUrl: 'Lägg till URL',
    typeOfBanner: 'Typ av banner',
    typeOfBannerDescription: 'Välj mellan Varning (orange), Neutral (grå) eller Fel (röd).',
    bannerNeutral: 'Neutral (grå)',
    bannerWarning: 'Varning (orange)',
    bannerError: 'Fel (röd)',
    links: 'Länkar',
    linksDescription:
      'Artikellänken placeras direkt efter brödtexten. Om du lägger till en "Gå tillbaka till gammal sida"-länk, placeras den före brödtexten.',
    goBackToOldPageLink: 'Länk för att gå tillbaka till gammal sida',
    messageInBanner: 'Meddelande i banner',
    messageInBannerDescription:
      'Engelska är obligatoriskt. Om inga andra språk väljs, används engelska som reserv på alla sidor.',
    addAdditionalLanguages: 'Lägg till ytterligare språk',
    bannerText: 'Text',
    nameOfLink: 'Namn på länk',
    englishText: 'Engelsk text',
    englishLinkText: 'Engelska: länkens namn',
    selectLanguage: 'Välj språk',
    addNewLanguage: 'Lägg till nytt språk',
    deleteBanner: 'Radera {{name}}',
    bannerWasSaved: '{{name}} sparades framgångsrikt',
    bannerWasPublished: '{{name}} publicerades framgångsrikt',
    bannerWasScheduled: '{{name}} schemalades framgångsrikt',
    articleLink: 'Artikellänk',
    goBackToOldPage: 'Gå tillbaka till gammal sida',
    previousPageNote: 'Obs: använd jokertecknen *department-id* och *date* i detta fält',
    selectTime: 'Välj tid',
    setStartDate: 'Ange startdatum för banner',
    setEndDate: 'Ange slutdatum för banner',
    endTimeIsBeforeStartTime: 'Sluttiden kan inte vara före starttiden',
    endDateIsBeforeStartDate: 'Slutdatum kan inte vara före startdatum',
    oneBannerPerPageError: 'Endast en banner per sida är tillåten. URL överlappar med befintliga banner: {{banners}}',
    mustProvideUrl: 'Du måste ange en URL',
    mustProvideNameOfBanner: 'Du måste ange namn på banner',
    mustProvideNameOfModal: 'Du måste ange namn på modal',
    mustProvideEnglishText: 'Du måste ange engelsk text',
    mustProvideArticleLink: 'Du måste ange artikellänk',
    mustProvideNameOfArticleLink: 'Du måste ange namn på artikellänken',
    mustProvideDate: 'Du måste ange ett datum',
    invalidArticleLink: 'Du måste ange en giltig artikellänk, t.ex. https://example.com',
    errorDuplicateBanner: 'Bannernamnet måste vara unikt. En banner med detta namn finns redan.',
    draftScheduleTooltip: 'Rensa din schemaläggning för att spara som utkast',
    banner: 'Banner',
    listOfBanners: 'Lista över banners',
    whatsThisModal: 'Vad är detta-modal',
    whatsThis: 'Vad är detta',
    listOfWhatsThisModals: 'Lista över "Vad är detta"-modaler',
    nameOfWhatsThisModal: 'Namn på "Vad är detta"-modal',
    descriptionWhatsThisModal:
      'Namnet måste vara unikt. Ett tips är att namnge "Vad är detta"-modalen beroende på dess placering, till exempel "Admin Pre-advice" eller "Planner Live".',
    nameOfModal: 'Namn på modal',
    pageLinkOfModal: 'Sida där modalen ska visas',
    pageLinkOfModalDescription:
      'Klistra in Glow-URL du vill lägga till modalen på. Kom ihåg att ändra avdelnings-ID till * för att modalen ska publiceras på alla avdelningar.',
    linkToPageGlow: 'Länk till sida i Glow',
    modalPreviewEmptyTitle: 'Ingen information ännu',
    modalPreviewEmptyDescription: 'Du måste lägga till information för att få en förhandsgranskning av modalen',
    addTextForModal: 'Lägg till text för modal',
    addTextForModalDescription:
      'Engelska är obligatoriskt och kommer att användas som reserv på alla modaler om du inte skriver någon information för de andra språken. Klicka på "Vad är detta"-länken för att få tips om hur du utformar länken.',
    searchBannerPlaceholder: 'Sök efter banner',
    searchModalPlaceholder: 'Sök efter modal',
    cmsNews: 'Uppdatering',
    cmsNewsLabel: 'Uppdateringar',
    listOfCMSNews: 'Lista över uppdateringar',
    noCMSNewsFound: 'Inga uppdateringar hittades',
    searchCMSNewsPlaceholder: 'Sök efter uppdatering',
    cMSNewsSettingsTitle: 'Placering av uppdatering',
    cMSNewsSettingsDescription:
      'Din uppdatering visas på startsidan och syns för alla användare när de loggar in på Glow.',
    nameOfCMSNews: 'Namn på uppdatering',
    descriptionOfCMSNewsName: 'Namnge din uppdatering för att enkelt kunna hitta den. Namnet måste vara unikt.',
    typeOfCMSNews: 'Typ av uppdatering',
    typeOfCMSNewsDescription: 'Välj mellan Servicestatus, Ny funktion eller Information.',
    selectTypeOfCMSNews: 'Välj typ av uppdatering',
    newFeatureCMSNews: 'Ny funktion',
    serviceStatusCMSNews: 'Servicestatus',
    informationCMSNews: 'Information',
    NEW_FEATURE: 'Ny funktion',
    SERVICE_STATUS: 'Servicestatus',
    INFORMATION: 'Information',
    scheduleCMSNews: 'Schemalägg uppdatering',
    scheduleCMSNewsDescription: 'När du schemalägger en uppdatering kommer du inte att kunna spara den som ett utkast.',
    setStartDateForCMSNews: 'Ange startdatum för uppdatering',
    setEndDateForCMSNews: 'Ange slutdatum för uppdatering',
    cMSNewsPreviewEmptyTitle: 'Ingen information ännu',
    cMSNewsPreviewEmptyDescription: 'Du måste lägga till information för att få en förhandsgranskning av uppdateringen',
    addTextForCMSNews: 'Lägg till text för uppdatering',
    addTextForCMSNewsDescription:
      'Engelska är obligatoriskt och kommer att användas som reserv på alla uppdateringar om du inte skriver någon information för de andra språken. Klicka på "Vad är detta"-länken för tips om hur du utformar uppdateringen.',
    mustProvideNameOfCMSNews: 'Du måste ange namn på uppdatering',
    createNewCMSNews: 'Skapa ny uppdatering',
    continueToYourPage: 'Fortsätt till din sida',
    clearSelection: 'Rensa val'
  },
  productionTimeWindow: {
    addNew: 'Lägg till nytt produktionstidsfönster',
    search: 'Sök efter produktionstidsfönster',
    description:
      'Här kan du ställa in ett produktionstidsfönster för beställningar som har ett mottagar-ID. Du kan söka på mottagar-ID eller postnummerintervall - vid sökning på postnummerintervall måste du även välja land. För att lägga till ett produktionstidsfönster, klicka på "Lägg till nytt" eller sök efter ett befintligt för att redigera.',
    addNewDescription:
      'Lägg till ett tidsfönster för när vi kan leverera paket till ett mottagar-ID. Om produktionstidsfönstret är tillagt kommer den här informationen att användas vid ruttplanering i stället för servicetidsfönstret.',
    recipientId: 'Mottagar-ID',
    searchForRecipientId: 'Sök efter mottagar-ID',
    recipientName: 'Mottagarnamn',
    address: 'Adress',
    postalCode: 'Postnummer',
    country: 'Land',
    selectCountry: 'Välj land',
    addedSuccess: 'Produktionstidsfönster för {{recipientId}} har lagts till.',
    recipientIdValidation: 'Du måste ange mottagar-ID',
    timeWindowValidation: 'Du måste ange ett tidsintervall',
    invalidRecipientId: 'Ogiltigt mottagar-ID',
    postalCodeRangeRequiredTogether: 'Postnummer från och till måste båda fyllas i',
    postalCodeRangeRequiresCountry: 'Välj ett land för att söka på postnummerintervall',
    createdAt: 'Skapad den',
    from: 'Från',
    to: 'Till',
    editSuccess: 'Produktionstidsfönster för {{recipientId}} har ändrats.',
    delete: 'Ta bort produktionstidsfönster för {{recipientId}}?',
    deleteDescription:
      'Att ta bort produktionstidsfönstret innebär att servicetidsfönstret kommer att användas vid ruttplanering för detta mottagarID. Vill du fortsätta?',
    deleteSuccess: 'Produktionstidsfönster för {{recipientId}} har raderats.',
    noResults: 'Inget produktionstidsfönster hittades',
    noResultsDescription:
      'Försök att söka med ett annat mottagar-ID, eller sök på postnummerintervall i stället. Du kan också skapa ett nytt produktionstidsfönster genom att trycka på knappen uppe i högra hörnet.',
    noResultsPostalCodeDescription:
      'Inget produktionstidsfönster matchar detta postnummerintervall. Försök att söka på mottagar-ID utan postnummerintervall i stället.',
    fromTimeAfterToTime: "'Från'-tiden måste vara före 'till'-tiden"
  },
  loadCarrierModal: {
    title: 'Lastbärargrupp: {{loadCarrierId}}',
    description: 'Leveranser i gruppen'
  },
  routesOverview: {
    palletRuleOverridden: 'Pallregel åsidosatt',
    routeNotFoundTitle: 'Rutten hittades inte',
    routeNotFoundDescription: 'Den kan ha raderats.',
    shipmentStatus: {
      CREATED: 'Skapad',
      ASSIGNED: 'Tilldelad',
      UNASSIGNED: 'Ej tilldelad',
      COLLECTED: 'Upphämtad',
      DELIVERED: 'Levererad',
      DEVIATED: 'Avvik',
      COMMENT: 'Kommentar',
      RESOLVED: 'Bekräftad',
      UNRESOLVED: 'Obekräftad',
      OFFERED: 'Erbjuden',
      REJECTED: 'Nekad',
      ACCEPTED: 'Accepterad',
      RETURNED: 'Returnerad',
      DELETED: 'Borttagen',
      UNCONFIRMED: 'Obekräftad',
      REFUSED: 'Nekad'
    },
    offeredAtTime: 'Order erbjuden kl. {{time}}',
    plannedRoute: 'Planerad rutt',
    routes: 'Rutter',
    routesCount: '{{filtered}} av {{total}} rutter',
    searchRouteOrDriver: 'Sök ruttnamn eller förarnamn',
    manuallyAdjustRoute: 'Justera rutt manuellt',
    changeRoute: 'Byt rutt',
    plannedRouteTime: 'Planerad rutt tid',
    notOptimized: {
      title: 'Rutten är inte optimerad',
      optimizationFailed:
        'Ruttoptimeringen misslyckades, så rutten använder en icke-optimerad fallback. ETA och ETD är inte tillgängliga.',
      manuallyPlanned: 'Rutten planerades manuellt utan optimering, så ETA och ETD är inte tillgängliga.'
    },
    statusOfRoute: 'Ruttstatus',
    incorrectETA: 'Mottagarens spårningssida visar felaktiga ankomsttider',
    adjustedFinishTime: 'Justera tid för sista leverans: {{time}}',
    driverIsDelayed: 'Föraren är {{delayed}} min {{suffix}}.',
    deviations: '{{count}} avvikelse',
    deviations_other: '{{count}} avvikelser',
    successfullyDeleted: 'Lyckades radera {{name}}',
    successfullyReversedDeliveryOrder: 'Omvända leveransordningen lyckades',
    colorPicker: 'Färgval',
    deleteAllRoutesConfirmDialogText: 'Är du säker på att du vill ta bort alla rutter?',
    stops: 'Stopp',
    stop: 'Stopp',
    waitingTime: 'Väntetid',
    totalWaitingTime: 'Total väntetid',
    stopsAfterPlannedEndTime: '{{count}} leverans efter planerad sluttid ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} leveranser efter planerad sluttid ({{time}}).',
    unassignShipmentFromRoute: 'Ta bort försändelse från rutt',
    unassign: 'Ta bort',
    priceInformation: 'Prisinformation',
    billingOrderShipment: 'Faktureringsorder',
    trips: 'Resor',
    routeSettings: 'Ruttinställningar',
    driverPhoneNumber: 'Förarens telefonnummer',
    selectVehicle: 'Välj fordon',
    nameOfRoute: 'Namn på rutt',
    setStartTime: 'Ange starttid',
    setEndDate: 'Slutdatum',
    setEndTime: 'Ange sluttid',
    endDateValidationError: 'Slutdatum måste vara ruttdatumet eller dagen efter',
    endTimeValidationError: 'Sluttid måste vara efter starttid',
    addMapArea: 'Lägg till kartområde',
    editMapArea: 'Redigera kartområde',
    areaWasUpdated: 'Kartområde redigerat på {{name}}',
    areaWasCreated: 'Kartområde tillagt till {{name}}',
    areaWasDeleted: 'Kartområde borttaget från {{name}}',
    addAreaRoute: 'Lägg till område till rutt',
    updateAreaRoute: 'Uppdatera område för rutt',
    deleteMapArea: 'Ta bort kartområde',
    templates: 'Mallar',
    loadTemplate: 'Ladda mall',
    deleteTemplate: 'Ta bort mall',
    saveAsTemplate: 'Spara som mall',
    saveTemplate: 'Spara mall',
    templateWasCreated: '{{name}} skapades',
    templateWasLoaded: '{{name}} laddades',
    templateWasDeleted: '{{name}} togs bort',
    loadTemplateSubHeading: 'Välj mallen du vill lägga till.',
    createANew: 'Skapa ny',
    orUpdateExisting: 'eller uppdatera befintlig',
    saveTemplateRulesNote:
      'Endast postnummer som är kopplade till en ruttregel tas med i mallen. Fristående postnummer sparas inte.',
    saveTemplateDepartmentGroupNote:
      'Den här vyn omfattar flera avdelningar. Ruttregler från andra avdelningar tas inte med i den här mallen.',
    deleteTemplateSubHeading: 'Välj mallen du vill ta bort.',
    defaultTemplate: 'Standardmall',
    defaultTemplateSubHeading:
      'Välj den mall du vill använda som standard. Denna mall kan sedan användas för automatisk skapning av rutter, vilket aktiveras i menyalternativet Avdelningar under Administration.',
    setDefaultTemplates: 'Ange standardmall',
    selectDefaultTemplate: 'Välj standardmall för {{department}}',
    defaultTemplates: 'Standardmallar',
    normalTemplates: 'Vanliga mallar',
    templateDefaultsSet: 'Standardmallar satta',
    selectTemplate: 'Välj mall',
    selectTemplateToOverride: 'Välj mall att skriva över',
    nameOfTemplate: 'Mallnamn',
    templateIsRequired: 'Mall måste väljas',
    templateOrNameIsRequired: 'Mall eller namn måste väljas',
    areYouDonePlanning: 'Är du klar med ruttplaneringen?',
    noBackPage: 'Nej, gå tillbaka till sidan',
    yesDone: 'Ja, jag är klar',
    manageRouteRules: 'Hantera ruttregler',
    eligibleForAutoDispatch: 'Kvalificerad för auto-dispatch av upphämtningsordrar',
    postalCodeRangesSet: 'Postnummerområden är satta',
    unsavedPostalCodeRule: 'Lägg till postnummerregeln innan du sparar',
    applyToConnectedRule: 'Använd dessa ändringar på den kopplade ruttregeln "{{name}}"',
    serviceExclusionDescription:
      'Ordrar med någon av dessa tjänstekoder tilldelas aldrig den här rutten av auto-dispatch.',
    postalCodeRulesSaved: 'Postnummerregler uppdaterade',
    postalCodeRulesSavedAndApplied: 'Postnummerregler uppdaterade och även tillämpade på regeln "{{name}}"',
    postalCodesTab: 'Postnummer',
    routeRuleTab: 'Ruttregel',
    connectRouteRuleSubHeading:
      'Koppla en ruttregel till denna rutt. Postnummerreglerna på rutten skrivs över med reglerna från den valda ruttregeln.',
    selectRouteRule: 'Välj ruttregel',
    routeRuleIsRequired: 'Ruttregel måste väljas',
    routeRuleConnected: 'Postnummerreglerna skrevs över från ruttregeln "{{name}}"',
    postalCodeRuleType: 'Regeltyp',
    includePostalCodes: 'Inkludera',
    excludePostalCodes: 'Exkludera',
    postalCodeRange: 'Intervall',
    exactPostalCode: 'Exakt postnummer',
    postalCodeFrom: 'Från postnummer',
    postalCodeTo: 'Till postnummer',
    addPostalCodeRule: 'Lägg till postnummerregel',
    noPostalCodeRules: 'Inga tillagda ännu',
    savedPostalCodeRules: 'Sparade postnummerregler',
    postalCodeRuleRequired: 'Postnummer krävs',
    postalCodeRuleConflict: {
      duplicate: 'Denna postnummerregel finns redan',
      overlap: 'Regeln överlappar den befintliga regeln "{{rule}}"',
      excludeNotContained: 'Exkluderingsregeln "{{rule}}" måste vara inom ett inkluderingsintervall',
      excludeCoversInclude: 'En exkluderingsregel kan inte täcka hela inkluderingsintervallet "{{rule}}"'
    },
    skipAutoDispatch: 'Inaktivera auto-dispatch',
    enableAutoDispatch: 'Aktivera auto-dispatch',
    skipAutoDispatchSuccess: 'Lyckades inaktivera auto-dispatch för {{name}}',
    enableAutoDispatchSuccess: 'Lyckades aktivera {{name}} för auto-dispatch',
    completedRoute: '{{name}} är slutförd',
    routeCreatedMessage: 'Rutt sparades och lades till i ruttlistan',
    createRoute: 'Skapa rutt',
    saveAndCreateRoute: 'Spara och skapa ny rutt',
    routeWasDeleted: 'Rutt borttagen',
    routeWasUpdated: 'Rutt uppdaterad',
    routeWasUpdated_other: 'Rutter uppdaterade',
    routeWasDeleted_other: 'Rutter borttagna',
    sendPrePickupSms: 'Förskicka spårnings‑SMS',
    deleteAllRoutes: 'Ta bort alla rutter',
    routesNotStarted: 'Rutter ej påbörjade',
    noRoutes: 'Inga rutter har skapats ännu',
    viewStopsGrouped: 'Gruppera stopp',
    showCompletedDeliveries: 'Visa slutförda',
    showRemainingDeliveries: 'Visa återstående',
    orders: 'Ordrar',
    onlyUnaccepted: 'endast ej accepterade',
    onlyRoutesWithUnacceptedOrders: 'Visa endast rutter med ej accepterade ordrar',
    activeFilters: 'Aktiva filter',
    clearFilters: 'Rensa filter',
    clearSearch: 'Rensa sökning',
    removeFilter: 'Ta bort filtret {{name}}',
    selectedCount: '{{count}} vald',
    selectedCount_other: '{{count}} valda',
    selectedCount_zero: 'inga valda',
    routeState: 'Ruttstatus',
    routeLabels: 'Ruttetiketter',
    state: 'Status',
    routeNameAZ: 'Ruttnamn A-Ö',
    routeNameZA: 'Ruttnamn Ö-A',
    routeStartedAZ: 'Rutt startad A-Ö',
    routeNotStartedAZ: 'Rutt inte startad A-Ö',
    deletePlannedStopFromSlot: 'Ta bort planerat stopp från slot',
    deleteBreakFromSlot: 'Ta bort paustid från slot',
    plannedStopDeletedFromSlot: 'Planerat stopp togs bort från slot',
    movedOrderToRouteSuccess: 'Order flyttades till rutt {{routeName}}',
    movedOrderToRouteSuccess_other: '{{count}} ordrar flyttades till rutt {{routeName}}',
    moveOrderToRouteQuestion: 'Flytta order till rutt {{routeName}}?',
    moveOrderToRouteQuestion_other: 'Flytta {{count}} ordrar till rutt {{routeName}}?',
    couldNotMoveOrderToRoute: 'Kunde inte flytta order till rutt {{routeName}}',
    failedToOptimizeSlotAfterDeletingPlannedStop:
      'Det gick inte att optimera rutten efter att det planerade stoppet togs bort',
    actionsForAllShipments: 'Åtgärder för alla försändelser',
    removePlannedStopFromRouteAndReoptimize:
      'Det planerade stoppet kommer att tas bort från rutten och rutten kommer automatiskt att optimeras om.',
    unassignShipmentFromRouteAndReoptimize:
      'Försändelsen kommer att tas bort från rutten och rutten kommer automatiskt att optimeras om.',
    unassignShipmentFromRouteAndReoptimize_other:
      'Försändelserna kommer att tas bort från rutten och rutten kommer automatiskt att optimeras om.',
    quickEditDisabledTooltip: 'Du saknar åtkomst till avdelningen för denna order.',
    routeLabel: 'Ruttetikett',
    selectRouteLabel: 'Välj ruttetikett',
    labelFilter: {
      title: 'Filtrera rutter efter etikett',
      description:
        'Denna avdelning har ruttetiketter. Välj en eller flera etiketter för att begränsa vilka rutter som visas.',
      selectLabels: 'Välj etiketter',
      apply: 'Använd filter',
      showAll: 'Visa alla rutter',
      or: 'ELLER',
      and: 'OCH'
    },
    mustSelectVehicle: 'Du måste välja ett fordon'
  },
  reports: {
    serviceTimeWindow: 'Levererad inom servicetidsfönster',
    estimatedTimeWindow: 'Levererad inom estimerad tid',
    correctLocation: 'Levererad på rätt plats',
    withinSTW: 'Inom STW',
    withinETD: 'Inom ETD',
    withinPAW: 'Inom PAW',
    followedRoutes: 'Följda rutter',
    departmentTitle: 'Rapporter för {{name}}',
    serviceWindow: 'Servicefönster',
    estimatedWindow: 'Estimerat fönster',
    quality: 'Kvalitet',
    scrollToStop: 'Scrolla till stopp',
    stopGraphLabel: 'Stoppdata',
    hiddenStopsTooltip: 'Denna graf innehåller dolda stopp. Klicka för att se vilka stopp',
    graphContainsHiddenStops: 'Denna graf innehåller dolda stopp',
    stopWasHiddenDueToDeliveryDateSetTo: 'Stopp {{stopNumber}} doldes eftersom leveransdatum var {{date}}',
    stopWasHiddenDueToDeliveryDateNotSet: 'Stopp {{stopNumber}} doldes eftersom det inte slutfördes',
    productionAccuracy: 'Produktionsfönster',
    productionAccuracyTimeWindow: 'Levererad inom produktionsfönstret',
    actualStop: 'Faktisk stoppordning',
    plannedStop: 'Planerad stoppordning',
    serviceTimeWindowTooltip: '{{number}} stopp levererades inom servicefönstret.',
    estimatedTimeWindowTooltip: '{{number}} stopp levererades inom det uppskattade tidfönstret.',
    correctLocationTooltip: '{{number}} stopp levererades till rätt plats.',
    followedRoutesTooltipStops: '{{number}} stopp genomfördes i rätt ordning.',
    followedRoutesTooltipOrders: '{{number}} ordrar levererades i rätt ordning.',
    productionAccuracyTooltip: '{{number}} stopp som levererades inom produktionsfönstret.'
  },
  settings: {
    profile: 'Profil',
    departmentsSaved: 'Dina avdelningar sparades'
  },
  iamOnboarding: {
    description:
      'Det verkar som att du inte har några avdelningar kopplade till ditt konto ännu. Du kan lägga till de avdelningar du behöver åtkomst till via inställningar i menyn till vänster.',
    goToSettings: 'Gå till Inställningar'
  },
  iamMigrationModal: {
    title: 'Åtgärd krävs: ansök om Glow One Identity-rollen',
    body: 'Som Posten & Bring-anställd behöver du nu rollen nedan för att logga in i Glow. Ansök om denna roll i One Identity.',
    instructions:
      'Gå till <a>{{iamUrl}}</a> och ansök om rollen. När din ansökan har godkänts kan du logga in i Glow med ditt Posten-konto.',
    roleLabel: 'Roll att ansöka om',
    copyRole: 'Kopiera rollnamn',
    copied: 'Kopierat',
    applyForRole: 'Ansök om rollen',
    confirmCheckbox: 'Jag bekräftar att jag har ansökt om rollen F_APP_S55475-GLOW_USR',
    confirm: 'Fortsätt'
  }
}
export default sv
